module controllers {
    export module consigment {
        interface IPurchaseUpdateScope extends ng.IScope { }

        interface IConsignmentUpdateParams extends ng.ui.IStateParamsService {
            conId: number;
            manId: number;
        }

        export class ConsignmentExportUpdateCtrl {
            static $inject = ["$scope", "$rootScope", "generalService", "$q", "$stateParams", "currencyService", "classificationValueService",
                "supplierService", "paymentMethodService", "termsOfPaymentService", "costModelService", "$anchorScroll", "$state", "purchaseOrderSKUService",
                "countryService", "incotermService", "termsOfDeliveryService", "consigneeService", "deliveryInstructionService", "documentRepositoryService", "bsLoadingOverlayService",
                "lookupService", "skuService", "$timeout", "$transitions", "transportModeService", "routeCodeService", "consignmentService", "cargoTypeService", "routeLeadTimesService",
                "$uibModal", "containerISOService", "containerService", "notifyPartyService", "addressService", "unLocationCodeService", "shipperService", "cartageContractorService",
                "warehouseService", "transportTypeService", "typeOfPackageService", "consignmentDetailService", "shippingPriorityService", "isInbound", "menuService",
                "commercialInvoiceService", "consignmentCustomsDetailService", "userAccountService", "goodsDeclarationService",
                "consignmentDocumentService", "consignmentTemplateService", "documentTypeService", "customAttributeService", "customAttributeAnswerOptionService", "permitService","vesselScheduleService","uiGridConstants",  'reportService'
                ,"LiveTrackingService","tariffCountryService","customsProcedureMatrixService",'customsOfficeCodeService','companyService','flowTypeService'
            ];

            public consignmentID: number;
            public consignment: interfaces.consignment.IConsignment;

            poNumber: string;

            selectedTab: number = 0;
            AddEditDescription: string;

            //Transport Mode Type
            //selectedTransportMode: number = 0;
            //transportMode: number;
            transportList: ng.resource.IResourceArray<interfaces.applicationcore.IDropdownModel>;

            //Route Data
            routeId: number = 1;
            routeData: interfaces.master.IRouteCode;
            routeLeadTimesData: interfaces.master.IRouteLeadTimes;
            ShippingPriority: interfaces.applicationcore.IDropdownModel;
            ExportConsignmentCostModel: interfaces.applicationcore.IDropdownModel;
            public consignmentLeadTimesLockDown: interfaces.consignment.IConsignmentLeadTimesLockDown;

            //Cargo Types
            cargoTypeList: Array<interfaces.applicationcore.IDropdownModel>;

            //Document Actions
            actionList: interfaces.applicationcore.IDropdownModel[];

            //Report List
            reportList: interfaces.applicationcore.IDropdownModel[];

            //Documents
            documentRepository: interfaces.documentManagement.IDocumentRepository;

            //Status
            public conStatus: interfaces.master.IStatusData;

            //Transit Point List Grid
            apiTransList: uiGrid.IGridApi;

            //Containers List Grid
            apiContainersList: uiGrid.IGridApi;
            containersList: Array<interfaces.logistics.IContainer>;

            //Customs List Grid
            apiCustomsList: uiGrid.IGridApi;

            //apiGoodsDecList
            apiGoodsDecList: uiGrid.IGridApi;
            apiClearInList: uiGrid.IGridApi;

            //consignment Document Grid
            apiConDocList: uiGrid.IGridApi;

            //Address Details
            address: interfaces.applicationcore.IAddress;

            loadPromises: ng.IPromise<any>[];

            allowGenerateReqDocs: boolean;
            allowViewCustoms: boolean = true;
            allowViewRefundClaims: boolean = false;
            hasViewRefundClaimRights: boolean = false;
            hasGenerateRemoveClearInRight: boolean = false;
            hasAddRemoveManualGoodsDecRight: boolean = false;
            hasGenerateAndRemoveGoodsDeclarationRight: boolean = false;
            hasMultipleGenerateRights : boolean = false;
            hasOverrideResponsibleUserRight: boolean = false;   
            hasOverrideConsignmentNumberRight: boolean = false; 

            allowCreateNewVersion: boolean;

            paginationOptions = {
                pageNumber: 1,
                pageSize: 25
            };

            paginationPROptions = {
                pageNumber: 1,
                pageSize: 25
            };

            editingPacking: boolean = false;
            isLoadingDetail: boolean = false;
            getAll: boolean = false;
            getAllClearIn: boolean = false;

            showOnlyProhibited: boolean = false;
            showAll: boolean = false;

            apiPRList: uiGrid.IGridApi;

            apiCIList: uiGrid.IGridApi;
            selectedCI: uiGrid.IGridRow;

            routeLeadTimes: interfaces.master.IRouteLeadTimes;

            functionType: number = 384;
            reason: string = "";

            consignmentTemplates: interfaces.applicationcore.IDropdownModel[];
            documentTypes: ng.resource.IResourceArray<interfaces.applicationcore.IDropdownModel>;

            breadCrumbDesc: string;

            consignmentHook: any;
            manifestHook: any;

            //Attribute Grid
            apiCA: uiGrid.IGridApi;
            attributeList: interfaces.applicationcore.IDropdownModel[] = [];
            attributeAnswerOptionList: interfaces.applicationcore.IDropdownModel[] = [];

            originalShipperId? : number;
            originalConigneeId?: number;
            originalNotifyPartyId?: number;

            consignmentTypeDefaults: interfaces.consignment.ConsignmentTypeDefaults = null;

            constructor(private $scope: IPurchaseUpdateScope,
                private $rootScope: interfaces.applicationcore.IRootScope,
                private generalService: interfaces.applicationcore.IGeneralService,
                private $q: ng.IQService, private $stateParams: IConsignmentUpdateParams,
                private currencyService: interfaces.applicationcore.ICurrencyService,
                private classificationValueService: interfaces.applicationcore.IClassificationValueService,
                private supplierService: interfaces.master.ISupplierService,
                private paymentMethodService: interfaces.master.IPaymentMethodService,
                private termsOfPaymentService: interfaces.master.ITermsOfPaymentService,
                private costModelService: interfaces.costing.ICostModelService,
                private $anchorScroll: ng.IAnchorScrollService,
                private $state: ng.ui.IStateService,
                private purchaseOrderSKUService: interfaces.purchase.IPurchaseOrderSKUService,
                public countryService: interfaces.applicationcore.ICountryService,
                public incotermService: interfaces.applicationcore.IIncotermService,
                public termsOfDeliveryService: interfaces.master.ITermsOfDeliveryService,
                public consigneeService: interfaces.master.IConsigneeService,
                public deliveryInstructionService: interfaces.purchase.IDeliveryInstructionService,
                public documentRepositoryService: interfaces.documentManagement.IDocumentRepositoryService,
                public bsLoadingOverlayService,
                private lookupService: interfaces.applicationcore.ILookupService,
                public skuService: interfaces.master.ISKUService, public $timeout: ng.ITimeoutService,
                public $transitions: ng.ui.core.ITransition,
                public transportModeService: interfaces.applicationcore.ITransportModeService,
                public routeCodeService: interfaces.master.IRouteCodeService,
                public consignmentService: interfaces.consignment.IConsignmentService,
                public cargoTypeService: interfaces.master.ICargoTypeService,
                public routeLeadTimesService: interfaces.master.IRouteLeadTimesService,
                private $uibModal: ng.ui.bootstrap.IModalService,
                public containerISOService: interfaces.applicationcore.IContainerISOService,
                public containerService: interfaces.logistics.IContainerService,
                public notifyPartyService: interfaces.master.INotifyPartyService,
                public addressService: interfaces.applicationcore.IAddressService,
                public unLocationCodeService: interfaces.applicationcore.IUNLocationCodeService,
                public shipperService: interfaces.master.IShipperService,
                public cartageContractorService: interfaces.master.ICartageContractorService,
                public warehouseService: interfaces.master.IWarehouseService,
                public transportTypeService: interfaces.master.ITransportTypeService,
                public typeOfPackageService: interfaces.master.ITypeOfPackageService,
                private consignmentDetailService: interfaces.consignment.IConsignmentDetailService,
                public shippingPriorityService: interfaces.master.IShippingPriorityService,
                public isInbound: boolean,
                private menuService: interfaces.applicationcore.IMenuService,
                private commercialInvoiceService: interfaces.logistics.ICommercialInvoiceService,
                private consignmentCustomsDetailService: interfaces.logistics.IConsignmentCustomsDetailService,
                private userAccountService: interfaces.applicationcore.IUserAccountService,
                private goodsDeclarationService: interfaces.customs.IGoodsDeclarationService,
                public consignmentDocumentService: interfaces.logistics.IConsignmentDocumentService,
                private consignmentTemplateService: interfaces.compliance.IConsignmentTemplateService,
                private documentTypeService: interfaces.documentManagement.IDocumentTypeService,
                public customAttributeService: services.master.customAttributeService,
                public customAttributeAnswerOptionService: services.master.customAttributeAnswerOptionService,
                private permitService: interfaces.master.IPermitService,
                private vesselScheduleService: interfaces.logistics.IVesselScheduleService,
                private uiGridConstants: uiGrid.IUiGridConstants,
                private reportService: interfaces.reporting.IReportService,
                private liveTrackingService: interfaces.logistics.ILiveTrackingService,
                private tariffCountryService: interfaces.tariff.ITariffCountryService,
                private customsProcedureMatrixService: interfaces.tariff.ICustomsProcedureMatrixService,
                private customsOfficeCodeService: interfaces.tariff.ICustomsOfficeCodeService,
                private companyService: interfaces.master.ICompanyService,
                private flowTypeService: interfaces.customs.IFlowTypeService,
            ) {
                if ($stateParams.conId === null) {
                    return;
                }

                this.consignmentHook = $transitions.onSuccess({
                    to: 'auth.ConsignmentExports.Update',
                    from: 'auth.ConsignmentExports.Update.**'
                }, () => {
                    this.bsLoadingOverlayService.wrap({
                        referenceId: 'con.update'
                    }, () => {
                        return this.loadConsignment();
                    });
                });

                this.consignmentHook = $transitions.onSuccess({
                    to: 'auth.ConsignmentImports.Update',
                    from: 'auth.ConsignmentImports.Update.**'
                }, () => {
                    this.bsLoadingOverlayService.wrap({
                        referenceId: 'con.update'
                    }, () => {
                        return this.loadConsignment();
                    });
                });

                this.manifestHook = $transitions.onSuccess({
                    to: 'auth.Manifests.Update.ConsignmentExport',
                    from: 'auth.Manifests.Update.ConsignmentExport.**'
                }, () => {
                    this.bsLoadingOverlayService.wrap({
                        referenceId: 'con.update'
                    }, () => {
                        return this.loadConsignment();
                    });
                });

                this.manifestHook = $transitions.onSuccess({
                    to: 'auth.Manifests.Update.ConsignmentImport',
                    from: 'auth.Manifests.Update.ConsignmentImport.**'
                }, () => {
                    this.bsLoadingOverlayService.wrap({
                        referenceId: 'con.update'
                    }, () => {
                        return this.loadConsignment();
                    });
                });

                $scope.$on('$destroy', () => {
                    $transitions.onStart({}, this.consignmentHook);
                    $transitions.onStart({}, this.manifestHook);
                });

                //Get the ID to get the Consignments Details.
                this.consignmentID = $stateParams.conId;

                this.bsLoadingOverlayService.wrap({
                    referenceId: 'con.update'
                }, () => {
                    return this.loadConsignment();
                });
            }

            loadConsignment() {
                if (this.consignment) {
                    this.consignment.CostInvoiceList = undefined;
                    this.consignment.ContainersList = undefined;
                    this.consignment.ConsignmentGoodsDeclarationList = undefined;
                    this.consignment.ConsignmentClearingInstructionList = undefined;
                    this.consignment.ConsignmentCustomsDetailList = undefined;
                    this.consignment.ConsignmentDetailList = undefined;
                    this.consignment.ConsignmentPRList = undefined;
                }
                return this.consignmentService.GetConsignment(this.consignmentID).get((result: interfaces.consignment.IConsignment) => {
                    this.consignment = result;

                    if (this.$stateParams.manId) {
                        if (this.consignment.IsInbound) {
                            this.breadCrumbDesc = "Consignment Import: " + this.consignment.WaybillNumber;
                        } else {
                            this.breadCrumbDesc = "Consignment Export: " + this.consignment.WaybillNumber;
                        }
                    } else {
                        this.breadCrumbDesc = this.consignment.WaybillNumber;
                    }

                    this.originalShipperId = this.consignment.Shipper? this.consignment.Shipper.Id : null;
                    this.originalConigneeId = this.consignment.Consignee? this.consignment.Consignee.Id : null;
                    this.originalNotifyPartyId = this.consignment.NotifyParty? this.consignment.NotifyParty.Id : null;

                    this.estimateLoadingDateChanged(null);
                    this.loadConsignmentLeadTimesLockDown();

                    this.isLoadingDetail = true;

                    this.$timeout(() => {
                        this.loadControls();

                        this.gvwCOD.data = this.consignment.ConsignmentDetailList;
                        this.gCIList.data = this.consignment.ConsignmentCommercialInvoiceList;

                        if (this.consignment.ConsignmentCommercialInvoiceList.length > 0) {
                            this.AddEditDescription = "Refresh Commercial Invoice";
                        } else {
                            this.AddEditDescription = "Add Commercial Invoice";
                        }

                        this.gvwContainers.data = this.consignment.ContainersList;
                        this.gvwCustoms.data = this.consignment.ConsignmentCustomsDetailList;
                        this.gvwGoodsDec.data = this.consignment.ConsignmentGoodsDeclarationList;
                        this.gvwDocMatrix.data = this.consignment.ConsignmentDocumentList;
                        this.gvwPRList.data = this.consignment.ConsignmentPRList;
                        this.gvwConsignmentAttribute.data = result.ConsignmentAttributeList;

                        //Setting the total item number
                        this.gvwContainers.totalItems = this.consignment.ContainersList.length;
                        this.gvwCustoms.totalItems = this.consignment.ConsignmentCustomsDetailList.length;
                        this.gvwGoodsDec.totalItems = this.consignment.ConsignmentGoodsDeclarationList.length;
                        //this.gvwClearIn.totalItems = this.consignment.ConsignmentClearingInstructionList.length;
                        this.gvwDocMatrix.totalItems = this.consignment.ConsignmentDocumentList.length;
                        this.gvwPRList.totalItems = this.consignment.ConsignmentPRList.length;
                        this.gvwCOD.totalItems = this.consignment.ConsignmentDetailList.length;
                        this.gCIList.totalItems = this.consignment.ConsignmentCommercialInvoiceList.length;

                        this.isLoadingDetail = false;
                    });

                }, (errorResponse) => {
                    this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                }).$promise;
            }

            loadConsignmentLeadTimesLockDown() {
                if (this.consignment) {
                    var ConsignmentLeadTimesLockDown: interfaces.consignment.IConsignmentLeadTimesLockDown = {
                        EstimatedClearingDate: false,
                        EstimatedDateOfLoading: false,
                        ActualLoadingDate: false,
                        ShipByDate: false,
                        EstimateDateOfArrival: false,
                        EstimateArrivalAtDestuff: false,
                        EstimateDateAtStore: false,
                        ActualClearingDate: false,
                        DateLoading: false,
                        ShippedOnBoardDate: false,
                        ActualTimeOfArrival: false,
                        ActualDateAtDestuff: false,
                        ActualDateAtStore: false,
                        OriginalEstimatedTimeOfDelivery: false,
                        FromStackDate: false,
                        ToStackDate: false,
                        ProvisionalDateAtDestuff: false,
                        EstimatedDestinationClearanceDate: false,
                        ActualDestinationClearanceDate: false
                    }

                    this.consignmentLeadTimesLockDown = ConsignmentLeadTimesLockDown;

                    // Open/Partial/Authorised Lockdown
                    if (this.consignment.LockdownType <= 2) {
                        this.consignmentLeadTimesLockDown.EstimatedClearingDate = false;
                        this.consignmentLeadTimesLockDown.EstimatedDateOfLoading = false;
                        this.consignmentLeadTimesLockDown.ActualLoadingDate = false;
                        this.consignmentLeadTimesLockDown.ShipByDate = false;
                        this.consignmentLeadTimesLockDown.EstimateDateOfArrival = false;
                        this.consignmentLeadTimesLockDown.EstimateArrivalAtDestuff = false;
                        this.consignmentLeadTimesLockDown.EstimateDateAtStore = false;
                        this.consignmentLeadTimesLockDown.ActualClearingDate = false;
                        this.consignmentLeadTimesLockDown.DateLoading = false;
                        this.consignmentLeadTimesLockDown.ShippedOnBoardDate = false;
                        this.consignmentLeadTimesLockDown.ActualTimeOfArrival = false;
                        this.consignmentLeadTimesLockDown.ActualDateAtDestuff = false;
                        this.consignmentLeadTimesLockDown.ActualDateAtStore = false;
                        this.consignmentLeadTimesLockDown.OriginalEstimatedTimeOfDelivery = true;
                        this.consignmentLeadTimesLockDown.FromStackDate = false;
                        this.consignmentLeadTimesLockDown.ToStackDate = false;
                        this.consignmentLeadTimesLockDown.ProvisionalDateAtDestuff = false;
                        this.consignmentLeadTimesLockDown.EstimatedDestinationClearanceDate = false;
                        this.consignmentLeadTimesLockDown.ActualDestinationClearanceDate = false;
                    }

                    // Finalised
                    if (this.consignment.LockdownType === 3) {
                        this.consignmentLeadTimesLockDown.EstimatedClearingDate = true;
                        this.consignmentLeadTimesLockDown.EstimatedDateOfLoading = true;
                        this.consignmentLeadTimesLockDown.ActualLoadingDate = true;
                        this.consignmentLeadTimesLockDown.ShipByDate = true;
                        this.consignmentLeadTimesLockDown.EstimateDateOfArrival = true;
                        this.consignmentLeadTimesLockDown.EstimateArrivalAtDestuff = true;
                        this.consignmentLeadTimesLockDown.EstimateDateAtStore = true;
                        this.consignmentLeadTimesLockDown.ActualClearingDate = true;
                        this.consignmentLeadTimesLockDown.DateLoading = true;
                        this.consignmentLeadTimesLockDown.ShippedOnBoardDate = false; //export only 
                        this.consignmentLeadTimesLockDown.ActualTimeOfArrival = false; //export only
                        this.consignmentLeadTimesLockDown.ActualDateAtDestuff = false; //export only
                        this.consignmentLeadTimesLockDown.ActualDateAtStore = false; //export only
                        this.consignmentLeadTimesLockDown.OriginalEstimatedTimeOfDelivery = true;
                        this.consignmentLeadTimesLockDown.FromStackDate = true;
                        this.consignmentLeadTimesLockDown.ToStackDate = true;
                        this.consignmentLeadTimesLockDown.ProvisionalDateAtDestuff = true;
                        this.consignmentLeadTimesLockDown.EstimatedDestinationClearanceDate = true;
                        this.consignmentLeadTimesLockDown.ActualDestinationClearanceDate = true;
                    }

                    //Cancelled  / Full
                    if (this.consignment.LockdownType >= 4) {
                        this.consignmentLeadTimesLockDown.EstimatedClearingDate = true;
                        this.consignmentLeadTimesLockDown.EstimatedDateOfLoading = true;
                        this.consignmentLeadTimesLockDown.ActualLoadingDate = true;
                        this.consignmentLeadTimesLockDown.ShipByDate = true;
                        this.consignmentLeadTimesLockDown.EstimateDateOfArrival = true;
                        this.consignmentLeadTimesLockDown.EstimateArrivalAtDestuff = true;
                        this.consignmentLeadTimesLockDown.EstimateDateAtStore = true;
                        this.consignmentLeadTimesLockDown.ActualClearingDate = true;
                        this.consignmentLeadTimesLockDown.DateLoading = true;
                        this.consignmentLeadTimesLockDown.ShippedOnBoardDate = true;
                        this.consignmentLeadTimesLockDown.ActualTimeOfArrival = true;
                        this.consignmentLeadTimesLockDown.ActualDateAtDestuff = true;
                        this.consignmentLeadTimesLockDown.ActualDateAtStore = true;
                        this.consignmentLeadTimesLockDown.OriginalEstimatedTimeOfDelivery = true;
                        this.consignmentLeadTimesLockDown.FromStackDate = true;
                        this.consignmentLeadTimesLockDown.ToStackDate = true;
                        this.consignmentLeadTimesLockDown.ProvisionalDateAtDestuff = true;
                        this.consignmentLeadTimesLockDown.EstimatedDestinationClearanceDate = true;
                        this.consignmentLeadTimesLockDown.ActualDestinationClearanceDate = true;
                    }

                    //Route has Lead times
                    if (this.routeLeadTimes) {
                        if (this.routeLeadTimes.Id > 0) {
                            this.consignmentLeadTimesLockDown.EstimatedClearingDate = true;
                            //this.consignmentLeadTimesLockDown.EstimatedDateOfLoading = true;
                            this.consignmentLeadTimesLockDown.ShipByDate = true;
                            this.consignmentLeadTimesLockDown.EstimateDateOfArrival = true;
                            this.consignmentLeadTimesLockDown.EstimateArrivalAtDestuff = true;
                            this.consignmentLeadTimesLockDown.EstimateDateAtStore = true;
                        }
                    }

                    // Consignment is linked to Manifest?
                    if (this.consignment.IsLinkedToManifest) {
                        this.consignmentLeadTimesLockDown.EstimatedClearingDate = true;
                        this.consignmentLeadTimesLockDown.EstimatedDateOfLoading = true;
                        this.consignmentLeadTimesLockDown.ShipByDate = true;
                        this.consignmentLeadTimesLockDown.EstimateDateOfArrival = true;
                        this.consignmentLeadTimesLockDown.EstimateArrivalAtDestuff = true;
                        this.consignmentLeadTimesLockDown.ActualClearingDate = true;
                        this.consignmentLeadTimesLockDown.DateLoading = true;
                        this.consignmentLeadTimesLockDown.ShippedOnBoardDate = true;
                        this.consignmentLeadTimesLockDown.ActualTimeOfArrival = true;
                        this.consignmentLeadTimesLockDown.ActualDateAtDestuff = true;
                        this.consignmentLeadTimesLockDown.FromStackDate = true;
                        this.consignmentLeadTimesLockDown.ToStackDate = true;
                        this.consignmentLeadTimesLockDown.ActualLoadingDate = true;
                    }
                }
            }

            loadControls() {
                var promises = [];

                this.editingPacking = false;

                promises.push(this.loadCargoTypes());
                promises.push(this.getDocuments(this.showAll));
                promises.push(this.loadStatus());
                promises.push(this.getAllowGenerateReqDocsRight());
                promises.push(this.loadComplianceTemplates());
                promises.push(this.loadConsignmentLeadTimesLockDown());

                if (this.consignment) {
                    if (this.consignment.IsInbound) {
                        promises.push(this.getAllowCreateNewVersionImportRight());
                        promises.push(this.getHasGenerateRemoveClearInRight());
                      
                    }
                    else {
                        promises.push(this.getAllowCreateNewVersionExportRight());
                       
                    }
                }

                promises.push(this.getAllowViewRefundClaimRight());
                
                promises.push(this.getHasAddRemoveGoodsDecRight());

                promises.push(this.getHasGenerateAndRemoveGoodsDeclarationRight());

                promises.push(this.loadConsignmentTypeDefaults());

                if (this.isInbound){
                    promises.push(this.getImportConsignmentResponsibleUserOverrideRight());
                    promises.push(this.getConsignmentNumberOverrideRight(714));
                }
                else{
                    promises.push(this.getExportConsignmentResponsibleUserOverrideRight());
                    promises.push(this.getConsignmentNumberOverrideRight(715));
                }

                this.bsLoadingOverlayService.wrap({
                    referenceId: 'con.update'
                }, () => {
                    return this.$q.all(promises).then(()=>{
                        //All the Rights have loaded, lets check if the User has multuiple 'Generate' Rights to enable the Action button or the individual buttons

                        const trueCount = [
                            this.hasAddRemoveManualGoodsDecRight,
                            this.hasGenerateAndRemoveGoodsDeclarationRight,
                          ].filter((value) => value === true).length;                          
                          this.hasMultipleGenerateRights = trueCount > 1;

                    });
                });
            }

            loadConsignmentTypeDefaults() {
                return this.consignmentService.GetConsignmentTypeDefaultsByConsignment(this.consignment.Id).get((result: interfaces.consignment.ConsignmentTypeDefaults) => {
                    this.consignmentTypeDefaults = result;                 
                    
                }, (failureData) => {
                    this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                }).$promise; 
            }

            loadComplianceTemplates() {
                return this.consignmentTemplateService.getForConsignmentDropdown(this.consignment.Id).query((result: interfaces.applicationcore.IDropdownModel[]) => {
                    this.consignmentTemplates = result;
                }, (failureData) => {
                    this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                }).$promise;
            }

            openConsignmentTemplate(templateId: number) {
                this.bsLoadingOverlayService.wrap({
                    referenceId: 'con.update'
                }, () => {

                        if (this.$stateParams.manId) {
                            if (this.isInbound) {
                                this.$state.go("auth.Manifests.Update.ConsignmentImport.Compliance", { transactionId: templateId  });
                            } else {
                                this.$state.go("auth.Manifests.Update.ConsignmentExport.Compliance", { transactionId: templateId });
                            }
                        } else {
                            if (this.consignment.IsInbound)
                                this.$state.go("auth.ConsignmentImports.Update.Compliance", { transactionId: templateId });
                            else
                                this.$state.go("auth.ConsignmentExports.Update.Compliance", { transactionId: templateId });
                        }

                });
            }

            loadUsers(searchText: string) {
                if (this.consignment) {
                    return this.userAccountService.getDropdownList(searchText, this.consignment.OwnerEntityId).query(
                        (result: ng.resource.IResourceArray<interfaces.applicationcore.IDropdownModel>) => {
                        }, (failureData) => {
                            this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                        }).$promise;
                } else {
                    var defer = this.$q.defer();
                    defer.resolve([]);
                    return defer.promise;
                }
            }

            loadRouteCodes() {
                if (this.consignment) {
                    return this.routeCodeService.getDropdownListAll(this.consignment.OwnerEntityId, this.consignment.IsInbound).query({},
                        (result: ng.resource.IResourceArray<interfaces.applicationcore.IDropdownModel>) => {
                        }, (failureData) => {
                            this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                        }).$promise;
                } else {
                    var defer = this.$q.defer();
                    defer.resolve([]);
                    return defer.promise;
                }
            }

            loadTerminals(searchText: string){
                var countryId : number;
                if (this.consignment.IsInbound)
                    countryId = this.consignment.UnloadingCountry.Id;
                else
                    countryId = this.consignment.LoadingCountry.Id;

                return this.vesselScheduleService.GetTerminalsForDropDownByCountry(countryId,searchText).query({
                },
                    (result: ng.resource.IResourceArray<interfaces.applicationcore.IDropdownModel>) => {
                       
                    }, (failureData) => {
                        this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                    }).$promise;
            }

            loadExportConsignmentCostModels() {
                var defer = this.$q.defer();

                if (this.consignment) {
                    this.costModelService.getDropdownList().query({ ownerEntityId: this.consignment.OwnerEntityId, typeId: 600 }, (resultList) => {
                        defer.resolve(resultList);
                    }, (errorResponse) => {
                        this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                        defer.resolve([]);
                    });

                } else {
                    defer.resolve([]);
                }

                return defer.promise;
            }

            routeCodeChanged(model: interfaces.applicationcore.IDropdownModel) {
                if (this.consignment && model) {
                    return this.routeCodeService.getRouteData().query({
                        routeId: model.Id,
                    },
                        (result: interfaces.master.IRouteCode) => {
                            //Load the data.
                            if (result.LoadingCountry) {
                                this.consignment.LoadingCountry = result.LoadingCountry;
                            }

                            if (result.LoadingLocation) {
                                this.consignment.LoadingLocation = result.LoadingLocation;
                            }

                            if (result.DispatchWarehouse) {
                                this.consignment.DispatchWarehouse = result.DispatchWarehouse;
                            }

                            if (result.DestinationCountry) {
                                this.consignment.UnloadingCountry = result.DestinationCountry;
                            }

                            if (result.UnloadingLocation) {
                                this.consignment.UnloadingLocation = result.UnloadingLocation;
                            }

                            if (result.ReceiptWarehouse) {
                                this.consignment.ReceiptWarehouse = result.ReceiptWarehouse;
                            }

                            if (result.TransportMode) {
                                this.consignment.TransportMode = result.TransportMode;
                            }

                            if (result.MasterCartageContractor) {
                                this.consignment.MasterCartageContractor = result.MasterCartageContractor;
                            }

                            if (result.CartageContractor) {
                                this.consignment.CartageContractor = result.CartageContractor;
                            }

                            if (result.Terminal){
                                this.consignment.Terminal = result.Terminal;
                            }

                            this.consignment.IsInbound = result.IsInbound;

                            this.consignment.TrackToStore = result.TrackToStore;

                            if (result.CargoType){
                                this.consignment.CargoTypeId = result.CargoType.Id;
                            }

                            this.estimateLoadingDateChanged(this.consignment.EstimateLoadingDate);
                        }, (failureData) => {
                            this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                        }).$promise;
                } else {
                    var defer = this.$q.defer();
                    defer.resolve([]);
                    return defer.promise;
                }
            }

            loadTransportModes() {
                return this.transportModeService.getDropdownList().query({},
                    (result: ng.resource.IResourceArray<interfaces.applicationcore.IDropdownModel>) => {
                        this.transportList = result;
                    }, (failureData) => {
                        this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                    }).$promise;
            }

            loadLoadingLocation(searchText: string) {
                if (this.consignment && this.consignment.LoadingCountry) {
                    return this.unLocationCodeService.getDropdownList().query({
                        countryId: this.consignment.LoadingCountry.Id,
                        searchText: searchText
                    },
                        (result: ng.resource.IResourceArray<interfaces.applicationcore.IDropdownModel>) => {
                        }, (failureData) => {
                            this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                        }).$promise;
                } else {
                    var defer = this.$q.defer();
                    defer.resolve([]);
                    return defer.promise;
                }
            }

            //Loading Unloading Location
            loadUnloadingLocation(searchText: string) {
                if (this.consignment && this.consignment.UnloadingCountry) {
                    return this.unLocationCodeService.getDropdownList().query({
                        countryId: this.consignment.UnloadingCountry.Id,
                        searchText: searchText
                    },
                        (result: ng.resource.IResourceArray<interfaces.applicationcore.IDropdownModel>) => {
                        }, (failureData) => {
                            this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                        }).$promise;
                } else {
                    var defer = this.$q.defer();
                    defer.resolve([]);
                    return defer.promise;
                }
            }

            //Loading Shipper
            loadShipper(searchText: string) {
                if (this.consignment) {
                    return this.shipperService.getShipperDropdown(this.consignment.OwnerEntityId, searchText).query({
                    },
                        (result: ng.resource.IResourceArray<interfaces.applicationcore.IDropdownModel>) => {
                        }, (failureData) => {
                            this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                        }).$promise;
                } else {
                    var defer = this.$q.defer();
                    defer.resolve([]);
                    return defer.promise;
                }
            }

            //Loading Master Contractor
            loadMasterContractor() {
                if (this.consignment) {
                    return this.cartageContractorService.getDropdownList().query({
                        ownerEntityId: this.consignment.OwnerEntityId
                    },
                        (result: ng.resource.IResourceArray<interfaces.applicationcore.IDropdownModel>) => {
                        }, (failureData) => {
                            this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                        }).$promise;
                } else {
                    var defer = this.$q.defer();
                    defer.resolve([]);
                    return defer.promise;
                }

            }

            //Loading Cartage Contractor
            loadCartageContractor() {
                if (this.consignment) {
                    return this.cartageContractorService.getDropdownList().query({
                        ownerEntityId: this.consignment.OwnerEntityId
                    },
                        (result: ng.resource.IResourceArray<interfaces.applicationcore.IDropdownModel>) => {
                        }, (failureData) => {
                            this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                        }).$promise;
                } else {
                    var defer = this.$q.defer();
                    defer.resolve([]);
                    return defer.promise;
                }
            }

            //Loading Sub Cartage Contractor
            loadSubCartageContractor() {
                if (this.consignment) {
                    return this.cartageContractorService.getDropdownList().query({
                        ownerEntityId: this.consignment.OwnerEntityId
                    },
                        (result: ng.resource.IResourceArray<interfaces.applicationcore.IDropdownModel>) => {
                        }, (failureData) => {
                            this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                        }).$promise;
                } else {
                    var defer = this.$q.defer();
                    defer.resolve([]);
                    return defer.promise;
                }
            }

            //Loading Dispatch Warehouse
            loadDispatchWarehouse() {
                if (this.consignment && this.consignment.LoadingCountry) {
                    return this.warehouseService.getDropdownList().query({
                        ownerEntityId: this.consignment.OwnerEntityId,
                        CountryId: this.consignment.LoadingCountry.Id
                    },
                        (result: ng.resource.IResourceArray<interfaces.applicationcore.IDropdownModel>) => {
                        }, (failureData) => {
                            this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                        }).$promise;
                } else {
                    var defer = this.$q.defer();
                    defer.resolve([]);
                    return defer.promise;
                }
            }

            //Loading Receipt Warehouse
            loadReceiptWarehouse() {
                if (this.consignment && this.consignment.UnloadingCountry) {
                    return this.warehouseService.getDropdownList().query({
                        ownerEntityId: this.consignment.OwnerEntityId,
                        CountryId: this.consignment.UnloadingCountry.Id
                    },
                        (result: ng.resource.IResourceArray<interfaces.applicationcore.IDropdownModel>) => {
                        }, (failureData) => {
                            this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                        }).$promise;
                } else {
                    var defer = this.$q.defer();
                    defer.resolve([]);
                    return defer.promise;
                }
            }

            //Loading Loading Country
            loadLoadingCountry() {
                return this.countryService.getDropdownList().query({
                },
                    (result: ng.resource.IResourceArray<interfaces.applicationcore.IDropdownModel>) => {
                    }, (failureData) => {
                        this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                    }).$promise;
            }

            //When changed the Dispatch Warehouse needs to reload.
            loadingCountryChanged() {
                this.consignment.DispatchWarehouse = null;
            }

            //When changed the Dispatch Warehouse needs to reload.
            unloadingCountryChanged() {
                this.consignment.ReceiptWarehouse = null;
            }

            //Loading Unoading Country
            loadUnloadingCountry() {
                return this.countryService.getDropdownList().query({
                },
                    (result: ng.resource.IResourceArray<interfaces.applicationcore.IDropdownModel>) => {
                    }, (failureData) => {
                        this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                    }).$promise;
            }

            //Loading HouseWaybill Issued Location
            loadHouseWaybillIssuedLocation(searchText: string) {
                if (this.consignment && this.consignment.UnloadingCountry) {
                    return this.unLocationCodeService.getDropdownListAllCountries().query({
                        searchText: searchText
                    },
                        (result: ng.resource.IResourceArray<interfaces.applicationcore.IDropdownModel>) => {
                        }, (failureData) => {
                            this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                        }).$promise
                } else {
                    var defer = this.$q.defer();
                    defer.resolve([]);
                    return defer.promise;
                };
            }

            //Loading Transport Document Issued Location
            loadTransportDocumentIssuedLocation(searchText: string) {
                if (this.consignment && this.consignment.LoadingCountry) {
                    return this.unLocationCodeService.getDropdownListAllCountries().query({
                        searchText: searchText
                    },
                        (result: ng.resource.IResourceArray<interfaces.applicationcore.IDropdownModel>) => {
                        }, (failureData) => {
                            this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                        }).$promise;
                } else {
                    var defer = this.$q.defer();
                    defer.resolve([]);
                    return defer.promise;
                }
            }

            //Loading Transport Type
            loadTransportType(searchText: string) {
                if (this.consignment) {
                    return this.transportTypeService.getDropdownList(this.consignment.OwnerEntityId, searchText).query({
                    },
                        (result: ng.resource.IResourceArray<interfaces.applicationcore.IDropdownModel>) => {
                        }, (failureData) => {
                            this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                        }).$promise;
                } else {
                    var defer = this.$q.defer();
                    defer.resolve([]);
                    return defer.promise;
                }
            }

            //Loading Inland Transport Mode
            loadInlandTransportMode() {
                return this.transportModeService.getDropdownList().query({},
                    (result: ng.resource.IResourceArray<interfaces.applicationcore.IDropdownModel>) => {
                        this.transportList = result;
                    }, (failureData) => {
                        this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                    }).$promise;
            }

            //Loading Sea Inland Contractor
            loadSeaInlandCartageContractor() {
                if (this.consignment) {
                    return this.cartageContractorService.getDropdownList().query({
                        ownerEntityId: this.consignment.OwnerEntityId
                    },
                        (result: ng.resource.IResourceArray<interfaces.applicationcore.IDropdownModel>) => {
                        }, (failureData) => {
                            this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                        }).$promise;
                } else {
                    var defer = this.$q.defer();
                    defer.resolve([]);
                    return defer.promise;
                }
            }

            //Loading Air Inland Contractor
            loadAirInlandCartageContractor() {
                if (this.consignment) {
                    return this.cartageContractorService.getDropdownList().query({
                        ownerEntityId: this.consignment.OwnerEntityId
                    },
                        (result: ng.resource.IResourceArray<interfaces.applicationcore.IDropdownModel>) => {
                        }, (failureData) => {
                            this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                        }).$promise;
                } else {
                    var defer = this.$q.defer();
                    defer.resolve([]);
                    return defer.promise;
                }
            }

            //Loading Route Data
            loadRouteData() {
                return this.routeCodeService.getRouteData().query(
                    {
                        routeId: this.routeId
                    },
                    (result: interfaces.master.IRouteCode) => {
                        //Set all the values from the data collected to the dropdowns.
                        this.routeData = result;
                    },
                    (failureData) => {
                        this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                    }).$promise;
            }

            //Loading Cargo Types
            loadCargoTypes() {
                return this.cargoTypeService.GetList().query(
                    {
                    }, (result: Array<interfaces.applicationcore.IDropdownModel>) => {
                        this.cargoTypeList = result;
                    }, (failureData) => {
                        this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                    }).$promise;
            }

            //Load Route Lead Times
            loadRouteLeadTimes() {
                return this.routeLeadTimesService.getByRoute().query(
                    {
                        routeId: this.routeId,
                        shippingPriorityId: this.consignment.ShippingPriority ? this.consignment.ShippingPriority.Id : 0
                    }, (routeLeadTimesData: interfaces.master.IRouteLeadTimes) => {
                        //Get the data back.
                        this.routeLeadTimesData = routeLeadTimesData;
                    }, (failureData) => {
                        this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                    }).$promise;
            }

            //Documents
            getDocuments(showAll:boolean) {
                return this.documentRepositoryService.getDocumentRepository().query({ 
                                    referenceNumber: this.consignment.WaybillNumber, 
                                    systemType: this.isInbound? Enum.EnumSystemType.ImportConsignment:Enum.EnumSystemType.Consignment, 
                                    ownerEntityId: this.consignment.OwnerEntityId,
                                    showAll:showAll
                                }, (documentRepository: interfaces.documentManagement.IDocumentRepository) => {
                    this.documentRepository = documentRepository;
           
                    if (this.documentRepository)
                        this.loadDocumentTypes();
           
                }, (errorResponse) => {
                    this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                }).$promise;
            }
           
            refreshDocuments(showAll:boolean) {
                this.showAll = showAll;
                this.documentRepository = null;
                return this.getDocuments(showAll);
            }

            printDocuments() {
                if (this.$stateParams.manId) {
                    if (this.isInbound) {
                        this.$state.go("auth.Manifests.Update.ConsignmentImport.Documents");
                    } else {
                        this.$state.go("auth.Manifests.Update.ConsignmentExport.Documents");
                    }
                } else {
                    if (this.isInbound) {
                        this.$state.go("auth.ConsignmentImports.Update.Documents");
                    } else {
                        this.$state.go("auth.ConsignmentExports.Update.Documents");
                    }
                }
            }

            //Status
            loadStatus() {               
                this.conStatus = {
                    StatusName: this.consignment.StatusName,
                    Id: this.consignment.Id,
                    EntityId: this.consignment.OwnerEntityId,
                    CurrentStatusId: this.consignment.StatusId,
                    CurrentStatusComments: this.consignment.StatusLastComments,
                    CurrentStatusStampDate: this.consignment.StatusLastUpdateStampDate,
                    CurrentStatusStampFullName: this.consignment.StatusLastUpdateStampFullName,
                    CurrentStatusType: this.isInbound ? Enum.EnumStatusType.ConsignmentImport : Enum.EnumStatusType.ConsignmentExport,
                    EnumStatusType: this.isInbound ? Enum.EnumStatusType.ConsignmentImport : Enum.EnumStatusType.ConsignmentExport,
                    EnumStatusAuthorisationType: this.isInbound ? Enum.EnumStatusAuthorisationType.ConsignmentImport : Enum.EnumStatusAuthorisationType.ConsignmentExport,
                    IsEditable: true,
                    Comments: ''
                };
            }

            updateStatus = (newStatusId: number, comments: string) => {
                var paramsObject: interfaces.master.IStatusChange = {
                    referenceId: this.consignment.Id,
                    newStatusId: newStatusId,
                    comments: comments
                };
                this.bsLoadingOverlayService.wrap({
                    referenceId: 'con.update'
                },
                    () => {
                       return this.SaveConsignment().then(() => {
                            this.consignmentService.changeStatus().save({}, paramsObject, (data: interfaces.applicationcore.IMessageHandler) => {
                                this.bsLoadingOverlayService.wrap({
                                    referenceId: 'con.update'
                                }, () => {
                                    this.selectedTab = 8;
                                    return this.loadConsignment();
                                });

                                this.generalService.displayMessageHandler(data);
                            }, (failureData) => {
                                this.bsLoadingOverlayService.wrap({
                                    referenceId: 'con.update'
                                }, () => {
                                    this.selectedTab = 8;
                                    return this.loadConsignment();
                                });

                                this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                            });
                        }, () => {
                            return;
                        });
                    });
            };

            removeInlineTransitPoint(entity: interfaces.logistics.IConsignmentCustomsDetail) {
                this.bsLoadingOverlayService.wrap({
                    referenceId: 'con.update'
                }, () => {
                    return this.consignmentCustomsDetailService.delete(entity.Id).delete((result) => {
                        this.$timeout(() => {
                            this.bsLoadingOverlayService.wrap({
                                referenceId: 'con.update'
                            }, () => {
                                return this.loadConsignment();
                            });
                        });
                    }, (errorResponse) => {
                        this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                    });
                });

                _.remove(this.gvwTransList.data, (o) => {
                    return o === entity;
                });
            }

            updateTransitPoints() {
                //Customs Detail
                if (this.apiCustomsList && this.apiCustomsList.rowEdit.getDirtyRows().length > 0) {
                    this.consignment.ConsignmentCustomsDetailList = _.map(this.apiCustomsList.rowEdit.getDirtyRows(), (o) => {
                        return o.entity;
                    });
                } else {
                    if (this.apiTransList && this.apiTransList.rowEdit.getDirtyRows().length > 0) {
                        this.consignment.ConsignmentCustomsDetailList = _.map(this.apiTransList.rowEdit.getDirtyRows(), (o) => {
                            return o.entity;
                        });
                    } else {
                        this.consignment.ConsignmentCustomsDetailList = [];
                    }
                }

                //Updating the Consignment
                return this.consignmentService.update().save((this.consignment), (result: interfaces.applicationcore.IMessageHandler) => {
                    if (!result.HasErrorMessage) {

                        if (this.apiCustomsList) {
                            this.apiCustomsList.rowEdit.setRowsClean(this.consignment.ConsignmentCustomsDetailList);
                        }

                        if (this.apiTransList) {
                            this.apiTransList.rowEdit.setRowsClean(this.consignment.ConsignmentCustomsDetailList);
                        }
                    }
                }, (failureData) => {
                    this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                    this.$anchorScroll("topAnchor");
                }).$promise;

            }

            //Transit Points List Grid
            gvwTransList: uiGrid.IGridOptions = {
                data: [],
                enableFiltering: false,
                useExternalFiltering: false,
                enableCellEdit: false,
                useExternalSorting: false,
                multiSelect: false,
                enableColumnResizing: true,
                enableFullRowSelection: true,
                useExternalPagination: false,
                enableRowHeaderSelection: false,
                enableHorizontalScrollbar: 2,
                rowEditWaitInterval: -1,
                cellEditableCondition: true,
                showGridFooter: true,
                onRegisterApi: (gridApi) => { this.registerTransitGridApi(gridApi); },
                columnDefs: [{
                    name: "REMOVE",
                    displayName: "",
                    field: "TransitPointRemove",
                    cellTemplate: `
                    <div class="GridButton"> 
                        <button type="button" ng-click="grid.appScope.removeInlineTransitPoint(row.entity)" class="btn btn-warning btn-sm">
                            Delete
                        </button>
                    </div>`,
                    enableSorting: false,
                    enableColumnMenu: false,
                    enableCellEditOnFocus: false,
                    width: 55,
                    headerCellTemplate: `
                        <div class="GridButton"> 
                            <button type="button" class="btn btn-default btn-sm" ng-click="grid.appScope.addInlineTransitPoint()">
                                <span class="fa fa-plus"></span>
                            </button>
                        </div>`
                }, {
                    name: 'COUNTRY',
                    displayName: 'Transit Country',
                    field: 'TransitCountry',
                    enableCellEditOnFocus: true,
                    enableCellEdit: true,
                    cellTemplate: `<div class="ui-grid-cell-contents">{{MODEL_COL_FIELD.Display}}</div>`,
                    editableCellTemplate: `
                                <form name="inputForm">
                                    <gts-dropdown ui-select-wrap name="{{MODEL_COL_FIELD.$$hashKey}}" append-to-body="true" ng-model="MODEL_COL_FIELD" form="inputForm" load-data="grid.appScope.loadCountry()"  ng-change="grid.appScope.countryChange(model, row.entity)"></gts-dropdown>
                                </form>`,
                    enableSorting: false,
                    width: 250
                }]
            };

            registerTransitGridApi(gridApi: uiGrid.IGridApi) {
                this.apiTransList = gridApi;

                this.apiTransList.cellNav.on.navigate(this.$scope, (gridSelection) => {
                    this.apiTransList.selection.selectRow(gridSelection.row.entity);
                });

                this.$timeout(() => {
                    this.gvwTransList.data = this.consignment.ConsignmentCustomsDetailList;
                });
            }

            //Containers Tab Grid
            gvwContainers: uiGrid.IGridOptions = {
                data: [],
                enableFiltering: false,
                useExternalFiltering: false,
                enableCellEdit: false,
                useExternalSorting: false,
                multiSelect: false,
                enableColumnResizing: true,
                enableFullRowSelection: true,
                useExternalPagination: false,
                enableRowHeaderSelection: false,
                enableHorizontalScrollbar: 2,
                rowEditWaitInterval: -1,
                cellEditableCondition: true,
                showGridFooter: true,
                onRegisterApi: (gridApi) => { this.registerContainersGridApi(gridApi); },
                columnDefs: [{
                    name: "EDIT",
                    displayName: "",
                    field: "ID",
                    cellTemplate: `
                        <div class="GridButton"> 
                            <button type="button" ng-click="grid.appScope.consignmentUpdateCtrl.removeInlineContainers(row.entity)" class="btn btn-warning btn-sm" ng-disabled="grid.appScope.consignmentUpdateCtrl.consignment.LockdownType>1">
                                Delete
                            </button>
                            <button type="button" ng-click="grid.appScope.consignmentUpdateCtrl.editContainers(row.entity)" class="btn btn-default btn-sm">
                                <span class="fa fa-pencil"></span>
                            </button>
                        </div>`,
                    enableSorting: false,
                    enableColumnMenu: false,
                    enableCellEdit: false,
                    width: 92,
                    enableCellEditOnFocus: false,
                    headerCellTemplate: `
                        <div class="GridButton"> 
                            <button type="button" class="btn btn-default btn-sm" ng-click="grid.appScope.consignmentUpdateCtrl.addInlineContainers()" ng-disabled="grid.appScope.consignmentUpdateCtrl.consignment.LockdownType>1">
                                <span class="fa fa-plus"></span>
                            </button>
                        </div>`
                }, {
                    name: "CONTAINERNUMBER",
                    displayName: "* Container Number",
                    field: "Number",
                    type: "string",
                    cellClass: 'text-right',
                    enableCellEdit: true,
                    cellEditableCondition: () => { return this.consignment ? this.consignment.LockdownType < 2 : true },
                    cellTemplate: `<div class="ui-grid-cell-contents">{{MODEL_COL_FIELD}}</div>`,
                    editableCellTemplate: `
                        <form name = "inputForm">
                            <p class="input-group-sm">
                                <input type="text" name="Number-{{MODEL_COL_FIELD.$$hashKey}}" ng-model="MODEL_COL_FIELD" class="form-control" ui-grid-editor step = "0.01" />
                            </p>
                        </form>`,
                    enableCellEditOnFocus: true
                }, {
                    name: "CONTAINERISO",
                    displayName: "Container Size",
                    field: "ContainerISOCode",
                    type: "string",
                    cellClass: 'text-right',
                    enableCellEdit: true,
                    cellEditableCondition: () => { return this.consignment ? this.consignment.LockdownType < 2 : true },
                    cellTemplate: `<div class="ui-grid-cell-contents">{{MODEL_COL_FIELD.Display}}</div>`,
                    editableCellTemplate: `
                            <form name="inputForm">
                                <gts-dropdown ui-select-wrap name="ContainerISOCode-{{MODEL_COL_FIELD.$$hashKey}}" append-to-body="true" ng-model="MODEL_COL_FIELD" form="inputForm" load-data="grid.appScope.consignmentUpdateCtrl.loadContainerISOs()"></gts-dropdown>
                            </form>`,
                    enableCellEditOnFocus: true
                }, {
                    name: "GROSSMASS",
                    displayName: "Gross Mass",
                    field: "GrossMass",
                    type: "number",
                    cellClass: 'text-right',
                    enableCellEdit: true,
                    cellEditableCondition: () => { return this.consignment ? this.consignment.LockdownType < 2 : true },
                    cellTemplate: `<div class="ui-grid-cell-contents">{{MODEL_COL_FIELD}}</div>`,
                    editableCellTemplate: `
                        <form name = "inputForm">
                            <p class="input-group-sm">
                                <input type="text" name="GrossMass-{{MODEL_COL_FIELD.$$hashKey}}" ng-model="MODEL_COL_FIELD" class="form-control" ui-grid-editor step = "0.01" />
                            </p>
                        </form>`,
                    enableCellEditOnFocus: true
                }]
            };

            registerContainersGridApi(gridApi: uiGrid.IGridApi) {
                this.apiContainersList = gridApi;

                this.apiContainersList.cellNav.on.navigate(this.$scope, (gridSelection) => {
                    this.apiContainersList.selection.selectRow(gridSelection.row.entity);
                });
            }

            //Add and remove in line Contaainer
            addInlineContainers() {
                (<Array<any>>(this.gvwContainers.data)).splice(0, 0, {});
            }

            removeInlineContainers(entity: interfaces.logistics.IContainer) {

                if (entity.Id > 0) {
                    this.bsLoadingOverlayService.wrap({
                        referenceId: 'con.update'
                    }, () => {
                        return this.containerService.delete(this.consignment.Id, null, entity.Id).delete((result: interfaces.applicationcore.IMessageHandler) => {
                            this.generalService.displayMessageHandler(result);
                            if (!result.HasErrorMessage) {
                                this.$timeout(() => {
                                    this.bsLoadingOverlayService.wrap({
                                        referenceId: 'con.update'
                                    }, () => {
                                        return this.loadConsignment();
                                    });
                                });
                            }

                        }, (errorResponse) => {
                            this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                        });
                    });
                } else {
                    _.remove(this.gvwContainers.data, (o) => {
                        return o === entity;
                    });
                }
            }

            editContainers(entity: interfaces.logistics.IContainer) {
                if (this.consignment) {
                    if (this.$state.current.name === "auth.Manifests.Update.ConsignmentExport") {
                        this.$state.go("auth.Manifests.Update.ConsignmentExport.Container", { contId: entity.Id });
                        return;
                    }

                    if (this.$state.current.name === "auth.Manifests.Update.ConsignmentImport") {
                        this.$state.go("auth.Manifests.Update.ConsignmentImport.Container", { contId: entity.Id });
                        return;
                    }

                    if (this.isInbound) {
                        this.$state.go("auth.ConsignmentImports.Update.Container", { contId: entity.Id });
                    } else {
                        this.$state.go("auth.ConsignmentExports.Update.Container", { contId: entity.Id });
                    }
                }
            }

            //Load Container ISO.
            loadContainerISOs(searchText: string) {
                return this.containerISOService.getContainerISODropdown(searchText).query(
                    () => {

                    }, (failureData) => {
                    }).$promise;
            }

            //Customs Tab Grid
            gvwCustoms: uiGrid.IGridOptions = {
                data: [],
                enableFiltering: false,
                useExternalFiltering: false,
                enableCellEdit: false,
                useExternalSorting: false,
                multiSelect: false,
                enableColumnResizing: true,
                enableFullRowSelection: true,
                useExternalPagination: false,
                enableRowHeaderSelection: false,
                enableHorizontalScrollbar: 2,
                rowEditWaitInterval: -1,
                cellEditableCondition: true,
                showGridFooter: true,
                onRegisterApi: (gridApi) => { this.registerCustomsGridApi(gridApi); },
                columnDefs: [{
                    name: "EDIT",
                    displayName: "",
                    field: "CustomsId",
                    cellTemplate: `
                        <div class="GridButton"> 
                            <button type="button" ng-click="grid.appScope.consignmentUpdateCtrl.removeInlineCustoms(row.entity)" class="btn btn-warning btn-sm" >
                                Delete
                            </button>
                        </div>`,
                    enableSorting: false,
                    enableColumnMenu: false,
                    enableCellEdit: false,
                    width: 55,
                    enableCellEditOnFocus: false,
                    headerCellTemplate: `
                        <div class="GridButton"> 
                            <button type="button" class="btn btn-default btn-sm" ng-click="grid.appScope.consignmentUpdateCtrl.addInlineCustoms()" ng-disabled="grid.appScope.consignmentUpdateCtrl.consignment.LockdownType>1">
                                <span class="fa fa-plus"></span>
                            </button>
                        </div>`
                }, {
                    name: "TRANSITCOUNT",
                    displayName: "Transit Country",
                    field: "TransitCountry",
                    type: "string",
                    cellClass: 'text-right',
                    enableCellEdit: true,
                    cellTemplate: `<div class="ui-grid-cell-contents">{{MODEL_COL_FIELD.Display}}</div>`,
                    editableCellTemplate: `
                            <form name="inputForm">
                                <gts-dropdown ui-select-wrap name="TransitCountryCode-{{MODEL_COL_FIELD.$$hashKey}}" append-to-body="true" ng-model="MODEL_COL_FIELD" form="inputForm" load-data="grid.appScope.consignmentUpdateCtrl.loadLoadingCountry()" ng-change="grid.appScope.countryChange(model, row.entity)"></gts-dropdown>
                            </form>`,
                    enableCellEditOnFocus: true
                }, {
                    name: "LRNNUMBER",
                    displayName: "LRN Number",
                    field: "LRNumber",
                    type: "string",
                    cellClass: 'text-right',
                    enableCellEdit: true,
                    cellTemplate: `<div class="ui-grid-cell-contents">{{MODEL_COL_FIELD}}</div>`,
                    editableCellTemplate: `
                        <form name = "inputForm">
                            <p class="input-group-sm">
                                <input type="text" name="LRNumber-{{MODEL_COL_FIELD.$$hashKey}}" ng-model="MODEL_COL_FIELD" class="form-control" ui-grid-editor step = "0.01" />
                            </p>
                        </form>`,
                    enableCellEditOnFocus: true
                }, {
                    name: "LRNDATE",
                    displayName: "LRN Date",
                    field: "LRNDate",
                    type: "string",
                    cellClass: 'text-right',
                    enableCellEdit: true,
                    cellTemplate: `<div class="ui-grid-cell-contents">{{MODEL_COL_FIELD | momentDateFilter: 'YYYY/MM/DD'}}</div>`,
                    editableCellTemplate: `
                        <form name="inputForm">
                            <gts-date format="yyyy/MM/dd" ng-model="MODEL_COL_FIELD" name="LRNDate-{{MODEL_COL_FIELD.$$hashKey}}"></gts-date>
                        </form>`,
                    enableCellEditOnFocus: true
                }, {
                    name: "PRODMEASURE",
                    displayName: "Procedure Measure",
                    field: "LRNProcedure",
                    type: "string",
                    cellClass: 'text-right',
                    enableCellEdit: true,
                    cellTemplate: `<div class="ui-grid-cell-contents">{{MODEL_COL_FIELD}}</div>`,
                    editableCellTemplate: `
                        <form name = "inputForm">
                            <p class="input-group-sm">
                                <input type="text" name="LRNProcedure-{{MODEL_COL_FIELD.$$hashKey}}" ng-model="MODEL_COL_FIELD" class="form-control" ui-grid-editor step = "0.01" />
                            </p>
                        </form>`,
                    enableCellEditOnFocus: true
                }]
            };

            //Add and remove in line Customs
            addInlineCustoms() {
                this.gvwCustoms.data = this.consignment.ConsignmentCustomsDetailList;
                this.gvwCustoms.data.push(<interfaces.logistics.IConsignmentCustomsDetail>{
                    TransitCountryCode: "",
                    TransitCountryDescription: ""
                });
            }

            removeInlineCustoms(entity: interfaces.logistics.IConsignmentCustomsDetail) {
                this.bsLoadingOverlayService.wrap({
                    referenceId: 'con.update'
                }, () => {
                    return this.consignmentCustomsDetailService.delete(entity.Id).delete((result) => {
                        this.$timeout(() => {
                            this.bsLoadingOverlayService.wrap({
                                referenceId: 'con.update'
                            }, () => {
                                return this.loadConsignment();
                            });
                        });
                    }, (errorResponse) => {
                        this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                    });
                });

                _.remove(this.gvwCustoms.data, (o) => {
                    return o === entity;
                });
            }

            registerCustomsGridApi(gridApi: uiGrid.IGridApi) {
                this.apiCustomsList = gridApi;

                this.apiCustomsList.cellNav.on.navigate(this.$scope, (gridSelection) => {
                    this.apiCustomsList.selection.selectRow(gridSelection.row.entity);
                });
            }

            //Loading the Consignees with Search
            loadConsignees(searchText: string) {
                var defered = this.$q.defer();

                if (!this.consignment) {
                    defered.resolve([]);
                    return defered.promise;
                }

                this.consigneeService.getDropdownList(this.consignment.OwnerEntityId, searchText).query({}, (list: Array<interfaces.applicationcore.IDropdownModel>) => {
                    defered.resolve(list);
                }, (errorResponse) => {
                    this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                    defered.resolve([]);
                });

                return defered.promise;

            }

            //Loading the Notify Parties
            loadNotifyParty() {
                if (this.consignment) {
                    return this.notifyPartyService.getDropdownList().query({
                        ownerEntityId: this.consignment.OwnerEntityId
                    }, () => {

                    }, (failureData) => {
                        this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                    }).$promise;
                } else {
                    var defer = this.$q.defer();
                    defer.resolve([]);
                    return defer.promise;
                }
            }

            packageTypeChanged(model: interfaces.applicationcore.IDropdownModel, entity: interfaces.consignment.IConsignmentDetailDisplay) {        
                    if (this.apiCOD) {
                        this.apiCOD.rowEdit.setRowsDirty([entity]);
                    }              
            }
 

            apiCOD: uiGrid.IGridApi;
            gvwCOD: uiGrid.IGridOptions = {
                data: [],
                enableFiltering: false,
                useExternalFiltering: false,
                enableCellEdit: false,
                useExternalSorting: false,
                multiSelect: false,
                enableColumnResizing: true,
                enableFullRowSelection: true,
                useExternalPagination: false,
                enableRowHeaderSelection: false,
                enableHorizontalScrollbar: 2,
                rowEditWaitInterval: -1,
                showGridFooter: true,
                onRegisterApi: (gridApi) => {
                    this.apiCOD = gridApi;
                    this.apiCOD.selection.on.rowSelectionChanged(this.$scope, () => {
                        this.editingPacking = false;
                    });

                    this.apiCOD.cellNav.on.navigate(this.$scope, (newCol) => {
                        this.$timeout(() => {
                            this.apiCOD.selection.selectRow(newCol.row.entity);
                        });
                    });
                },
                columnDefs: [{
                    name: "EDIT",
                    displayName: "",
                    field: "ID",
                    cellTemplate: `
                        <div class="GridButton"> 
                            <button type="button" ng-click="grid.appScope.consignmentUpdateCtrl.editDetail(row.entity.Id)" class="btn btn-default btn-sm">
                                <span class="fa fa-pencil"></span>
                            </button>
                        </div>`,
                    enableSorting: false,
                    enableColumnMenu: false,
                    enableCellEdit: false,
                    width: 32,
                    enableCellEditOnFocus: false,
                    headerCellTemplate: `
                    <div class="GridButton"> 
                        <button type="button" class="btn btn-default btn-sm" ng-click="grid.appScope.consignmentUpdateCtrl.addInlineDetail()" ng-disabled="grid.appScope.consignmentUpdateCtrl.consignment.LockdownType>2">
                            <span class="fa fa-plus"></span>
                        </button>
                    </div>`
                }, {
                    name: "SEQNUM",
                    displayName: "#",
                    field: "LineNumber",
                    enableFiltering: false,
                    type: "number",
                    cellClass: 'text-right',
                    width: 30,
                    enableCellEdit: false,
                    enableCellEditOnFocus: false
                }, {
                    name: "DESCGOOD",
                    displayName: "Description Of Goods",
                    field: "DescriptionOfGoods",
                    width: 250,
                    enableCellEdit: true,
                    cellEditableCondition: () => { return this.consignment ? this.consignment.LockdownType < 3 : true },
                    enableCellEditOnFocus: true,
                    editableCellTemplate: `
                                <form name="inputForm">
                                    <p class="input-group-sm">
                                        <input type="text" name="DescriptionOfGoods-{{MODEL_COL_FIELD.$$hashKey}}" ng-model="MODEL_COL_FIELD" ng-class="'colt' + col.uid" class="form-control" ui-grid-editor step="0.01" />
                                    </p>
                                </form>`,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                </div>
                            </div>`
                }, {
                    name: "NUMPACKAGE",
                    displayName: "Number Of Packages",
                    field: "NumberOfPackages",
                    type: "number",
                    cellFilter: "number: 2",
                    cellClass: 'text-right',
                    width: 150,
                    enableCellEdit: true,
                    cellEditableCondition: () => { return this.consignment ? this.consignment.LockdownType < 3 : true },
                    enableCellEditOnFocus: true,
                    editableCellTemplate: `
                                <form name="inputForm">
                                    <p class="input-group-sm">
                                        <input type="number" name="NumberOfPackages-{{MODEL_COL_FIELD.$$hashKey}}" ng-model="MODEL_COL_FIELD" ng-class="'colt' + col.uid" class="form-control" ui-grid-editor step="0.01" />
                                    </p>
                                </form>`,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="number" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/></div>
                            </div>`,
                    filter: {
                        condition: (searchTerm, cellValue) => {
                            return cellValue >= searchTerm;
                        }
                    }
                }, {
                    name: "TOPACK",
                    displayName: "Type Of Package",
                    field: "TypeOfPackage",
                    enableFiltering: true,
                    enableCellEdit: true,
                    cellEditableCondition: () => { return this.consignment ? this.consignment.LockdownType < 3 : true },
                    enableCellEditOnFocus: true,
                    width: 200,
                    cellTemplate: `<div class="ui-grid-cell-contents">{{MODEL_COL_FIELD.Display}}</div>`,
                    editableCellTemplate: `<form name="inputForm">
                                                <gts-dropdown ui-select-wrap name="code-{{MODEL_COL_FIELD.$$hashKey}}" append-to-body="true" ng-model="MODEL_COL_FIELD" form="inputForm" load-data="grid.appScope.consignmentUpdateCtrl.loadTypeOfPackage(searchText)" required="true" search-enabled="false" ng-change="grid.appScope.consignmentUpdateCtrl.packageTypeChanged(model,row.entity)"></gts-dropdown>
                                            </form>`,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/></div>
                            </div>`,
                    filter: {
                        condition: (searchTerm, cellValue) => {
                            return (cellValue.Display.toLocaleLowerCase().indexOf(searchTerm.toLocaleLowerCase()) >= 0 || searchTerm.length === 0);
                        }
                    },
                    sortingAlgorithm: (a, b, rowA, rowB, direction) => {
                        var nulls = this.apiCOD.core.sortHandleNulls(a, b);
                        if (nulls !== null) {
                            return nulls;
                        } else {
                            if (a === b) {
                                return 0;
                            }

                            if (direction === "desc") {
                                if (a.Display < b.Display) return -1;
                                if (a.Display > b.Display) return 1;
                            } else if (direction === "asc") {
                                if (a.Display > b.Display) return 1;
                                if (a.Display < b.Display) return -1;
                            }

                            return 0;
                        }
                    }
                }, {
                    name: "GROSSMASS",
                    displayName: "Gross Mass",
                    field: "Grossmass",
                    type: "number",
                    cellFilter: "number: 5",
                    cellClass: 'text-right',
                    width: 150,
                    enableCellEdit: true,
                    cellEditableCondition: () => { return this.consignment ? this.consignment.LockdownType < 3 : true },
                    enableCellEditOnFocus: true,
                    editableCellTemplate: `
                                <form name="inputForm">
                                    <p class="input-group-sm">
                                        <input type="number" name="grossmass-{{MODEL_COL_FIELD.$$hashKey}}" ng-model="MODEL_COL_FIELD" ng-class="'colt' + col.uid" class="form-control" ui-grid-editor step="0.000001" />
                                    </p>
                                </form>`,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="number" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/></div>
                            </div>`,
                    filter: {
                        condition: (searchTerm, cellValue) => {
                            return cellValue >= searchTerm;
                        }
                    }
                }, {
                    name: "NETMASS",
                    displayName: "Net Mass",
                    field: "NettMass",
                    type: "number",
                    cellFilter: "number: 5",
                    cellClass: 'text-right',
                    width: 150,
                    enableCellEdit: true,
                    cellEditableCondition: () => { return this.consignment ? this.consignment.LockdownType < 3 : true },
                    enableCellEditOnFocus: true,
                    editableCellTemplate: `
                                <form name="inputForm">
                                    <p class="input-group-sm">
                                        <input type="number" name="netmass-{{MODEL_COL_FIELD.$$hashKey}}" ng-model="MODEL_COL_FIELD" ng-class="'colt' + col.uid" class="form-control" ui-grid-editor step="0.000001" />
                                    </p>
                                </form>`,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="number" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/></div>
                            </div>`,
                    filter: {
                        condition: (searchTerm, cellValue) => {
                            return cellValue >= searchTerm;
                        }
                    }
                }, {
                    name: "VOLUME",
                    displayName: "Volume",
                    field: "Volume",
                    type: "number",
                    cellFilter: "number: 5",
                    cellClass: 'text-right',
                    width: 150,
                    enableCellEdit: true,
                    cellEditableCondition: () => { return this.consignment ? this.consignment.LockdownType < 3 : true },
                    enableCellEditOnFocus: true,
                    editableCellTemplate: `
                                <form name="inputForm">
                                    <p class="input-group-sm">
                                        <input type="number" name="volume-{{MODEL_COL_FIELD.$$hashKey}}" ng-model="MODEL_COL_FIELD" ng-class="'colt' + col.uid" class="form-control" ui-grid-editor step="0.000001" />
                                    </p>
                                </form>`,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="number" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/></div>
                            </div>`,
                    filter: {
                        condition: (searchTerm, cellValue) => {
                            return cellValue >= searchTerm;
                        }
                    }
                }]
            };

            addInlineDetail() {
                (<Array<any>>(this.gvwCOD.data)).splice(0, 0, {});
            }

            removeDetail() {
                var selectedRow = <interfaces.consignment.IConsignmentDetailDisplay>this.apiCOD.selection.getSelectedRows()[0];
                if (selectedRow && selectedRow.Id > 0) {
                    this.bsLoadingOverlayService.wrap({
                        referenceId: 'con.update'
                    }, () => {
                        return this.consignmentDetailService.delete(selectedRow.Id).delete((result) => {
                            this.$timeout(() => {
                                this.bsLoadingOverlayService.wrap({
                                    referenceId: 'con.update'
                                }, () => {
                                    return this.loadConsignment();
                                });
                            });
                        }, (errorResponse) => {
                            this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                        });
                    });
                } else if (selectedRow) {
                    _.remove(this.gvwCOD.data, (o) => {
                        return o === selectedRow;
                    });
                }
            }

            apiCOPACK: uiGrid.IGridApi;
            gvwCOPACK: uiGrid.IGridOptions = {
                data: [],
                enableFiltering: true,
                useExternalFiltering: false,
                enableCellEdit: false,
                useExternalSorting: false,
                multiSelect: false,
                enableColumnResizing: true,
                enableFullRowSelection: true,
                useExternalPagination: false,
                enableRowHeaderSelection: false,
                cellEditableCondition: () => { return (this.consignment) ? (this.consignment.LockdownType > 2 ? false : true) : false },
                enableHorizontalScrollbar: 2,
                rowEditWaitInterval: -1,
                showGridFooter: true,
                onRegisterApi: (gridApi) => {
                    this.apiCOPACK = gridApi;

                    if (this.consignment) {

                        this.gvwCOPACK.columnDefs[5].visible = this.consignment.EnableItemTracking;
                        this.gvwCOPACK.columnDefs[6].visible = this.consignment.EnableItemTracking;
                        this.gvwCOPACK.columnDefs[7].visible = this.consignment.EnableItemTracking;
                        this.gvwCOPACK.columnDefs[9].visible = this.consignment.EnableItemTracking;
                        this.gvwCOPACK.columnDefs[10].visible = this.consignment.EnableItemTracking;

                        if (this.consignment.CargoTypeId === 4)
                            this.gvwCOPACK.columnDefs[13].visible = true;
                    }
                    this.$timeout(() => {
                        this.apiCOPACK.grid.refresh();
                        this.loadConsignmentDetailPacking();
                    });


                    this.apiCOPACK.cellNav.on.navigate(this.$scope, (newCol) => {
                        this.$timeout(() => {
                            this.apiCOPACK.selection.selectRow(newCol.row.entity);
                        });
                    });
                },
                columnDefs: [{
                    name: "EDIT",
                    field: "",
                    enableFiltering: false,
                    width: 55,
                    enableCellEdit: false,
                    enableCellEditOnFocus: false,
                    headerCellTemplate: `
                    <div class="GridButton"> 
                        <button type="button" class="btn btn-default btn-sm" ng-click="grid.appScope.consignmentUpdateCtrl.addInlinePackingDetail()"  ng-disabled="grid.appScope.consignmentUpdateCtrl.consignment.LockdownType>2">
                            <span class="fa fa-plus"></span>
                        </button>
                    </div>`,
                    cellTemplate: `
                    <div class="GridButton"> 
                        <button type="button" class="btn btn-warning btn-sm" ng-click="grid.appScope.consignmentUpdateCtrl.removePackingDetail(row.entity)" ng-disabled="grid.appScope.consignmentUpdateCtrl.consignment.LockdownType>2">
                            Delete
                        </button>
                    </div>`
                }, {
                    name: "SEQNUM",
                    displayName: "#",
                    field: "SequenceNumber",
                    enableFiltering: false,
                    type: "number",
                    cellClass: 'text-right',
                    width: 30,
                    enableCellEdit: false,
                    enableCellEditOnFocus: false
                }, {
                    name: "SKUCODE",
                    displayName: "SKU Code",
                    field: "SKUCode",
                    width: 150,
                    enableCellEdit: false,
                    enableCellEditOnFocus: false,
                    editableCellTemplate: `
                                <form name="inputForm">
                                    <p class="input-group-sm">
                                        <input type="text" name="skucode-{{MODEL_COL_FIELD.$$hashKey}}" ng-model="MODEL_COL_FIELD" ng-class="'colt' + col.uid" class="form-control" ui-grid-editor step="0.01" />
                                    </p>
                                </form>`,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                </div>
                            </div>`
                }, {
                    name: "SKUDESC",
                    displayName: "SKU Description",
                    field: "SKUDescription",
                    width: 150,
                    enableCellEdit: false,
                    enableCellEditOnFocus: false,
                    editableCellTemplate: `
                                    <form name="inputForm">
                                        <p class="input-group-sm">
                                            <input type="text" name="skudesc-{{MODEL_COL_FIELD.$$hashKey}}" ng-model="MODEL_COL_FIELD" ng-class="'colt' + col.uid" class="form-control" ui-grid-editor step="0.01" />
                                        </p>
                                    </form>`,
                    filterHeaderTemplate: `
                                <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                    <div class="input-group-sm">
                                        <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                    </div>
                                </div>`
                }, {
                    name: "QTY",
                    displayName: "Order Qty.",
                    field: "Qty",
                    type: "number",
                    cellFilter: "number: 5",
                    cellClass: 'text-right',
                    width: 150,
                    enableCellEdit: false,
                    enableCellEditOnFocus: false,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="number" ignore-wheel class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/></div>
                            </div>`,
                    filter: {
                        condition: (searchTerm, cellValue) => {
                            return cellValue >= searchTerm;
                        }
                    }
                }, {
                    name: "LOTNUM",
                    displayName: "Lot Number",
                    field: "LotNumber",
                    width: 150,
                    enableCellEdit: true,
                    enableCellEditOnFocus: true,
                    visible: false,
                    editableCellTemplate: `
                                            <form name="inputForm">
                                                <p class="input-group-sm">
                                                    <input type="text" name="LotNumber-{{MODEL_COL_FIELD.$$hashKey}}" ng-model="MODEL_COL_FIELD" ng-class="'colt' + col.uid" class="form-control" ui-grid-editor maxlength="30" />
                                                </p>
                                            </form>`,
                    filterHeaderTemplate: `
                                    <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                        <div class="input-group-sm">
                                            <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                        </div>
                                    </div>`
                }, {
                    name: "SERIALNUM",
                    displayName: "Serial Number",
                    field: "SerialNumber",
                    width: 150,
                    enableCellEdit: true,
                    enableCellEditOnFocus: true,
                    visible: false,
                    editableCellTemplate: `
                                        <form name="inputForm">
                                            <p class="input-group-sm">
                                                <input type="text" name="SerialNumber-{{MODEL_COL_FIELD.$$hashKey}}" ng-model="MODEL_COL_FIELD" ng-class="'colt' + col.uid" class="form-control" ui-grid-editor maxlength="30" />
                                            </p>
                                        </form>`,
                    filterHeaderTemplate: `
                                    <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                        <div class="input-group-sm">
                                            <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                        </div>
                                    </div>`
                }, {
                    name: "LOTQTY",
                    displayName: "Lot Quantity",
                    field: "LotQty",
                    type: "number",
                    cellFilter: "number: 5",
                    cellClass: 'text-right',
                    width: 150,
                    enableCellEdit: true,
                    enableCellEditOnFocus: true,
                    visible: false,
                    editableCellTemplate: `
                                        <form name="inputForm">
                                            <p class="input-group-sm">
                                                <input type="number" ignore-wheel name="LotQty-{{MODEL_COL_FIELD.$$hashKey}}" ng-model="MODEL_COL_FIELD" ng-class="'colt' + col.uid" class="form-control" ui-grid-editor maxlength="30" />
                                            </p>
                                        </form>`,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="number" ignore-wheel class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/></div>
                            </div>`,
                    filter: {
                        condition: (searchTerm, cellValue) => {
                            return cellValue >= searchTerm;
                        }
                    }
                }, {
                    name: "ALLQTY",
                    displayName: "*Allocated Quantity",
                    field: "AllocatedQty",
                    type: "number",
                    cellFilter: "number: 5",
                    cellClass: 'text-right',
                    width: 150,
                    enableCellEdit: true,
                    enableCellEditOnFocus: true,
                    editableCellTemplate: `
                                <form name="inputForm" ng-disabled="grid.appScope.consignmentUpdateCtrl.consignment.LockdownType>2">
                                    <p class="input-group-sm">
                                        <input type="number" ignore-wheel name="AllocatedQty-{{MODEL_COL_FIELD.$$hashKey}}" ng-model="MODEL_COL_FIELD" ng-class="'colt' + col.uid" class="form-control" ui-grid-editor step="0.00001" />
                                    </p>
                                </form>`,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="number" ignore-wheel class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/></div>
                            </div>`,
                    filter: {
                        condition: (searchTerm, cellValue) => {
                            return cellValue >= searchTerm;
                        }
                    }
                }, {
                    name: 'EXPDATE',
                    displayName: 'Expiry Date',
                    field: 'ExpiryDate',
                    enableCellEditOnFocus: true,
                    enableCellEdit: true,
                    visible: false,
                    cellTemplate: `<div class="ui-grid-cell-contents">{{MODEL_COL_FIELD | momentDateFilter: "YYYY/MM/DD"}}</div>`,
                    editableCellTemplate: `
                            <form name="inputForm">
                                    <gts-date format="yyyy/MM/dd" ng-model="MODEL_COL_FIELD" name="{{MODEL_COL_FIELD.$$hashKey}}-expdate"></gts-date>
                            </form>`,
                    enableSorting: false,
                    width: 150,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                                <gts-date format="yyyy/MM/dd" ng-model="colFilter.term" name="expDate"></gts-date>
                                        
                            </div>`,
                    filter: {
                        condition: function (searchTerm, cellValue) {
                            if (cellValue) {
                                return cellValue.isSameOrAfter(searchTerm);
                            } else {
                                return false;
                            }
                        }
                    }
                }, {
                    name: 'PRODDATE',
                    displayName: 'Production Date',
                    field: 'ProductionDate',
                    enableCellEditOnFocus: true,
                    enableCellEdit: true,
                    cellTemplate: `<div class="ui-grid-cell-contents">{{MODEL_COL_FIELD | momentDateFilter: "YYYY/MM/DD"}}</div>`,
                    editableCellTemplate: `
                            <form name="inputForm">
                                    <gts-date format="yyyy/MM/dd" ng-model="MODEL_COL_FIELD" name="{{MODEL_COL_FIELD.$$hashKey}}-proddate"></gts-date>
                            </form>`,
                    enableSorting: false,
                    visible: false,
                    width: 150,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                                <gts-date format="yyyy/MM/dd" ng-model="colFilter.term" name="prodDate"></gts-date>
                                        
                            </div>`,
                    filter: {
                        condition: function (searchTerm, cellValue) {
                            if (cellValue) {
                                return cellValue.isSameOrAfter(searchTerm);
                            } else {
                                return false;
                            }
                        }
                    }
                }, {
                    name: "ALLPACK",
                    displayName: "*Allocated Packages",
                    field: "TrackingNumberOfPackages",
                    type: "number",
                    cellFilter: "number: 0",
                    cellClass: 'text-right',
                    width: 150,
                    enableCellEdit: true,
                    enableCellEditOnFocus: true,
                    editableCellTemplate: `
                                <form name="inputForm">
                                    <p class="input-group-sm">
                                        <input type="number" ignore-wheel name="detailNumPack-{{MODEL_COL_FIELD.$$hashKey}}" ng-model="MODEL_COL_FIELD" ng-class="'colt' + col.uid" class="form-control" ui-grid-editor step="1" />
                                    </p>
                                </form>`,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="number" ignore-wheel class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/></div>
                            </div>`,
                    filter: {
                        condition: (searchTerm, cellValue) => {
                            return cellValue >= searchTerm;
                        }
                    }
                }, {
                    name: "TOPACK",
                    displayName: "*Type Of Package",
                    field: "TypeOfPackage",
                    enableFiltering: true,
                    enableCellEdit: true,
                    enableCellEditOnFocus: true,
                    width: 175,
                    cellTemplate: `<div class="ui-grid-cell-contents">{{MODEL_COL_FIELD.Display}}</div>`,
                    editableCellTemplate: `<form name="inputForm">
                                                <gts-dropdown ui-select-wrap name="top-{{MODEL_COL_FIELD.$$hashKey}}" append-to-body="true" ng-model="MODEL_COL_FIELD" form="inputForm" load-data="grid.appScope.consignmentUpdateCtrl.loadTypeOfPackagePacking(searchText)" required="true"
                                                search-enabled="false"></gts-dropdown>
                                            </form>`,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/></div>
                            </div>`,
                    filter: {
                        condition: (searchTerm, cellValue) => {
                            return (cellValue.Display.toLocaleLowerCase().indexOf(searchTerm.toLocaleLowerCase()) >= 0 || searchTerm.length === 0);
                        }
                    },
                    sortingAlgorithm: (a, b, rowA, rowB, direction) => {
                        var nulls = this.apiCOD.core.sortHandleNulls(a, b);
                        if (nulls !== null) {
                            return nulls;
                        } else {
                            if (a === b) {
                                return 0;
                            }

                            if (direction === "desc") {
                                if (a.Display < b.Display) return -1;
                                if (a.Display > b.Display) return 1;
                            } else if (direction === "asc") {
                                if (a.Display > b.Display) return 1;
                                if (a.Display < b.Display) return -1;
                            }

                            return 0;
                        }
                    }
                }, {
                    name: "CONTAINER",
                    displayName: "Container",
                    field: "Container",
                    enableFiltering: true,
                    enableCellEdit: true,
                    enableCellEditOnFocus: true,
                    visible: false,
                    width: 175,
                    cellTemplate: `<div class="ui-grid-cell-contents">{{MODEL_COL_FIELD.Code}}</div>`,
                    editableCellTemplate: `<form name="inputForm">
                                                <gts-dropdown ui-select-wrap name="con-{{MODEL_COL_FIELD.$$hashKey}}" append-to-body="true" ng-model="MODEL_COL_FIELD" form="inputForm" load-data="grid.appScope.consignmentUpdateCtrl.loadDetailContainers(searchText)" required="true" pagination-search="true" refresh-delay="1000"></gts-dropdown>
                                            </form>`,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/></div>
                            </div>`,
                    filter: {
                        condition: (searchTerm, cellValue) => {
                            return (cellValue.Display.toLocaleLowerCase().indexOf(searchTerm.toLocaleLowerCase()) >= 0 || searchTerm.length === 0);
                        }
                    },
                    sortingAlgorithm: (a, b, rowA, rowB, direction) => {
                        var nulls = this.apiCOD.core.sortHandleNulls(a, b);
                        if (nulls !== null) {
                            return nulls;
                        } else {
                            if (a === b) {
                                return 0;
                            }

                            if (direction === "desc") {
                                if (a.Display < b.Display) return -1;
                                if (a.Display > b.Display) return 1;
                            } else if (direction === "asc") {
                                if (a.Display > b.Display) return 1;
                                if (a.Display < b.Display) return -1;
                            }

                            return 0;
                        }
                    }
                }]
            };

            loadConsignmentDetailPacking() {
                this.isLoadingDetail = true;

                this.consignmentDetailService.getPackingList(this.consignment.Id).query((result) => {
                    this.isLoadingDetail = false;
                    this.gvwCOPACK.data = result;
                }, (errorResponse) => {
                    this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                    this.isLoadingDetail = false;
                });
            }

            editPacking() {
                if (this.apiCOD && this.apiCOD.rowEdit.getDirtyRows().length === 0) {
                    this.editingPacking = true;
                } else {
                    this.generalService.displayMessageBox("Edit Packaging", "Please save consignment detail summary before editing the packing list");
                }
            }

            savePacking() {
                if (this.editingPacking) {
                    this.bsLoadingOverlayService.wrap({
                        referenceId: 'con.update'
                    }, () => {
                        return this.savePackingList().then(() => {
                            this.$timeout(() => {
                                this.bsLoadingOverlayService.wrap({
                                    referenceId: 'con.update'
                                }, () => {
                                    return this.loadConsignment();
                                });
                            });
                        });
                    });
                } else {
                    this.generalService.displayMessageBox("Edit Packaging", "Please load the packing list before editing the packing list");
                }

            }

            loadTypeOfPackage(searchText: string) {
                return this.typeOfPackageService.getDropdownList(this.consignment.OwnerEntityId).query(() => {
                }, (errorResponse) => {
                    this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                }).$promise;
            }

            loadTypeOfPackagePacking(searchText: string) {
                var defer = this.$q.defer();

                if (this.consignment.ConsignmentDetailList.length > 0) {
                    var topList = _.map(this.consignment.ConsignmentDetailList, (o) => {
                        return {
                            Id: o.Id, // We want the Id of the Consignment Detail Record.
                            Code: o.TypeOfPackage.Code,
                            Description: o.TypeOfPackage.Description,
                            Display: o.LineNumber + " - " + o.NumberOfPackages + " " + o.TypeOfPackage.Description,
                        };
                    });

                    topList = _.filter(topList, (n: interfaces.applicationcore.IDropdownModel) => {
                        return (n.Display.toLocaleLowerCase().indexOf(searchText) >= 0 || searchText.length === 0);
                    });

                    defer.resolve(topList);
                } else {

                    defer.resolve([]);
                }

                return defer.promise;
            }

            loadDetailContainers(searchText: string) {
                var defer = this.$q.defer();

                if (this.consignment.ContainersList.length > 0) {
                    var contList = _.map(this.consignment.ContainersList, (o) => {
                        return {
                            Id: o.Id,
                            Code: o.Number,
                            Description: o.Number,
                            Display: o.Number,
                        };
                    });

                    contList = _.filter(contList, (n: interfaces.applicationcore.IDropdownModel) => {
                        return (n.Display.toLocaleLowerCase().indexOf(searchText) >= 0 || searchText.length === 0);
                    });

                    defer.resolve(contList);
                } else {

                    defer.resolve([]);
                }

                return defer.promise;
            }

            addContainer_click() {
                if (this.consignment) {
                    if (this.$state.current.name === "auth.Manifests.Update.ConsignmentExport") {
                        this.$state.go("auth.Manifests.Update.ConsignmentExport.Container", { contId: 0 });
                        return;
                    }

                    if (this.$state.current.name === "auth.Manifests.Update.ConsignmentImport") {
                        this.$state.go("auth.Manifests.Update.ConsignmentImport.Container", { contId: 0 });
                        return;
                    }

                    if (this.isInbound) {
                        this.$state.go("auth.ConsignmentImports.Update.Container", { contId: 0 });
                    } else {
                        this.$state.go("auth.ConsignmentExports.Update.Container", { contId: 0 });
                    }
                }
            }

            DownloadFourKitesCSV(){
                this.bsLoadingOverlayService.wrap({
                    referenceId: 'con.update'
                },
                    () => {
                        this.liveTrackingService.getFourKitesCSVData(this.consignment.Id).then(() => {
                        }, (data) => {
                            this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>data.data);
                        });
                    });
            }

            generatePackingDetail_click() {
                if (this.consignment.CargoTypeId === 4) {
                    this.showContainerSizeModal().then((result) => {                 
                        if (result) {
                            this.bsLoadingOverlayService.wrap({
                                referenceId: 'con.update'
                            }, () => {
                                this.SaveConsignment().then(() => {
                                    return this.generatePackingDetail(result.Id?result.Id:null).then(() => {
                                        this.$timeout(() => {
                                            this.bsLoadingOverlayService.wrap({
                                                referenceId: 'con.update'
                                            }, () => {
                                                return this.loadConsignment();
                                            });
                                        });
                                    });
                                }, () => {
                                    return;
                                });
                            });
                        }
                    });
                } else {
                    this.generalService.displayConfirmationBox("Confirm?", `This will save the consignment and then generate packing details, are you sure?`).then((result) => {
                        if (result) {
                            this.bsLoadingOverlayService.wrap({
                                referenceId: 'con.update'
                            }, () => {
                                this.SaveConsignment().then(() => {
                                    return this.generatePackingDetail().then(() => {
                                        this.$timeout(() => {
                                            this.bsLoadingOverlayService.wrap({
                                                referenceId: 'con.update'
                                            }, () => {
                                                return this.loadConsignment();
                                            });
                                        });
                                    });
                                }, () => {
                                    return;
                                });
                            });
                        }
                    });
                }
            }

            updateProRataTotals_click() {
                this.generalService.displayConfirmationBox("Pro Rata Gross Weight?", `This will pro rata Gross Weight, Net Weight and Cube to all Commercial Invoice Lines from consignment details. Any existing values will be overridden. Are you sure you would like to continue?`).then((result) => {
                    if (result) {
                        this.bsLoadingOverlayService.wrap({
                            referenceId: 'con.update'
                        }, () => {
                            this.SaveConsignment().then(() => {
                                return this.updateProRataTotals().then(() => {
                                    this.$timeout(() => {
                                        this.bsLoadingOverlayService.wrap({
                                            referenceId: 'con.update'
                                        }, () => {
                                            return this.loadConsignment();
                                        });
                                    });
                                });
                            }, () => {
                                return;
                            });
                        });
                    }
                });
            }

            showContainerSizeModal() {
                return this.$uibModal.open({
                    animation: true,
                    size: "lg",
                    template: `<div class="modal-header">
                    <h3 class="modal-title" id="modal-title">Generate Packaging</h3>
                    </div>
                        <div class="modal-body" id="modal-body">
                        <p>
                            This function will generate Consignment and, if applicable, container details.  If no container size is entered container details will not be generated.
                        </p>
                        <p>
                            Warning:  Any existing consignment and container details will be deleted.
                        </p>
                        <form name="inputForm">
                            <gts-dropdown name="containerSize" ng-model="containerSizeCtrl.containerSize" form="inputForm" load-data="containerSizeCtrl.loadContainerISOs()" ></gts-dropdown>
                        </form>
                        </div>
                        <div class="modal-footer">
                        <button class="btn btn-primary" type="button" ng-click="containerSizeCtrl.ok()">Ok</button>
                        <button class="btn btn-info" type="button" ng-click="containerSizeCtrl.cancel()">Close</button>
                        </div>`,
                    controller: class containerSizeCtrl {
                        containerSize: interfaces.applicationcore.IDropdownModel;
                        constructor($scope, private $uibModalInstance: angular.ui.bootstrap.IModalInstanceService, private containerISOService: interfaces.applicationcore.IContainerISOService) {
                        }

                        cancel() {
                            this.$uibModalInstance.dismiss();
                        }

                        ok() {
                            this.$uibModalInstance.close(this.containerSize?this.containerSize:1);
                        }

                        //Load Container ISO.
                        loadContainerISOs(searchText: string) {
                            return this.containerISOService.getContainerISODropdown(searchText).query(
                                () => {

                                }, (failureData) => {
                                }).$promise;
                        }
                    },
                    controllerAs: "containerSizeCtrl",
                    resolve: {
                    }
                }).result;
            }

            generatePackingDetail(containerSizeId?: number) {
                var defer = this.$q.defer();

                this.SaveConsignment().then(() => {
                    this.consignmentDetailService.generatePackaging(this.consignmentID, containerSizeId).save((result: interfaces.applicationcore.IMessageHandler) => {
                        defer.resolve();
                        this.generalService.displayMessageHandler(result);

                    }, (failureData) => {
                        defer.reject();
                        this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                    });
                }, () => {
                    defer.reject();
                });

                return defer.promise;
            }

            savePackingList() {
                var defer = this.$q.defer();

                var packingList: Array<interfaces.consignment.IConsignmentDetailPacking>;

                if (this.apiCOPACK && this.apiCOPACK.rowEdit.getDirtyRows().length > 0) {
                    packingList = _.map(this.apiCOPACK.rowEdit.getDirtyRows(), (o) => {
                        return o.entity;
                    });
                } else {
                    defer.resolve();
                    return defer.promise;
                }

                this.consignmentDetailService.updatePackingList().save((packingList), (result: interfaces.applicationcore.IMessageHandler) => {
                    defer.resolve();
                    this.generalService.displayMessageHandler(result);

                    if (this.apiCOPACK)
                        this.apiCOPACK.rowEdit.setRowsClean(packingList);

                    this.editingPacking = true;

                }, (failureData) => {
                    defer.reject();
                    this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                    this.editingPacking = true;
                });

                return defer.promise;
            }

            updateProRataTotals() {
                var defer = this.$q.defer();

                this.SaveConsignment().then(() => {
                    this.consignmentDetailService.updateProRataTotals(this.consignmentID).save((result: interfaces.applicationcore.IMessageHandler) => {
                        this.generalService.displayMessageHandler(result);

                        if (!result.HasErrorMessage) {
                            this.$timeout(() => {
                                this.bsLoadingOverlayService.wrap({
                                    referenceId: 'con.update'
                                }, () => {
                                    return this.loadConsignment();
                                });
                            });
                        }
                    }, (failureData) => {
                        this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                    });
                }, () => {
                    defer.reject();
                });

                return defer.promise;
            }

            removePackingDetail(entity: interfaces.consignment.IConsignmentDetailPacking) {
                if (entity && entity.IsNew) {
                    _.remove(this.gvwCOD.data, (o) => {
                        return o === entity;
                    });
                } else if (entity) {

                    this.bsLoadingOverlayService.wrap({
                        referenceId: 'con.update'
                    }, () => {
                        return this.consignmentDetailService.deletePacking(entity.CommercialInvoiceSKUId, entity.CommercialInvoiceItemTrackingId, entity.ContainerConsignmentInvoiceDetailId).delete((result) => {
                            this.loadConsignmentDetailPacking();
                        }, (errorResponse) => {
                            this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                        });
                    });

                }
            }

            addInlinePackingDetail() {
                var selectedRow = <interfaces.consignment.IConsignmentDetailPacking>this.apiCOPACK.selection.getSelectedRows()[0];

                if (selectedRow) {
                    var packing = {
                        IsNew: true,
                        CommercialInvoiceSKUId: selectedRow.CommercialInvoiceSKUId,
                        SKUCode: selectedRow.SKUCode,
                        SKUDescription: selectedRow.SKUDescription,
                        AllocatedQty: 0,
                        LotQty: 0,
                        Qty: selectedRow.Qty,
                        TypeOfPackageDescription: selectedRow.TypeOfPackageDescription,
                        TypeOfPackageCode: selectedRow.TypeOfPackageCode,
                        ConsignmentDetailId: selectedRow.ConsignmentDetailId,
                        DetailNumberOfPackages: 0,
                        EnableItemTracking: selectedRow.EnableItemTracking
                    };
                    (<Array<any>>(this.gvwCOPACK.data)).splice(0, 0, packing);
                }
            }

            SaveConsignment() {
                // Containers
                if (this.apiContainersList && this.apiContainersList.rowEdit.getDirtyRows().length > 0) {
                    this.consignment.ContainersList = _.map(this.apiContainersList.rowEdit.getDirtyRows(), (o) => {
                        return o.entity;
                    });
                } else {
                    this.consignment.ContainersList = [];
                }

                //Consignment Documents
                if (this.apiConDocList && this.apiConDocList.rowEdit.getDirtyRows().length > 0) {
                    this.consignment.ConsignmentDocumentList = _.map(this.apiConDocList.rowEdit.getDirtyRows(), (o) => {
                        return o.entity;
                    });
                } else {
                    this.consignment.ConsignmentDocumentList = [];
                }

                //Customs Detail
                if (this.apiCustomsList && this.apiCustomsList.rowEdit.getDirtyRows().length > 0) {
                    this.consignment.ConsignmentCustomsDetailList = _.map(this.apiCustomsList.rowEdit.getDirtyRows(), (o) => {
                        return o.entity;
                    });
                } else {
                    if (this.apiTransList && this.apiTransList.rowEdit.getDirtyRows().length > 0) {
                        this.consignment.ConsignmentCustomsDetailList = _.map(this.apiTransList.rowEdit.getDirtyRows(), (o) => {
                            return o.entity;
                        });
                    } else {
                        this.consignment.ConsignmentCustomsDetailList = [];
                    }
                }

                //Detail
                if (this.apiCOD && this.apiCOD.rowEdit.getDirtyRows().length > 0) {
                    this.consignment.ConsignmentDetailList = _.map(this.apiCOD.rowEdit.getDirtyRows(), (o) => {
                        return o.entity;
                    });
                } else {
                    this.consignment.ConsignmentDetailList = [];
                }

                //P&R
                if (this.apiPRList && this.apiPRList.rowEdit.getDirtyRows().length > 0) {
                    this.consignment.ConsignmentPRList = _.map(this.apiPRList.rowEdit.getDirtyRows(), (o) => {
                        return o.entity;
                    });
                } else {
                    this.consignment.ConsignmentPRList = [];
                }

                return this.consignmentService.update().save((this.consignment), (result: interfaces.applicationcore.IMessageHandler) => {
                    if (!result.HasErrorMessage) {
                        if (this.apiCOD)
                            this.apiCOD.rowEdit.setRowsClean(this.consignment.ConsignmentDetailList);

                        if (this.apiCustomsList)
                            this.apiCustomsList.rowEdit.setRowsClean(this.consignment.ConsignmentCustomsDetailList);

                        if (this.apiContainersList)
                            this.apiContainersList.rowEdit.setRowsClean(this.consignment.ContainersList);

                        if (this.apiConDocList)
                            this.apiConDocList.rowEdit.setRowsClean(this.consignment.ConsignmentDocumentList);

                        if (this.apiPRList)
                            this.apiPRList.rowEdit.setRowsClean(this.consignment.ConsignmentPRList);
                    }

                    this.$anchorScroll("topAnchor");
                }, (failureData) => {
                    this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                    this.$anchorScroll("topAnchor");
                }).$promise;
            }

            editCommercialInvoice(comInvoiceId: number) {
                if (!comInvoiceId) {
                    return;
                }

                if (this.$stateParams.manId) {
                    if (this.consignment.IsInbound) {
                        this.$state.go("auth.Manifests.Update.ConsignmentImport.CommercialInvoice", { comId: comInvoiceId });
                    } else {
                        this.$state.go("auth.Manifests.Update.ConsignmentExport.CommercialInvoice", { comId: comInvoiceId });
                    }
                } else {

                    if (this.consignment.IsInbound) {
                        this.$state.go("auth.ConsignmentImports.Update.CommercialInvoice", { comId: comInvoiceId });
                    } else {
                        this.$state.go("auth.ConsignmentExports.Update.CommercialInvoice", { comId: comInvoiceId });
                    }
                }
            }

            poWizzard() {
                if (this.apiCIList && this.apiCIList.selection.getSelectedRows().length > 0) {
                    var selected = this.apiCIList.selection.getSelectedRows()[0];

                    if (this.$stateParams.manId) {
                        if (this.consignment.IsInbound) {
                            this.$state.go("auth.Manifests.Update.ConsignmentImport.POWizard", { conId: this.consignmentID, supId: selected.SupplierId, conType: this.consignment.ConsignmentTypeId });
                        } else {
                            this.$state.go("auth.ConsignmentExports.SaleOrder", { conId: this.consignmentID });
                        }
                    }
                    else
                    {
                        if (this.consignment.IsInbound) {
                            this.$state.go("auth.ConsignmentImports.Update.PurchaseOrder", { conId: this.consignmentID, supId: selected.SupplierId, conType: this.consignment.ConsignmentTypeId });
                        } else {
                            this.$state.go("auth.ConsignmentExports.SaleOrder", { conId: this.consignmentID });
                        }
                    }

                } else {
                    this.apiCIList.selection.selectRow(this.gCIList.data[0]);

                    if (this.apiCIList && this.apiCIList.selection.getSelectedRows().length > 0) {
                        var selected = this.apiCIList.selection.getSelectedRows()[0];


                        if (this.$stateParams.manId) {
                            if (this.consignment.IsInbound) {
                                this.$state.go("auth.Manifests.Update.ConsignmentImport.POWizard", { conId: this.consignmentID, supId: selected.SupplierId, conType: this.consignment.ConsignmentTypeId });
                            } else {
                                this.$state.go("auth.ConsignmentExports.SaleOrder", { conId: this.consignmentID });
                            }                            
                        }
                        else
                        {
                            if (this.consignment.IsInbound) {
                                this.$state.go("auth.ConsignmentImports.Update.PurchaseOrder", { conId: this.consignmentID, supId: selected.SupplierId, conType: this.consignment.ConsignmentTypeId });
                            } else {
                                this.$state.go("auth.ConsignmentExports.SaleOrder", { conId: this.consignmentID });
                            }
                        }
                    }
                }
            }

            gCIList: uiGrid.IGridOptions = {
                data: [],
                enableFiltering: true,
                //useExternalFiltering: true,
                enableCellEdit: false,
                useExternalSorting: true,
                multiSelect: false,
                enableColumnResizing: true,
                enableFullRowSelection: true,
                enablePagination: false,
                enablePaginationControls: false,
                paginationPageSizes: [25, 50, 75, 100],
                paginationPageSize: 25,
                useExternalPagination: false,
                enableRowHeaderSelection: false,
                showGridFooter: true,
                enableHorizontalScrollbar: 2,
                enableVerticalScrollbar: 1,
                rowEditWaitInterval: -1,
                cellEditableCondition: () => { return this.consignmentTypeDefaults.AllowInvoiceNumberDateOverride},                
                onRegisterApi: (gridApi) => { this.registerGridApi(gridApi) },
                columnDefs: [{
                    name: "EDIT",
                    displayName: "",
                    enableFiltering: false,
                    cellTemplate: `
                    <div> 
                        <button type="button" ng-click="grid.appScope.consignmentUpdateCtrl.editCommercialInvoice(row.entity.Id)" class="btn btn-default btn-sm">
                            <span class="fa fa-pencil"></span>
                        </button>
                    </div>`,
                    enableSorting: false,
                    enableColumnMenu: false,
                    width: 35
                }, {
                    name: "InvoiceNumber",
                    displayName: "Invoice Number",
                    field: "InvoiceNumber",
                    width: 120,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                </div>\
                            </div>`,
                    enableCellEdit: true,
                    cellTemplate: `<div class="ui-grid-cell-contents">{{MODEL_COL_FIELD}}</div>`,
                    editableCellTemplate: `
                        <form name = "inputForm">
                            <p class="input-group-sm">
                                <input type="text" name="InvoiceNumber-{{MODEL_COL_FIELD.$$hashKey}}" ng-model="MODEL_COL_FIELD" class="form-control" ui-grid-editor step = "0.01" />
                            </p>
                        </form>`,
                    enableCellEditOnFocus: true                            
                }, {
                    name: "InvoiceDate",
                    displayName: "Invoice Date",
                    cellFilter: 'momentDateFilter:"YYYY/MM/DD"',
                    field: "InvoiceDate",
                    width: 120,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                </div>
                            </div>`,
                    type: "string",
                    cellClass: 'text-right',
                    enableCellEdit: true,
                    cellTemplate: `<div class="ui-grid-cell-contents">{{MODEL_COL_FIELD | momentDateFilter: 'YYYY/MM/DD'}}</div>`,
                    editableCellTemplate: `
                        <form name="inputForm">
                            <gts-date format="yyyy/MM/dd" ng-model="MODEL_COL_FIELD" name="LRNDate-{{MODEL_COL_FIELD.$$hashKey}}"></gts-date>
                        </form>`,
                    enableCellEditOnFocus: true                            
                }, {
                    name: "Supplier",
                    displayName: "Supplier",
                    field: "Supplier",
                    width: 200,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                </div>
                            </div>`
                }, {
                    name: "Customer",
                    displayName: "Customer Name",
                    field: "Customer",
                    width: 150,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                </div>
                            </div>`
                }, {
                    name: "Reference",
                    displayName: "Reference",
                    field: "Reference",
                    width: 150,
                    visible: !this.$stateParams.IsInbound,
                    filterHeaderTemplate: `
                        <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                            <div class="input-group-sm">
                                <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD}}"/>
                            </div>
                        </div>`
                }, {
                    name: "Incoterm",
                    displayName: "Incoterm",
                    field: "Incoterm",
                    width: 220,
                    filterHeaderTemplate: `
                        <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                            <div class="input-group-sm">
                                <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                            </div>
                        </div>`
                }, {
                    name: "CurrencyCode",
                    displayName: "Currency",
                    field: "CurrencyCode",
                    width: 100,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                </div>
                            </div>`
                }, {
                    name: "TotalInvoiceValue",
                    displayName: "Total Value",
                    field: "TotalInvoiceValue",
                    width: 100,
                    cellClass: 'text-right',
                    cellFilter: "number: 2",
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                </div>
                            </div>`
                }, {
                    name: "TotalVAT",
                    displayName: "Total VAT",
                    field: "TotalVAT",
                    width: 100,
                    cellClass: 'text-right',
                    cellFilter: 'number: 2',
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                </div>
                            </div>`
                },]
            };

            registerGridApi(gridApi: uiGrid.IGridApi) {
                this.apiCIList = gridApi;
                this.apiCIList.pagination.on.paginationChanged(this.$scope, (newPage, pageSize) => { this.CIListPageChange(newPage, pageSize) });

                this.apiCIList.selection.on.rowSelectionChanged(this.$scope, (selected) => { this.selectedCI = selected; });

                this.$timeout(() => {
                    if (this.selectedCI)
                        this.apiCIList.selection.selectRow(this.selectedCI.entity);
                });
            }

            CIListPageChange(newPage, pageSize) {
                this.paginationOptions.pageNumber = newPage;
                this.paginationOptions.pageSize = pageSize;
            }

            refreshConsignmentAddresses_click() {
                this.generalService.displayConfirmationBox("Refresh Addresses", "Would you like to refresh Consignment and Commercial Invoice Addresses?").then(
                    (result) => {
                        if (result) {
                            this.bsLoadingOverlayService.wrap({
                                referenceId: 'con.update'
                            }, () => {
                                return this.SaveConsignment().then((result) => {
                                    this.generalService.displayMessageHandler(result);

                                    if (!result.HasErrorMessage) {
                                        this.$timeout(() => {
                                            this.bsLoadingOverlayService.wrap({
                                                referenceId: 'con.update'
                                            }, () => {
                                                return this.refreshConsignmentAddresses().then((result) => {

                                                    if (!result.HasErrorMessage) {
                                                        this.$timeout(() => {
                                                            this.bsLoadingOverlayService.wrap({
                                                                referenceId: 'con.update'
                                                            }, () => {
                                                                return this.loadConsignment();
                                                            });
                                                        });
                                                    }
                                                });
                                            });
                                        });
                                    }
                                });
                            });
                        }
                    }, () => {

                    }
                );
            }

            refreshConsignmentAddresses() {
                return this.consignmentService.refreshConsignmentAddresses(this.consignment.Id).save((result) => {
                    this.generalService.displayMessageHandler(result);
                    this.$anchorScroll("topAnchor");
                }, (failureData) => {
                    this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                    this.$anchorScroll("topAnchor");
                }).$promise;
            }

            updateConsignmentComments_click() {
                this.generalService.displayConfirmationBox("Confirm", "Any comments will be overwritten, do you want to continue?").then(
                    (result) => {
                        if (result) {
                            this.bsLoadingOverlayService.wrap({
                                referenceId: 'con.update'
                            }, () => {
                                return this.SaveConsignment().then((result) => {
                                    this.generalService.displayMessageHandler(result);

                                    if (!result.HasErrorMessage) {
                                        this.$timeout(() => {
                                            this.bsLoadingOverlayService.wrap({
                                                referenceId: 'con.update'
                                            }, () => {
                                                return this.updateConsignmentComments().then((result) => {
                                                    if (!result.HasErrorMessage) {
                                                        this.$timeout(() => {
                                                            this.bsLoadingOverlayService.wrap({
                                                                referenceId: 'con.update'
                                                            }, () => {
                                                                return this.loadConsignment();
                                                            });
                                                        });
                                                    }
                                                });
                                            });
                                        });
                                    }
                                });
                            });
                        }
                    }, () => {

                    }
                );
            }

            updateConsignmentComments() {
                return this.consignmentService.generateConsignmentComments(this.consignment.Id).save((result) => {
                    this.generalService.displayMessageHandler(result);
                    this.$anchorScroll("topAnchor");
                }, (failureData) => {
                    this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                    this.$anchorScroll("topAnchor");
                }).$promise;
            }


            refreshFromSalesOrder_click() {
                if (this.apiCIList && this.apiCIList.selection.getSelectedRows().length > 0) {

                    var selected = this.apiCIList.selection.getSelectedRows()[0];

                    this.bsLoadingOverlayService.wrap({
                        referenceId: 'con.update'
                    },
                        () => {
                            this.SaveConsignment().then(() => {
                                return this.commercialInvoiceService.refreshFromSalesOrder().save(
                                    { comId: selected.Id }, (response) => {
                                        this.generalService.displayMessageHandler(response);

                                        if (!response.HasErrorMessage) {
                                            this.$timeout(() => {
                                                this.bsLoadingOverlayService.wrap({
                                                    referenceId: 'con.update'
                                                }, () => {
                                                    return this.loadConsignment();
                                                });
                                            });
                                        }
                                    }, (errorResponse) => {
                                        this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                                    });
                            }, () => {
                                return;
                            });
                        });

                } else {
                    this.generalService.displayMessage("Please select a commercial invoice", Enum.EnumMessageType.Warning);
                }
            }

            refreshFromDeliveryInstruction_click() {
                if (this.apiCIList && this.apiCIList.selection.getSelectedRows().length > 0) {

                    var selected = this.apiCIList.selection.getSelectedRows()[0];

                    this.bsLoadingOverlayService.wrap({
                        referenceId: 'con.update'
                    },
                        () => {
                            this.SaveConsignment().then(() => {
                                return this.commercialInvoiceService.refreshFromDeliveryInstruction().save(
                                    { comId: selected.Id }, (response) => {
                                        this.generalService.displayMessageHandler(response);

                                        if (!response.HasErrorMessage) {
                                            this.$timeout(() => {
                                                this.bsLoadingOverlayService.wrap({
                                                    referenceId: 'con.update'
                                                }, () => {
                                                    return this.loadConsignment();
                                                });
                                            });
                                        }
                                    }, (errorResponse) => {
                                        this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                                    })
                            }, () => {
                                return;
                            });
                        });

                } else {
                    this.generalService.displayMessage("Please select a commercial invoice", Enum.EnumMessageType.Warning);
                }
            }

            tradeAgreementWizard_click() {
                if (this.apiCIList && this.apiCIList.selection.getSelectedRows().length > 0) {

                    var selected = this.apiCIList.selection.getSelectedRows()[0];

                    this.showTradeAgreementModal().then((data) => {
                        if (data) {
                            this.bsLoadingOverlayService.wrap({
                                referenceId: 'con.update'
                            },
                                () => {
                                    this.SaveConsignment().then(() => {
                                        return this.commercialInvoiceService.commercialInvoiceTradeAgreementWizard(selected.Id, data.declarationCountryId, data.countryGroupId,
                                            data.originCriteriaId, data.preferenceCodeId, data.overrideExisting, data.uploadProductMaster).save((response) => {
                                                this.generalService.displayMessageHandler(response);

                                                if (!response.HasErrorMessage) {
                                                    this.$timeout(() => {
                                                        this.bsLoadingOverlayService.wrap({
                                                            referenceId: 'con.update'
                                                        }, () => {
                                                            return this.loadConsignment();
                                                        });
                                                    });
                                                }
                                            }, (errorResponse) => {
                                                this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                                            });
                                    }, () => {
                                        return;
                                    });
                                });
                        }
                    }, () => {

                    });

                } else {
                    this.generalService.displayMessage("Please select a commercial invoice", Enum.EnumMessageType.Warning);
                }
            }

            showTradeAgreementModal() {
                return this.$uibModal.open({
                    animation: true,
                    template: `<div class="modal-content">
                                <div class="modal-header">
                                    <h3 class="modal-title" id="modal-title">Trade Agreement Wizard</h3>
                                </div>
                                <div class="modal-body" id="modal-body">
                                    <gts-message-display messages="Messages"></gts-message-display>
                                    <form name="trade">
                                        <div class="row">
                                            <div class="vertical-align">
                                                <div class="col-md-4">
                                                    <req></req>
                                                    <label>Country of Declaration</label>
                                                </div>
                                                <div class="col-md-8">
                                                    <gts-dropdown name="decCountry" ng-model="decCountry" form="trade" load-data="loadLoadingCountry()" required="true" ng-change="decCountryChange(model)"></gts-dropdown>
                                                </div>
                                            </div>
                                            <div class="vertical-align">
                                                <div class="col-md-4">
                                                    <req></req>
                                                    <label>Country Group</label>
                                                </div>
                                                <div class="col-md-8">
                                                    <gts-dropdown name="groupCountry" ng-model="groupCountry" form="trade" load-data="loadCountryGroups()" required="true" list="countryGroupList" ng-change="originCriteriaList = undefined; orgCriteria = undefined;"></gts-dropdown>
                                                </div>
                                            </div>
                                            <div class="vertical-align">
                                                <div class="col-md-4">
                                                    <opt></opt>
                                                    <label>Origin Criteria</label>
                                                </div>
                                                <div class="col-md-8">
                                                    <gts-dropdown name="orgCriteria" ng-model="orgCriteria" form="trade" load-data="loadCountryOrigins()" required="false" list="originCriteriaList"></gts-dropdown>
                                                </div>
                                            </div>
                                            <div class="vertical-align">
                                                <div class="col-md-4">
                                                    <opt></opt>
                                                    <label>Preference Code</label>
                                                </div>
                                                <div class="col-md-8">
                                                    <gts-dropdown name="prefCode" ng-model="prefCode" form="trade" load-data="loadPreferenceCodes()" required="false" list="prefCodeList"></gts-dropdown>
                                                </div>
                                            </div>
                                            <div class="vertical-align">
                                                <div class="col-md-4">
                                                    <opt></opt>
                                                    <label>Override Existing?</label>
                                                </div>
                                                <div class="col-md-8">
                                                    <p class="input-group-sm">
                                                        <input type="checkbox" ng-model="overrideExisting">
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="vertical-align">
                                                <div class="col-md-4">
                                                    <opt></opt>
                                                    <label>Upload to Product Master?</label>
                                                </div>
                                                <div class="col-md-8">
                                                    <p class="input-group-sm">
                                                        <input type="checkbox" ng-model="uploadProductMaster">
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div class="modal-footer">
                                    <button class="btn btn-primary" type="button" ng-click="ok()" ng-disabled="!decCountry || !groupCountry">OK</button>
                                    <button class="btn btn-info" type="button" ng-click="cancel()">Cancel</button>
                                </div>
                            </div>`,
                    controller: ($scope, $uibModalInstance: angular.ui.bootstrap.IModalInstanceService, tariffCountryGroupService: interfaces.tariff.ITariffCountryGroupService,
                        tariffCountryGroupOriginService: interfaces.tariff.ITariffCountryGroupOriginService, tariffPreferenceCodeService: interfaces.tariff.ITariffPreferenceCodeService,
                        defaultDestinationCountry,
                        targetCountry) => {
                        $scope.loadLoadingCountry = () => { return this.loadLoadingCountry() };


                        $scope.decCountry = defaultDestinationCountry;


                        $scope.decCountryChange = () => {
                            $scope.countryGroupList = undefined;
                            $scope.groupCountry = undefined;
                            $scope.prefCodeList = undefined;
                            $scope.prefCode = undefined;
                        };

                        $scope.countryGroupList = [];
                        $scope.loadCountryGroups = () => {

                            if ($scope.decCountry) {
                                return tariffCountryGroupService.getForDropDownByTargetCountry($scope.decCountry.Id, targetCountry.Id).query(() => {

                                }, (errorResponse) => {
                                    this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data, $scope);
                                }).$promise;
                            } else {
                                var defer = this.$q.defer();
                                defer.resolve([]);
                                return defer.promise;
                            }
                        };

                        $scope.originCriteriaList = [];
                        $scope.loadCountryOrigins = () => {
                            if ($scope.groupCountry) {
                                return tariffCountryGroupOriginService.getDropdownList().query({
                                    countryGroupId: $scope.groupCountry.Id
                                }, () => {

                                }, (errorResponse) => {
                                    this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data, $scope);
                                }).$promise;
                            } else {
                                var defer = this.$q.defer();
                                defer.resolve([]);
                                return defer.promise;
                            }
                        };

                        $scope.prefCodeList = [];
                        $scope.loadPreferenceCodes = () => {
                            if ($scope.decCountry) {
                                return tariffPreferenceCodeService.getDropdownList().query({
                                    tariffCountryId: $scope.decCountry.Id
                                }, () => {

                                }, (errorResponse) => {
                                    this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data, $scope);
                                }).$promise;
                            } else {
                                var defer = this.$q.defer();
                                defer.resolve([]);
                                return defer.promise;
                            }
                        };

                        $scope.ok = () => {
                            $uibModalInstance.close({
                                declarationCountryId: $scope.decCountry.Id,
                                countryGroupId: $scope.groupCountry.Id,
                                originCriteriaId: $scope.orgCriteria ? $scope.orgCriteria.Id : undefined,
                                preferenceCodeId: $scope.prefCode ? $scope.prefCode.Id : undefined,
                                overrideExisting: $scope.overrideExisting,
                                uploadProductMaster: $scope.uploadProductMaster
                            });
                        };

                        $scope.cancel = () => {
                            $uibModalInstance.dismiss(false);
                        };
                    },
                    resolve: {
                        defaultDestinationCountry: (this.consignment.IsInbound) ? this.consignment.UnloadingCountry : this.consignment.LoadingCountry,
                        targetCountry: (this.consignment.IsInbound) ? this.consignment.LoadingCountry : this.consignment.UnloadingCountry,
                    }
                }).result;
            }

            convertUnitOfMeasure_click() {
                if (this.apiCIList && this.apiCIList.selection.getSelectedRows().length > 0) {

                    var selected = this.apiCIList.selection.getSelectedRows()[0];

                    this.showConvertUnitOfMeasureModal().then((data) => {
                        if (data) {
                            this.bsLoadingOverlayService.wrap({
                                referenceId: 'con.update'
                            },
                                () => {
                                    this.SaveConsignment().then(() => {
                                        return this.commercialInvoiceService.commercialInvoiceConvertUoM(data.isConvertUoM, selected.Id, data.uomId).save((response) => {
                                            this.generalService.displayMessageHandler(response);

                                            if (!response.HasErrorMessage) {
                                                this.$timeout(() => {
                                                    this.bsLoadingOverlayService.wrap({
                                                        referenceId: 'con.update'
                                                    }, () => {
                                                        return this.loadConsignment();
                                                    });
                                                });
                                            }
                                        }, (errorResponse) => {
                                            this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                                        });
                                    }, () => {
                                        return;
                                    });
                                });
                        }
                    }, () => {

                    });

                } else {
                    this.generalService.displayMessage("Please select a commercial invoice", Enum.EnumMessageType.Warning);
                }
            }

            showConvertUnitOfMeasureModal() {
                return this.$uibModal.open({
                    animation: true,
                    template: `<div class="modal-content">
                                <div class="modal-header">
                                    <h3 class="modal-title" id="modal-title">Convert Unit of Measure</h3>
                                </div>
                                <div class="modal-body" id="modal-body">
                                    <gts-message-display messages="Messages"></gts-message-display>
                                    <form name="trade">
                                        <div class="row">
                                            <div class="vertical-align">
                                                <div class="col-md-12">
                                                    <p> This utility will convert either the price or order unit of measure for the entire selected invoice. If you convert the price unit of measure, the prices will also be converted accordingly. </p>
                                                </div>
                                            </div>
                                            <div class="vertical-align">
                                                <div class="col-md-6">
                                                    <req></req>
                                                    <label>Convert Price / Order Unit of Measure</label>
                                                </div>
                                                <div class="col-md-6">
                                                    <p class="input-group-sm">
                                                        <select class="form-control" ng-model="isConvertUoM">
                                                            <option ng-value="true" selected>
                                                                Order Unit of Measure
                                                            </option>
                                                            <option ng-value="false">
                                                                Price Unit of Measure
                                                            </option>
                                                        </select>
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="vertical-align">
                                                <div class="col-md-6">
                                                    <req></req>
                                                    <label>Convert Unit of Measure to</label>
                                                </div>
                                                <div class="col-md-6">
                                                    <gts-dropdown name="uom" ng-model="uom" form="trade" load-data="loadUoMs()" required="true"></gts-dropdown>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div class="modal-footer">
                                    <button class="btn btn-primary" type="button" ng-click="ok()" ng-disabled="!uom">OK</button>
                                    <button class="btn btn-info" type="button" ng-click="cancel()">Cancel</button>
                                </div>
                            </div>`,
                    controller: ($scope, $uibModalInstance: angular.ui.bootstrap.IModalInstanceService, unitOfMeasureService: interfaces.master.IUnitOfMeasureService) => {
                        $scope.isConvertUoM = true;
                        $scope.loadUoMs = () => {
                            return unitOfMeasureService.getUoMDropdown().query({
                                ownerEntityId: this.consignment.OwnerEntityId
                            }, () => {

                            }, (errorResponse) => {
                                this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data, $scope);
                            }).$promise;
                        };

                        $scope.ok = () => {
                            $uibModalInstance.close({
                                isConvertUoM: $scope.isConvertUoM,
                                uomId: $scope.uom.Id
                            });
                        };

                        $scope.cancel = () => {
                            $uibModalInstance.dismiss(false);
                        };
                    },
                    resolve: {
                    }
                }).result;
            }

            taCertificateAllocation_click() {
                if (this.apiCIList && this.apiCIList.selection.getSelectedRows().length > 0) {

                    var selected = this.apiCIList.selection.getSelectedRows()[0];

                    this.bsLoadingOverlayService.wrap({
                        referenceId: 'con.update'
                    },
                        () => {
                            return this.SaveConsignment().then(() => {
                                return this.commercialInvoiceService.containCertificate(selected.Id).get((response) => {
                                    if (response.value) {
                                        this.existingCertificates(selected.Id);
                                    } else {
                                        this.noExistingCertificates(selected.Id);
                                    }
                                }, (errorResponse) => {
                                    this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                                });
                            }, () => {
                                return;
                            });
                        });

                } else {
                    this.generalService.displayMessage("Please select a commercial invoice", Enum.EnumMessageType.Warning);
                }

            }

            noExistingCertificates(comId: number) {
                this.generalService.displayConfirmationBox("Confirm", "You are about to allocate certificate numbers. Would you like to continue?").then((data) => {
                    if (data) {
                        this.bsLoadingOverlayService.wrap({
                            referenceId: 'con.update'
                        },
                            () => {
                                return this.consignmentService.allocateCertificateNumbers(this.consignment.Id, comId).save((response) => {
                                    this.generalService.displayMessageHandler(response);

                                    if (!response.HasErrorMessage) {
                                        this.$timeout(() => {
                                            this.bsLoadingOverlayService.wrap({
                                                referenceId: 'con.update'
                                            }, () => {
                                                return this.loadConsignment();
                                            });
                                        });
                                    }

                                }, (errorResponse) => {
                                    this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                                }).$promise;
                            });
                    }
                }, () => {

                });
            }

            existingCertificates(comId: number) {
                this.generalService.displayConfirmationBox("Confirm", "There are certificates allocated to the commercial invoice. Re-allocating certificates to this commercial invoice will cancel these certificates if they are printed or reallocate a new number if they are not printed. Are you sure you want to Re-Allocate certificates?").then((data) => {
                    if (data) {
                        this.showCertificateCancellationModal(comId).then((result) => {
                            if (result) {
                                this.reallocateCertificates(comId, result.currentCertificateId? result.currentCertificateId:0, result.documentType, result.newCertificateNumber?result.newCertificateNumber:'', result.cancellationReason, result.cancelAll?result.cancelAll:false);
                            }
                        });
                    }
                }, () => {

                });
            }

            cancelAllCertificates(comId: number, cancellationReason: string) {
                this.bsLoadingOverlayService.wrap({
                    referenceId: 'con.update'
                },
                    () => {
                        return this.consignmentService.allocateCertificateNumbers(this.consignment.Id, comId, cancellationReason).save((response) => {
                            this.generalService.displayMessageHandler(response);

                            if (!response.HasErrorMessage) {
                                this.$timeout(() => {
                                    this.bsLoadingOverlayService.wrap({
                                        referenceId: 'con.update'
                                    }, () => {
                                        return this.loadConsignment();
                                    });
                                });
                            }

                        }, (errorResponse) => {
                            this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                        }).$promise;
                    });
            }

            reallocateCertificates(comId: number, currentCertificateId: number, documentType: number, newCertificateNumber: string, cancellationReason: string, cancelAll: boolean) {
                this.bsLoadingOverlayService.wrap({
                    referenceId: 'con.update'
                },
                    () => {
                        return this.consignmentService.reallocateCertificateNumbers(currentCertificateId, newCertificateNumber, comId, cancellationReason, documentType, cancelAll).save((response) => {
                            this.generalService.displayMessageHandler(response);

                            if (!response.HasErrorMessage) {
                                this.$timeout(() => {
                                    this.bsLoadingOverlayService.wrap({
                                        referenceId: 'con.update'
                                    }, () => {
                                        if (cancelAll){
                                            //Auto-allocate certificates after Cancel All
                                            return this.noExistingCertificates(comId);
                                        }else
                                        {
                                            return this.loadConsignment();
                                        }
                                    });
                                });
                            }

                        }, (errorResponse) => {
                            this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                        }).$promise;
                    });
            }

            showCertificateCancellationModal(comId: number) {
                return this.$uibModal.open({
                    animation: true,
                    template: `<div class="modal-content">
                                <div class="modal-header">
                                    <h3 class="modal-title" id="modal-title">Re-allocate Certificates</h3>
                                </div>
                                <div class="modal-body" id="modal-body">
                                    <gts-message-display messages="Messages"></gts-message-display>
                                    <form name="trade">
                                        <div class="row">
                                            <div class="vertical-align">
                                                <div class="col-md-6">
                                                    <opt></opt>
                                                    <label>Certificate Type</label>
                                                </div>
                                                <div class="col-md-6">
                                                    <gts-dropdown name="certType" ng-model="certType" form="trade" load-data="loadCertTypes()" required="false" ng-change="certTypeChanged(model)"></gts-dropdown>
                                                </div>
                                            </div>
                                            <div class="vertical-align">
                                                <div class="col-md-6">
                                                    <opt></opt>
                                                    <label>Cancel All</label>
                                                </div>
                                                <div class="col-md-6">
                                                 <p class="input-group-sm">
                                                    <input type="checkbox" ng-model="cancelAll" ng-change="certTypeChanged(model)">
                                                </p>
                                                </div>
                                            </div>                                            
                                            <div class="vertical-align">
                                                <div class="col-md-6">
                                                    <opt></opt>
                                                    <label>Certificate Number</label>
                                                </div>
                                                <div class="col-md-6">
                                                    <gts-dropdown name="certNumber" ng-disabled="cancelAll" ng-model="certNumber" form="trade" load-data="loadCertNumbers()" required="false" list="certNumbers"></gts-dropdown>
                                                </div>
                                            </div>
                                            <div class="vertical-align">
                                                <div class="col-md-6">
                                                    <opt></opt>
                                                    <label>Certificate Number To</label>
                                                </div>
                                                <div class="col-md-6">
                                                    <gts-dropdown name="certNumberTo"  ng-disabled="cancelAll" ng-model="certNumberTo" form="trade" load-data="loadAvailableCertNumbers(searchText)" pagination-search="true" refresh-delay="1000" required="false" list="certAvailableNumbers"></gts-dropdown>
                                                </div>
                                            </div>
                                            <div class="vertical-align">
                                                <div class="col-md-6">
                                                    <opt></opt>
                                                    <label>Cancellation Reason</label>
                                                </div>
                                            </div>
                                            <div class="vertical-align">
                                                <div class="col-md-12">
                                                    <p class="input-group-sm has-feedback" ng-class="{'has-error': trade.Reason.$invalid}">
                                                        <textarea rows="3" name="Reason" ng-model="reason" class="form-control" ng-change="changeReason()"></textarea>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div class="modal-footer">
                                    <button class="btn btn-primary" type="button" ng-click="ok()" ng-disabled="!reason || (!cancelAll && (!certType || !certNumber || !certNumberTo))">OK</button>
                                    <button class="btn btn-info" type="button" ng-click="cancel()">Cancel</button>
                                </div>
                            </div>`,
                    controller: ($scope, $uibModalInstance: angular.ui.bootstrap.IModalInstanceService, certificateRegisterDetailService: interfaces.master.ICertificateRegisterDetailService) => {

                        $scope.certTypeChanged = () => {
                            $scope.cancelAll = undefined;
                            $scope.certNumbers = undefined;
                            $scope.certType = undefined;
                            $scope.certNumber = undefined;
                            $scope.certNumberTo = undefined;
                            $scope.certAvailableNumbers = undefined;
                        }

                        $scope.cancelAllChanged = (cancelAll:boolean) =>{
                            $scope.certNumber = undefined;
                            $scope.certNumberTo = undefined;
                        }

                        $scope.loadCertTypes = () => {
                            return this.classificationValueService.GetClassificationValueDropdownByClassification().query({
                                classificationId: 127
                            }, () => {

                            }, (errorResponse) => {
                                this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data, $scope);
                            }).$promise;
                        };

                        $scope.certTypeChanged = () => {
                            $scope.certNumbers = undefined;
                            $scope.certAvailableNumbers = undefined;
                            $scope.certNumber = undefined;
                            $scope.certNumberTo = undefined;
                        };

                        $scope.loadCertNumbers = () => {
                            if ($scope.certType) {
                                return certificateRegisterDetailService.getAllocatedCertificateRegisterDetail(comId, $scope.certType.Id).query().$promise;
                            } else {
                                var defer = this.$q.defer();
                                defer.resolve([]);
                                return defer.promise;
                            }
                        }

                        $scope.loadAvailableCertNumbers = (searchText) => {
                            if ($scope.certType) {
                                var countryId = 0;
                                if (this.consignment.IsInbound && this.consignment.LoadingCountry)
                                    countryId = this.consignment.LoadingCountry.Id
                                if (!this.consignment.IsInbound && this.consignment.UnloadingCountry)
                                    countryId = this.consignment.UnloadingCountry.Id

                                if (countryId > 0)
                                    return certificateRegisterDetailService.GetAvailableCertificateRegisterDetailCountryBased(countryId, searchText, this.consignment.OwnerEntityId, $scope.certType.Id).query().$promise;
                                else
                                    return certificateRegisterDetailService.getAvailableCertificateRegisterDetail(searchText, this.consignment.OwnerEntityId, $scope.certType.Id).query().$promise;
                            } else {
                                var defer = this.$q.defer();
                                defer.resolve([]);
                                return defer.promise;
                            }
                        }

                        $scope.ok = () => {
                            $uibModalInstance.close({
                                currentCertificateId: $scope.certNumber ? $scope.certNumber.Id : undefined,
                                newCertificateNumber: $scope.certNumberTo ? $scope.certNumberTo.Description : undefined,
                                cancellationReason: $scope.reason,
                                documentType: $scope.certType ? $scope.certType.Id : undefined,
                                cancelAll: $scope.cancelAll
                            });
                        };

                        $scope.cancel = () => {
                            $uibModalInstance.dismiss(false);
                        };
                    },
                    resolve: {
                    }
                }).result;
            }

            //Load Shipping Priorities
            public loadShippingPriorities() {
                var defer = this.$q.defer();

                if (this.consignment) {
                    this.shippingPriorityService.getDropdownList().query(
                            { 
                                entityId: this.consignment.OwnerEntityId, 
                                transportModeId: this.consignment.TransportMode?this.consignment.TransportMode.Id:null,
                                IsInbound: this.consignment.IsInbound
                            }, (data) => {
                        defer.resolve(data);
                    }, (errorResponse) => {
                        this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                        defer.resolve([]);
                    });
                } else {
                    defer.resolve([]);
                }

                return defer.promise;
            }

            //Loading Lead Times
            public shippingPriorityChanged(model: interfaces.applicationcore.IDropdownModel) {

                this.consignment.ShippingPriority = model;

                this.bsLoadingOverlayService.wrap({
                    referenceId: 'con.update'
                },
                    () => {
                        return this.loadLeadTimes(this.consignment.RouteCode, model).then(
                            () => {
                                this.calculateLeadTimes(false, this.consignment.EstimateLoadingDate);
                            }
                        );
                    });
            }

            public exportConsignmentCostModelChanged(model: interfaces.applicationcore.IDropdownModel) {

            }

            loadCostingDetail() {

            }

            public CostExportConsignment() {
                if (this.ExportConsignmentCostModel) {
                    this.generalService.displayConfirmationBox("Confirm", "You are about to Cost the Export Consignment. Would you like to continue?").then((data) => {
                        if (data) {
                            this.bsLoadingOverlayService.wrap({
                                referenceId: 'con.update'
                            },
                                () => {
                                    return this.consignmentService.costExportConsignment(this.consignment.Id, this.ExportConsignmentCostModel.Id).save((response) => {
                                        this.generalService.displayMessageHandler(response);

                                        if (!response.HasErrorMessage) {
                                            this.$timeout(() => {
                                                this.bsLoadingOverlayService.wrap({
                                                    referenceId: 'con.update'
                                                }, () => {
                                                    return this.loadConsignment();
                                                });
                                            });
                                        }

                                    }, (errorResponse) => {
                                        this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                                    }).$promise;
                                });
                        }
                    }, () => {

                    });
                }
            }

            //estimateLoadingDateChanged
            public estimateLoadingDateChanged(newValue: moment.Moment) {
                var defer = this.$q.defer();

                this.bsLoadingOverlayService.wrap({
                    referenceId: 'con.update'
                },
                    () => {
                        return this.loadLeadTimes(this.consignment.RouteCode, this.consignment.ShippingPriority).then(
                            () => {
                                this.calculateLeadTimes(false, newValue);
                            }
                        );
                    });

                defer.resolve();
                return defer.promise;
            }

            //Not Promise?
            public estimateLoadingDateChangedNow(newValue: moment.Moment) {
                this.bsLoadingOverlayService.wrap({
                    referenceId: 'con.update'
                },
                    () => {
                        return this.loadLeadTimes(this.consignment.RouteCode, this.consignment.ShippingPriority).then(
                            () => {
                              
                                this.calculateLeadTimes(false, newValue);
                             
                            }
                        );
                    });
            }

            public actualShipByDateDateChanged(newValue: moment.Moment) {
                if (newValue){
                    this.consignment.TransportDocumentDate = newValue;  
                }
            }

            public loadLeadTimes(model: interfaces.applicationcore.IDropdownModel, shippingPriority: interfaces.applicationcore.IDropdownModel) {
                var defer = this.$q.defer();

                if (model && model.Id) {
                    this.routeLeadTimesService.getByRoute().query({ routeId: model.Id, shippingPriorityId: shippingPriority ? shippingPriority.Id : 0 }, (routeLeadTime) => {
                        this.routeLeadTimes = routeLeadTime;
                        defer.resolve();
                    }, (errorResponse) => {
                        this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                    });
                }
                else {
                    this.routeLeadTimes = <interfaces.master.IRouteLeadTimes>{
                        ETA: 0,
                        ShipByDate: 0,
                        CustomsClearedDate: 0,
                        DateToStore: 0,
                        DestinationClearing: 0,
                        RequiredDateOfArrival: 0,
                        RouteId: 0
                    };

                    defer.resolve();
                }

                return defer.promise;
            }

            public calculateLeadTimes(forward: boolean, newValue: moment.Moment) {
                if (!newValue)
                    return;

                if (!this.routeLeadTimes)
                    return;
                
                    

                if (!forward) {
                    //Assign Dates - Before
                    if (this.consignment.ActualLoadingDate != newValue) {
                        this.consignment.EstimateClearanceDate = newValue.clone().add((this.routeLeadTimes.CustomsClearedDate * -1), "day");
                    }

                    //Assign Dates - After
                    this.consignment.EstimateShipByDate = newValue.clone().add((this.routeLeadTimes.ShipByDate * 1), "day");
                    this.consignment.EstimateArrivalDate = this.consignment.EstimateShipByDate.clone().add((this.routeLeadTimes.ETA * 1), "day");
                    this.consignment.EstimatedDestinationClearanceDate = this.consignment.EstimateArrivalDate.clone().add((this.routeLeadTimes.DestinationClearing * 1), "day");
                     
                    if (!this.isInbound)
                        this.consignment.EstimateDestinationWarehouseDate = this.consignment.EstimatedDestinationClearanceDate.clone().add((this.routeLeadTimes.RequiredDateOfArrival * 1), "day");
                    else
                        this.consignment.EstimateDestinationWarehouseDate = this.consignment.EstimateArrivalDate.clone().add((this.routeLeadTimes.RequiredDateOfArrival * 1), "day");

                    this.consignment.EstimateStoreDeliveryDate = this.consignment.EstimateDestinationWarehouseDate.clone().add((this.routeLeadTimes.DateToStore * 1), "day");

                    this.loadConsignmentLeadTimesLockDown();
                }
            }

            insertCIL() {
                this.consignment.ConsignmentCommercialInvoiceList.push(<interfaces.consignment.ICommercialInvoiceDisplay>{

                });
            }

            createNew() {
              if (this.isInbound)
              {
                    if (this.$stateParams.manId) {
                        this.$state.go("auth.Manifests.Update.ConsignmentImport.CommercialInvoiceCreateNew", { consignmentId: Number(this.consignment.Id) });
                    }
                    else
                    {
                        this.$state.go("auth.ConsignmentImports.Update.CommercialInvoiceCreateNew", { consignmentId: Number(this.consignment.Id) });
                    }
                }
                else{
                    this.$state.go("auth.ConsignmentExports.Update.CommercialInvoiceCreateNew", { consignmentId: Number(this.consignment.Id) });
                } 
            }

            vesselSelected(vessel: interfaces.logistics.IVesselLookup) {
                this.consignment.TransportName = vessel.VesselName;
                
                if(vessel.VoyageNumber?.trim())
                {
                    this.consignment.TransportNumber = vessel.VoyageNumber;
                }
                
                if(vessel.VesselCallSign?.trim()){
                    this.consignment.VesselRadioCallSign = vessel.VesselCallSign;
                }
                
                if(vessel.CustomsOperatorCode?.trim()){
                    this.consignment.VesselOperator = vessel.CustomsOperatorCode;
                }

                if (this.consignment.IsInbound){
                    this.consignment.EstimateArrivalDate = vessel.DateOfArrival;
                }
                else
                {
                    this.consignment.EstimateShipByDate = vessel.DateOfDeparture;
                    this.consignment.FromStackDate = vessel.StackOpening;
                    this.consignment.ToStackDate = vessel.StackClosing;
                }

                if(!this.consignment.Terminal && vessel.TerminalId){
                    this.consignment.Terminal = <interfaces.applicationcore.IDropdownModel>{Id:vessel.TerminalId,Code:vessel.TerminalCode,Description:vessel.TerminalName,Display:vessel.TerminalCode + ' - ' + vessel.TerminalName};
                }

                if(this.consignment.IsInbound && !this.consignment.UnloadingLocation)
                {
                    this.consignment.UnloadingLocation = <interfaces.applicationcore.IDropdownModel>{Id:vessel.LoccationId,Code:vessel.LocationCode,Description:vessel.LocationName,Display:vessel.LocationCode + ' - ' + vessel.LocationName};
                }

                if(!this.consignment.IsInbound && !this.consignment.LoadingLocation)
                {
                    this.consignment.LoadingLocation = <interfaces.applicationcore.IDropdownModel>{Id:vessel.LoccationId,Code:vessel.LocationCode,Description:vessel.LocationName,Display:vessel.LocationCode + ' - ' + vessel.LocationName};
                }                

                this.consignment.VesselId = vessel.VesselId;
                this.consignment.VesselScheduleVisitSequence = vessel.VisitId;

            }

            addeditCommercialInvoice_click() {

                if (!this.isInbound) {
                    if (this.gCIList.data.length > 0) {
                        this.$timeout(() => {
                            this.apiCIList.selection.unSelectRow(this.gCIList.data[0]);
                            this.apiCIList.selection.selectRow(this.gCIList.data[0]);
                        })
                    }
                }

                if (this.gCIList.data.length > 0) {
                    if (this.$stateParams.manId) {
                        if (this.isInbound)
                            this.$state.go("auth.ConsignmentImports.PurchaseOrder", { consignmentId: Number(this.consignment.Id), commercialInvoiceId: Number(this.gCIList.data[0].Id) });
                        else
                            this.$state.go("auth.Manifests.Update.ConsignmentExport.AddEditCommercialInvoice", { consignmentId: Number(this.consignment.Id), commercialInvoiceId: Number(this.gCIList.data[0].Id) });
                    }
                    else {
                        if (this.isInbound)
                            this.$state.go("auth.ConsignmentImports.PurchaseOrder", { consignmentId: Number(this.consignment.Id), commercialInvoiceId: Number(this.gCIList.data[0].Id) });
                        else
                            this.$state.go("auth.ConsignmentExports.Update.AddEditCommercialInvoice", { consignmentId: Number(this.consignment.Id), commercialInvoiceId: Number(this.gCIList.data[0].Id) });
                    }

                }
                else {
                    if (this.$stateParams.manId) {
                        if (this.isInbound)
                            this.$state.go("auth.ConsignmentImports.PurchaseOrder", { consignmentId: Number(this.consignment.Id), commercialInvoiceId: 0 });
                        else
                            this.$state.go("auth.Manifests.Update.ConsignmentExport.AddEditCommercialInvoice", { consignmentId: Number(this.consignment.Id), commercialInvoiceId: 0 });
                    }
                    else {
                        if (this.isInbound)
                            this.$state.go("auth.ConsignmentImports.PurchaseOrder", { consignmentId: Number(this.consignment.Id), commercialInvoiceId: 0 });
                        else
                            this.$state.go("auth.ConsignmentExports.Update.AddEditCommercialInvoice", { consignmentId: Number(this.consignment.Id), commercialInvoiceId: 0 });
                    }
                }


            }

            removeCIL() {
                if (this.apiCIList.selection.getSelectedRows().length > 0) {

                    this.generalService.displayConfirmationBox("Confirm Remove", "Are you sure you want to remove this Commercial Invoice Line?").then((result) => {
                        var selectedRow: interfaces.consignment.ICommercialInvoiceDisplay = this.apiCIList.selection.getSelectedRows()[0];
                        if (result && (!selectedRow.Id || selectedRow.Id <= 0)) {
                            _.remove(this.consignment.ConsignmentCommercialInvoiceList, selectedRow);
                        } else if (result) {
                            this.bsLoadingOverlayService.wrap({
                                referenceId: 'con.update'
                            },
                                () => {

                                    return this.commercialInvoiceService.delete(selectedRow.Id).remove((result) => {
                                        this.generalService.displayMessageHandler(result);
                                        if (!result.HasErrorMessage)
                                            return this.loadConsignment();
                                    }, (errorResponse) => {
                                        this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                                    }).$promise;
                                });
                        }
                    });

                } else {
                    this.generalService.displayMessage("Please select a Commercial Invoice Line", Enum.EnumMessageType.Warning);
                }
            }

            printCIDocuments() {
                if (this.apiCIList && this.apiCIList.selection.getSelectedRows().length > 0) {

                    var selected = this.apiCIList.selection.getSelectedRows()[0];

                    if (this.$stateParams.manId) {
                        if (this.consignment.IsInbound) {
                            this.$state.go("auth.Manifests.Update.ConsignmentImport.CommercialInvoice.Documents", { comId: selected.Id });
                        } else {
                            this.$state.go("auth.Manifests.Update.ConsignmentExport.CommercialInvoice.Documents", { comId: selected.Id });
                        }
                    } else {
                        if (this.consignment.IsInbound) {
                            this.$state.go("auth.ConsignmentImports.Update.CommercialInvoice.Documents", { comId: selected.Id });
                        } else {
                            this.$state.go("auth.ConsignmentExports.Update.CommercialInvoice.Documents", { comId: selected.Id });
                        }
                    }

                } else {
                    this.generalService.displayMessage("Please select a commercial invoice", Enum.EnumMessageType.Warning);
                }
            }

            printGDDocuments() {
                if (this.apiGoodsDecList && this.apiGoodsDecList.selection.getSelectedRows().length > 0) {

                    var selected = this.apiGoodsDecList.selection.getSelectedRows()[0];

                    if (this.$stateParams.manId) {
                        if (this.consignment.IsInbound) {
                            this.$state.go("auth.Manifests.Update.ConsignmentImport.GoodsDeclaration.Documents", { gsdId: selected.Id, version: selected.version });
                        } else {
                            this.$state.go("auth.Manifests.Update.ConsignmentExport.GoodsDeclaration.Documents", { gsdId: selected.Id, version: selected.version });
                        }
                    } else {
                        if (this.consignment.IsInbound) {
                            this.$state.go("auth.ConsignmentImports.Update.GoodsDeclaration.Documents", { gsdId: selected.Id, version: selected.version });
                        } else {
                            this.$state.go("auth.ConsignmentExports.Update.GoodsDeclaration.Documents", { gsdId: selected.Id, version: selected.version });
                        }
                    }
                } else {
                    this.generalService.displayMessage("Please select a Goods Declaration", Enum.EnumMessageType.Warning);
                }
            }

            refundClaims() {
                if (this.apiGoodsDecList && this.apiGoodsDecList.selection.getSelectedRows().length > 0) {
                    var selected = this.apiGoodsDecList.selection.getSelectedRows()[0];
                    this.$state.go("auth.ConsignmentExports.Update.RefundClaim", { refId: selected.RefundClaimId });

                } else {
                    this.generalService.displayMessage("Please select a Goods Declaration", Enum.EnumMessageType.Warning);
                }
            }

            printGDCIDocuments() {
                if (this.apiClearInList && this.apiClearInList.selection.getSelectedRows().length > 0) {

                    var selected = this.apiClearInList.selection.getSelectedRows()[0];

                    if (this.consignment.IsInbound) {
                        this.$state.go("auth.ConsignmentImports.Update.GoodsDeclaration.Documents", { gsdId: selected.Id, version: selected.version });
                    } else {
                        this.$state.go("auth.ConsignmentExports.Update.GoodsDeclaration.Documents", { gsdId: selected.Id, version: selected.version });
                    }
                } else {
                    this.generalService.displayMessage("Please select a Clearing Instruction", Enum.EnumMessageType.Warning);
                }
            }

            apportionateConsignmentAlc() {
                this.bsLoadingOverlayService.wrap({
                    referenceId: 'con.update'
                }, () => {
                    return this.SaveConsignment().then(() => {
                        this.consignmentService.apportionateConsignmentALC(this.consignment.Id).save((result: interfaces.applicationcore.IMessageHandler) => {
                            this.generalService.displayMessageHandler(result);

                            if (!result.HasErrorMessage) {
                                this.$timeout(() => {
                                    this.bsLoadingOverlayService.wrap({
                                        referenceId: 'con.update'
                                    }, () => {
                                        return this.loadConsignment();
                                    });
                                });
                            }
                        }, (errorResponse) => {
                            this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                        });
                    }, () => {
                        return;
                    });
                });
            }

            changeAlcStatus(){
                let alcStatusChangeModel : interfaces.consignment.ALCStatusChangeModel = {
                    consignmentId: this.consignment.Id,
                    statusId: this.consignment.CostInvoiceSummary.ALCStatus.Id,
                    varianceReason:this.consignment.CostInvoiceSummary.ALCVarianceReason?this.consignment.CostInvoiceSummary.ALCVarianceReason.Id:null,
                    comments: this.consignment.CostInvoiceSummary.ALCReasonComments
                };

                this.bsLoadingOverlayService.wrap({
                    referenceId: 'con.update'
                }, () => {
                    return this.consignmentService.changeALCStatus().save({},alcStatusChangeModel,(result: interfaces.applicationcore.IMessageHandler) => {
                        this.generalService.displayMessageHandler(result);

                        if (!result.HasErrorMessage) {
                            this.$timeout(() => {
                                this.bsLoadingOverlayService.wrap({
                                    referenceId: 'con.update'
                                }, () => {
                                    return this.loadConsignment();
                                });
                            });
                        }
                    }, (errorResponse) => {
                        this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                    });
                });
            }

            reopenAlc(){
                let alcStatusChangeModel : interfaces.consignment.ALCStatusChangeModel = {
                    consignmentId: this.consignment.Id,
                    statusId: 633,
                    varianceReason:null,
                    comments: this.consignment.CostInvoiceSummary.ALCReasonComments
                };

                this.bsLoadingOverlayService.wrap({
                    referenceId: 'con.update'
                }, () => {
                    return this.consignmentService.changeALCStatus().save({},alcStatusChangeModel,(result: interfaces.applicationcore.IMessageHandler) => {
                        this.generalService.displayMessageHandler(result);

                        if (!result.HasErrorMessage) {
                            this.$timeout(() => {
                                this.bsLoadingOverlayService.wrap({
                                    referenceId: 'con.update'
                                }, () => {
                                    return this.loadConsignment();
                                });
                            });
                        }
                    }, (errorResponse) => {
                        this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                    });
                });
            }            

            viewCostInvoiceSummary() {
                this.bsLoadingOverlayService.wrap({
                    referenceId: 'con.update'
                }, () => {
                    return this.menuService.getGTSConnectMenuItem(529).get((result: interfaces.applicationcore.IMenu) => {
                        if (result.url) {
                            result.url += "?Id=" + this.consignment.Id;
                            var url = this.$state.href("auth.IFrame", { url: result.url });
                            window.open(url, '_blank');
                        }
                    }).$promise;
                });
            }



            generateCostInvoices() {
                this.bsLoadingOverlayService.wrap({
                    referenceId: 'con.update'
                }, () => {
                    return this.SaveConsignment().then(() => {
                        this.commercialInvoiceService.generateCostInvoices(this.consignment.Id).save((result) => {
                            this.generalService.displayMessageHandler(result);

                            if (!result.HasErrorMessage) {
                                this.$timeout(() => {
                                    this.bsLoadingOverlayService.wrap({
                                        referenceId: 'con.update'
                                    }, () => {
                                        return this.loadConsignment();
                                    });
                                });
                            }
                        }, (errorResponse) => {
                            this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                        });
                    }, () => {
                        return;
                    });
                });
            }

            editCostInvoice(costInvoiceId: number) {
                if (this.$stateParams.manId) {
                    if (this.consignment.IsInbound) {
                        this.$state.go("auth.Manifests.Update.ConsignmentImport.CostInvoice", { comId: costInvoiceId });
                    } else {
                        this.$state.go("auth.Manifests.Update.ConsignmentExport.CostInvoice", { comId: costInvoiceId });
                    }
                } else {
                    if (this.consignment.IsInbound) {
                        this.$state.go("auth.ConsignmentImports.Update.CostInvoice", { comId: costInvoiceId });
                    } else {
                        this.$state.go("auth.ConsignmentExports.Update.CostInvoice", { comId: costInvoiceId });
                    }
                }
            }

            viewCostInvoiceDocuments(costInvoiceId: number) {
                if (this.$stateParams.manId) {
                    if (this.consignment.IsInbound) {
                        this.$state.go("auth.Manifests.Update.ConsignmentImport.CostInvoice.Documents", { comId: costInvoiceId });
                    } else {
                        this.$state.go("auth.Manifests.Update.ConsignmentExport.CostInvoice.Documents", { comId: costInvoiceId });
                    }
                } else {
                    if (this.consignment.IsInbound) {
                        this.$state.go("auth.ConsignmentImports.Update.CostInvoice.Documents", { comId: costInvoiceId });
                    } else {
                        this.$state.go("auth.ConsignmentExports.Update.CostInvoice.Documents", { comId: costInvoiceId });
                    }
                }
            }

            removeCostInvoice(costInvoiceId: number) {
                if (costInvoiceId) {
                    this.bsLoadingOverlayService.wrap({
                        referenceId: 'con.update'
                    }, () => {
                        return this.commercialInvoiceService.delete(costInvoiceId).delete((result) => {
                            this.generalService.displayMessageHandler(result);
                            if (!result.HasErrorMessage) {
                                this.$timeout(() => {
                                    this.bsLoadingOverlayService.wrap({
                                        referenceId: 'con.update'
                                    }, () => {
                                        return this.loadConsignment();
                                    });
                                });
                            }
                        }, (errorResponse) => {
                            this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                        }).$promise;
                    });

                }
            }

            //Goods Declaration Grid
            gvwGoodsDec: uiGrid.IGridOptions = {
                data: [],
                enableFiltering: false,
                useExternalFiltering: false,
                enableCellEdit: false,
                useExternalSorting: false,
                multiSelect: false,
                enableColumnResizing: true,
                enableFullRowSelection: true,
                useExternalPagination: false,
                enableRowHeaderSelection: false,
                enableHorizontalScrollbar: 2,
                rowEditWaitInterval: -1,
                cellEditableCondition: false,
                showGridFooter: true,
                onRegisterApi: (gridApi) => {
                    this.registerGoodsDecGridApi(gridApi);



                },
                columnDefs: [{
                    name: "EDIT",
                    displayName: "",
                    field: "Id",
                    cellTemplate: `
                    <div class="GridButton"> 
                        <button type="button" ng-click="grid.appScope.consignmentUpdateCtrl.editGoodsDec(row.entity)" class="btn btn-info btn-sm">
                            <span class="fa fa-pencil"></span>
                        </button>
                    </div>`,
                    enableSorting: false,
                    enableColumnMenu: false,
                    enableCellEdit: false,
                    width: 35,
                    enableCellEditOnFocus: false,
                }, {
                    name: "EDISTATUS",
                    displayName: "EDI",
                    field: "EDIStatus",
                    enableCellEdit: false,
                    cellTemplate: `
                    <div style="text-align: center; padding-top: 6px;" ng-if="row.entity.Source==='GENERATED'">
                        <div ng-if="row.entity.StatusIndicator === 0">
                            <span class="fa fa-edit"></span>
                        </div>
                        <div ng-if="row.entity.StatusIndicator === 1">
                            <span class="fa fa-times" style="color: #cb2330;"></span>
                        </div>
                        <div ng-if="row.entity.StatusIndicator === 2">
                            <span class="fa fa-exclamation-triangle" style="color: #f57f20; opacity: 0.7;"></span>
                        </div>
                        <div ng-if="row.entity.StatusIndicator === 3">
                            <span class="fa fa-check-circle" style="color: #bcd856;"></span>
                        </div>
                    </div>                   
                    <div style="text-align: center; padding-top: 6px;" ng-if="row.entity.IsClearingInstruction">                                                  
                        <div ng-if="row.entity.StatusIndicator === 0">
                           <img style="width:16px;height:16px;" ng-src="data:image/png;base64,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">                       
                        </div>
                        <div ng-if="row.entity.StatusIndicator === 1">
                            <span class="fa fa-times" style="color: #cb2330;"></span>
                        </div>
                        <div ng-if="row.entity.StatusIndicator === 2">
                            <span class="fa fa-exclamation-triangle" style="color: #f57f20; opacity: 0.7;"></span>
                        </div>
                        <div ng-if="row.entity.StatusIndicator === 3">
                            <span class="fa fa-check-circle" style="color: #bcd856;"></span>
                        </div>
                    </div>
                    <div style="text-align: center; padding-top: 6px;" ng-if="row.entity.Source==='INTEGRATED'">                       
                        <img style="width:16px;height:16px;" ng-src="data:image/png;base64,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">                       
                    </div>    
                    <div style="text-align: center; padding-top: 6px;" ng-if="row.entity.Source==='MANUAL'">                       
                        <img style="width:16px;height:16px;" ng-src="data:image/png;base64,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">                       
                    </div>                                    
                    `,
                    enableSorting: false,
                    enableColumnMenu: false,
                    width: 45,
                    enableCellEditOnFocus: false,
                }, {
                    name: "COUNTRY",
                    displayName: "Country",
                    field: "DeclarationCountry",
                    type: "string",
                    cellClass: 'text-right',
                    enableCellEdit: false,
                    cellTemplate: `<div class="ui-grid-cell-contents">{{MODEL_COL_FIELD}}</div>`,
                    enableCellEditOnFocus: false
                }, {
                    name: "CPCTYPE",
                    displayName: "CPC",
                    field: "CPCType",
                    type: "string",
                    cellClass: 'text-right',
                    enableCellEdit: false,
                    cellTemplate: `<div class="ui-grid-cell-contents">{{MODEL_COL_FIELD}}</div>`,
                    enableCellEditOnFocus: false
                }, {
                    name: "FUNCTION",
                    displayName: "Function",
                    field: "Function",
                    type: "string",
                    cellClass: 'text-right',
                    enableCellEdit: false,
                    cellTemplate: `<div class="ui-grid-cell-contents">{{MODEL_COL_FIELD}}</div>`,
                    enableCellEditOnFocus: false
                }, {
                    name: "VERSION",
                    displayName: "Version",
                    field: "version",
                    type: "string",
                    cellClass: 'text-right',
                    enableCellEdit: false,
                    cellTemplate: `<div class="ui-grid-cell-contents">{{MODEL_COL_FIELD}}</div>`,
                    enableCellEditOnFocus: false
                }, {
                    name: "LASTCUSTOMSSTATUS",
                    displayName: "Last Customs Status",
                    field: "LastCustomsStatus",
                    type: "string",
                    cellClass: 'text-right',
                    enableCellEdit: false,
                    cellTemplate: `<div class="ui-grid-cell-contents">{{MODEL_COL_FIELD}}</div>`,
                    enableCellEditOnFocus: false,
                    width: 150
                }, {
                    name: "SOURCE",
                    displayName: "Source",
                    field: "Source",
                    type: "string",
                    cellClass: 'text-right',
                    enableCellEdit: false,
                    cellTemplate: `<div class="ui-grid-cell-contents">{{MODEL_COL_FIELD}}</div>`,
                    enableCellEditOnFocus: false,
                    width: 140
                }, {
                    name: "MRNNUMBER",
                    displayName: "MRN Number",
                    field: "MRNNumber",
                    type: "string",
                    cellClass: 'text-right',
                    enableCellEdit: false,
                    cellTemplate: `<div class="ui-grid-cell-contents">{{MODEL_COL_FIELD}}</div>`,
                    enableCellEditOnFocus: false
                }, {
                    name: "ASSESSMENTDATE",
                    displayName: "Assessment Date",
                    field: "AssessmentDate",
                    type: "string",
                    cellClass: 'text-right',
                    enableCellEdit: false,
                    cellTemplate: `<div class="ui-grid-cell-contents">{{MODEL_COL_FIELD | momentDateFilter: 'YYYY/MM/DD'}}</div>`,
                    enableCellEditOnFocus: false
                }, {
                    name: "DECLARANT",
                    displayName: "Declarant",
                    field: "Declarant",
                    type: "string",
                    cellClass: 'text-right',
                    enableCellEdit: false,
                    cellTemplate: `<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD}}">{{MODEL_COL_FIELD}}</div>`,
                    enableCellEditOnFocus: false
                }, {
                    name: "REFUNDREFERENCE",
                    displayName: "Refund Reference",
                    field: "RefundReference",
                    type: "string",
                    cellClass: 'text-right',
                    enableCellEdit: false,
                    cellTemplate: `<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD}}">{{MODEL_COL_FIELD}}</div>`,
                    enableCellEditOnFocus: false
                }, {
                    name: "REFUNDSTATUS",
                    displayName: "Refund Status",
                    field: "RefundStatus",
                    type: "string",
                    cellClass: 'text-right',
                    enableCellEdit: false,
                    cellTemplate: `<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD}}">{{MODEL_COL_FIELD}}</div>`,
                    enableCellEditOnFocus: false
                }]
            };

            //Edit Goods Dec
            editGoodsDec(entity: interfaces.customs.IGoodsDeclaration) {
                if (this.$stateParams.manId) {
                    if (this.isInbound) {
                        this.$state.go("auth.Manifests.Update.ConsignmentImport.GoodsDeclaration", { gsdId: entity.Id, version: entity.version });
                    } else {
                        this.$state.go("auth.Manifests.Update.ConsignmentExport.GoodsDeclaration", { gsdId: entity.Id, version: entity.version });
                    }
                } else {
                    if (this.consignment.IsInbound) {
                        this.$state.go("auth.ConsignmentImports.Update.GoodsDeclaration", { gsdId: entity.Id, version: entity.version });
                    } else {
                        this.$state.go("auth.ConsignmentExports.Update.GoodsDeclaration", { gsdId: entity.Id, version: entity.version });
                    }
                }
            }

            registerGoodsDecGridApi(gridApi: uiGrid.IGridApi) {
                this.apiGoodsDecList = gridApi;

                this.apiGoodsDecList.cellNav.on.navigate(this.$scope, (gridSelection) => {
                    this.apiGoodsDecList.selection.selectRow(gridSelection.row.entity);
                    if (gridSelection.row.entity.RefundClaimId > 0 && this.hasViewRefundClaimRights) {
                        this.allowViewRefundClaims = true;
                    }
                    else {
                        this.allowViewRefundClaims = false;
                    }
                });

                this.$timeout(() => {
                    this.gvwGoodsDec.data = this.consignment.ConsignmentGoodsDeclarationList;
                });
            }

            generateGoodsDec(GoodsDeclarationType: string) {
                this.displayCreateVersion(false,GoodsDeclarationType);
            }
            //This is a change
            generate(isClearing: boolean, GoodsDeclarationType: string) {
                this.bsLoadingOverlayService.wrap({
                    referenceId: 'con.update'
                }, () => {
                    //Save the consignment first before saving
                    return this.SaveConsignment().then((result) => {
                        this.generalService.displayMessageHandler(result);

                        if (!result.HasErrorMessage) {
                            this.$timeout(() => {
                                this.bsLoadingOverlayService.wrap({
                                    referenceId: 'con.update'
                                }, () => {
                                    return this.goodsDeclarationService.generateGoodsDec().get({
                                        consignmentId: this.consignment.Id,
                                        functionClassificationValueId: this.functionType,
                                        versionChangeReason: this.reason,
                                        CreateClearingInstructionOnly: isClearing,
                                        GoodsDeclarationType: GoodsDeclarationType
                                    }, (result: interfaces.applicationcore.IMessageHandler) => {
                                        this.generalService.displayMessageHandler(result);

                                        this.$timeout(() => {
                                            this.bsLoadingOverlayService.wrap({
                                                referenceId: 'con.update'
                                            }, () => {
                                                return this.loadConsignment();
                                            });
                                        });
                                    }, (errorResponse) => {
                                        this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);

                                        this.$timeout(() => {
                                            this.bsLoadingOverlayService.wrap({
                                                referenceId: 'con.update'
                                            }, () => {
                                                return this.loadConsignment();
                                            });
                                        });
                                    }).$promise;
                                });
                            });
                        }
                    });
                });
            }

            showAllVersions() {
                this.bsLoadingOverlayService.wrap({
                    referenceId: 'con.update'
                }, () => {
                    return this.goodsDeclarationService.getGoodsDeclarations().query({
                        consignmentId: this.consignment.Id,
                        version: "",
                        getAll: this.getAll,
                        isClearingInstruction: false,
                    }, (result: Array<interfaces.customs.IGoodsDeclarationDisplay>) => {
                        this.consignment.ConsignmentGoodsDeclarationList = result;
                        this.gvwGoodsDec.data = result;
                    }, (errorResponse) => {
                        this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                    }).$promise;
                });
            }

            dutyDrawbacks() {
                this.bsLoadingOverlayService.wrap({
                    referenceId: 'con.update'
                }, () => {
                    if (this.consignment.DutyDrawbackId) {
                        if (this.$stateParams.manId) {
                            var url = '#!/RefundClaims/Update/' + this.consignment.DutyDrawbackId;
                            window.open(url, '_blank');
                        }
                        else {
                            this.$state.go("auth.ConsignmentExports.Update.RefundClaim", { refId: this.consignment.DutyDrawbackId });
                        }
                    }
                    else {
                        return this.SaveConsignment().then(() => {
                            this.consignmentService.Create52203DDClaim(this.consignment.Id).save({
                                conId: this.consignment.Id,
                            }, (result) => {
                                this.generalService.displayMessageHandler(result);
                                this.$anchorScroll("topAnchor");

                                if (!result.HasErrorMessage) {
                                    this.$timeout(() => {
                                        this.bsLoadingOverlayService.wrap({
                                            referenceId: 'con.update'
                                        }, () => {
                                            return this.loadConsignment();
                                        });
                                    });
                                }
                            }, (failureData) => {
                                this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                                this.$anchorScroll("topAnchor");
                            });
                        }, () => {
                            return;
                        });
                    }
                });
            }

            removeGoodsDec() {
                this.bsLoadingOverlayService.wrap({
                    referenceId: 'con.update'
                }, () => {
                    //Save the consignment first before saving
                    return this.SaveConsignment().then((result) => {
                        this.generalService.displayMessageHandler(result);

                        if (!result.HasErrorMessage) {
                            this.$timeout(() => {
                                this.bsLoadingOverlayService.wrap({
                                    referenceId: 'con.update'
                                }, () => {
                                    var selectedRow = <interfaces.customs.IGoodsDeclaration>this.apiGoodsDecList.selection.getSelectedRows()[0];
                                    if (selectedRow && selectedRow.Id > 0) {
                                        if (selectedRow.IsClearingInstruction && !this.getHasGenerateRemoveClearInRight){
                                            this.generalService.displayMessage("You do not have Rights to remove a Clearing Instruction", Enum.EnumMessageType.Warning);
                                        }else if (selectedRow.Source === 'MANUAL' && !this.hasAddRemoveManualGoodsDecRight){
                                            this.generalService.displayMessage("You do not have Rights to remove a Manual Goods Declaration", Enum.EnumMessageType.Warning);
                                        }else if (selectedRow.Source === 'GENERATED' && !this.hasGenerateAndRemoveGoodsDeclarationRight){
                                            this.generalService.displayMessage("You do not have Rights to remove a Goods Declaration", Enum.EnumMessageType.Warning);
                                        }
                                        else{
                                                    this.bsLoadingOverlayService.wrap({
                                                        referenceId: 'con.update'
                                                    }, () => {
                                                        return this.goodsDeclarationService.delete(selectedRow.Id).delete((result) => {
                                                            this.generalService.displayMessageHandler(result);
                                                            if (!result.HasErrorMessage) {
                                                                this.$timeout(() => {
                                                                    this.bsLoadingOverlayService.wrap({
                                                                        referenceId: 'con.update'
                                                                    }, () => {
                                                                        return this.loadConsignment();
                                                                    });
                                                                });
                                                            }
                                                        }, (errorResponse) => {
                                                            this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                                                        });
                                                    });
                                                }
                                    } else if (selectedRow) {
                                        _.remove(this.gvwGoodsDec.data, (o) => {
                                            return o === selectedRow;
                                        });
                                    } else {
                                        this.generalService.displayMessage("Please select a Goods Declaration to remove", Enum.EnumMessageType.Warning);
                                    }
                                });
                            });
                        }
                    });
                });
            }


            registerConsignmentAttributeApi(gridApi: uiGrid.IGridApi) {
                this.apiCA = gridApi;
            }

            removeInlineCA() {
                var selectedRow = <interfaces.master.ICustomAttributeValue>this.apiCA.selection.getSelectedRows()[0];
                if (selectedRow && selectedRow.Id > 0) {
                    this.bsLoadingOverlayService.wrap({
                        referenceId: 'con.update'
                    }, () => {
                        return this.customAttributeService.deleteCustomAttributeValue(selectedRow.Id).save({ Id: selectedRow.Id }, (result) => {
                            this.generalService.displayMessageHandler(result);
                            this.$timeout(() => {
                                this.bsLoadingOverlayService.wrap({
                                    referenceId: 'con.update'
                                }, () => {
                                        this.loadConsignment();
                                });
                            });
                        }, (errorResponse) => {
                            this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                        });
                    });
                } else if (selectedRow) {
                    _.remove(this.gvwConsignmentAttribute.data, (o) => {
                        return o === selectedRow;
                    });
                }
            }

            removeInlineCA1(entity: interfaces.master.ICustomAttributeValue) {
                this.bsLoadingOverlayService.wrap({
                    referenceId: 'con.update'
                }, () => {

                    return this.customAttributeService.deleteCustomAttributeValue(entity.Id).save({ Id: entity.Id }, (result) => {
                        this.generalService.displayMessageHandler(result);
                        this.$timeout(() => {
                            this.bsLoadingOverlayService.wrap({
                                referenceId: 'con.update'
                            }, () => {
                                this.loadConsignment();
                            });
                        });
                    }, (errorResponse) => {
                        this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                    });
                });

                if (this.apiCA) {
                    this.apiCA.rowEdit.setRowsClean(this.consignment.ConsignmentAttributeList);
                }

                if (entity.Id === 0) {
                    _.remove(this.gvwConsignmentAttribute.data, (o) => {
                        return o === entity;
                    });
                    return;
                }
            }

            checkBoxAttributeChanged(entity) {
                if (this.apiCA) {
                    this.apiCA.rowEdit.setRowsDirty([entity]);
                }
            }

            attributeValueChanged(model: interfaces.applicationcore.IDropdownModel, entity: interfaces.master.ICustomAttributeValue) {
                if (model) {
                    entity.AttributeValue = model.Description;

                    if (this.apiCA) {
                        this.apiCA.rowEdit.setRowsDirty([entity]);
                    }
                }
            }

            attributeValueOtherChanged(entity: interfaces.master.ICustomAttributeValue) {
                if (entity) {
                    if (this.apiCA) {
                        this.apiCA.rowEdit.setRowsDirty([entity]);
                    }
                }
            }

            insertCA() {
                this.consignment.ConsignmentAttributeList.push(<interfaces.master.ICustomAttributeValue>{
                    Id: 0,
                    Attribute: <interfaces.master.ICustomAttribute>{ Id: 0, AttributeType: 0, IsNotEditable: false },
                    CategoryType: this.isInbound?793:784,
                    CategoryKey: this.consignment.Id,
                    IsActive: true
                });
            }

            addAllAttributes() {
                var typeId = 784;
                if (this.consignment.IsInbound)
                    typeId = 793;

                this.bsLoadingOverlayService.wrap({
                    referenceId: 'con.update'
                }, () => {
                    return this.SaveConsignment().then(() => {
                        this.customAttributeService.generateMandatoryAttributes(this.consignment.Id, typeId).save((result) => {
                            this.generalService.displayMessageHandler(result);

                            if (!result.HasErrorMessage) {
                                this.$timeout(() => {
                                    this.bsLoadingOverlayService.wrap({
                                        referenceId: 'update'
                                    }, () => {
                                        return this.loadConsignment();
                                    });
                                });
                            }
                        }, (errorResponse) => {
                            this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                        });
                    }, () => {
                        return;
                    });
                });
            }

            loadAttributeList() {
                var typeId = 784;
                if (this.consignment.IsInbound)
                    typeId = 793;

                return this.customAttributeService.GetCustomAttributeByCategory(typeId, this.consignment.OwnerEntityId).query({
                }, (resultList) => {
                    this.attributeList = resultList;
                }).$promise;
            }

            loadAttributeAnswerOptionList(id) {
                return this.customAttributeAnswerOptionService.GetDropDownListByAttribute().query({
                    attributeId: id
                }, (resultList) => {
                    this.attributeAnswerOptionList = resultList;
                }).$promise;
            }

            gvwConsignmentAttribute: uiGrid.IGridOptions = {
                data: [],
                enableFiltering: false,
                useExternalFiltering: false,
                enableCellEdit: true,
                useExternalSorting: false,
                multiSelect: false,
                enableRowHeaderSelection: false,
                enableColumnResizing: true,
                enableFullRowSelection: false,
                useExternalPagination: false,
                enableHorizontalScrollbar: 2,
                rowTemplate: '<div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" ng-class="col.colIndex()" class="ui-grid-cell" ng-disabled="row.entity.Attribute.IsNotEditable" ui-grid-cell></div>',
                rowEditWaitInterval: -1,
                onRegisterApi: (gridApi) => {
                    this.apiCA = gridApi;

                    this.apiCA.cellNav.on.navigate(this.$scope, (newCol) => {
                        this.$timeout(() => {
                            this.apiCA.selection.selectRow(newCol.row.entity);
                        });
                    });
                },
                columnDefs: [
                    {
                        name: "EDIT",
                        displayName: "",
                        field: "Id",
                        cellTemplate: `
                        <div class="GridButton"> 
                            <button type="button" ng-click="grid.appScope.consignmentUpdateCtrl.removeInlineCA()" ng-disabled="row.entity.Attribute.IsNotEditable" class="btn btn-warning btn-sm">
                                Delete
                            </button>
                        </div>`,
                        enableSorting: false,
                        enableColumnMenu: false,
                        enableCellEdit: false,
                        width: 80,
                        enableCellEditOnFocus: false,
                        headerCellTemplate: `
                        <div class="GridButton">
                            <button type="button" class="btn btn-primary btn-sm" ng-click="grid.appScope.consignmentUpdateCtrl.addAllAttributes()" >
                                <span title="Click to create mandatory list of attributes" class="fa fa-list"></span>
                            </button>
                            <button type="button" class="btn btn-default btn-sm" ng-click="grid.appScope.consignmentUpdateCtrl.insertCA()" >
                                <span class="fa fa-plus"></span>
                            </button>
                        </div>`
                    },
                    {
                        name: 'Attribute',
                        displayName: '* Attribute',
                        field: 'Attribute',
                        enableCellEditOnFocus: true,
                        cellTemplate: `<div class="ui-grid-cell-contents" ng-disabled="row.entity.Attribute.IsNotEditable">{{MODEL_COL_FIELD.Display}}</div>`,
                        editableCellTemplate: `
                                <form name="inputForm">
                                    <gts-dropdown ui-select-wrap name="{{MODEL_COL_FIELD.$$hashKey}}" ng-disabled="row.entity.Attribute.IsNotEditable" append-to-body="true" ng-model="MODEL_COL_FIELD" form="inputForm" load-data="grid.appScope.consignmentUpdateCtrl.loadAttributeList()"></gts-dropdown>
                                </form>`,
                        enableSorting: false,
                        width: 300
                    },
                    {
                        name: 'AttributeValue',
                        displayName: '* Attribute Value',
                        field: 'CustomAttributeAnswerOption',
                        enableCellEditOnFocus: true,
                        cellTemplate: `<div class="ui-grid-cell-contents" ng-if="row.entity.Attribute.AttributeType == 57" ng-disabled="row.entity.Attribute.IsNotEditable">{{row.entity.AttributeValue}}</div>
                                       <div class="ui-grid-cell-contents" ng-if="row.entity.Attribute.AttributeType == 58" ng-disabled="row.entity.Attribute.IsNotEditable">{{row.entity.AttributeValue}}</div>
                                       <div class="ui-grid-cell-contents" ng-if="row.entity.Attribute.AttributeType == 556" ng-disabled="row.entity.Attribute.IsNotEditable">{{row.entity.AttributeNumericValue}}</div>
                                       <div class="ui-grid-cell-contents" ng-if="row.entity.Attribute.AttributeType == 557" ng-disabled="row.entity.Attribute.IsNotEditable">{{row.entity.AttributeDateValue | momentDateFilter: 'YYYY/MM/DD HH:mm'}}</div>`,
                        editableCellTemplate: `
                                <form name="inputForm">
                                        <gts-dropdown ng-if="row.entity.Attribute.AttributeType == 57" ng-disabled="row.entity.Attribute.IsNotEditable" ng-change="grid.appScope.consignmentUpdateCtrl.attributeValueChanged(model, row.entity)"  ui-select-wrap name="{{MODEL_COL_FIELD.$$hashKey}}-AttributeValueDD" append-to-body="true" ng-model="MODEL_COL_FIELD" form="inputForm" load-data="grid.appScope.consignmentUpdateCtrl.loadAttributeAnswerOptionList(row.entity.Attribute.Id)"></gts-dropdown>                                                                                                                                               
                                        
                                        <p class="input-group-sm" ng-if="row.entity.Attribute.AttributeType == 58">
                                        <input type="text" ng-change="grid.appScope.consignmentUpdateCtrl.attributeValueOtherChanged( row.entity)" ng-if="row.entity.Attribute.AttributeType == 58" ng-disabled="row.entity.Attribute.IsNotEditable"  ignore-wheel name="AttributeNumericValueText" ng-model="row.entity.AttributeValue" class="form-control" ng-class="'colt' + col.uid" class="form-control" ui-grid-editor />
                                        </p>

                                        <p class="input-group-sm"  ng-if="row.entity.Attribute.AttributeType == 556">
                                        <input type="number" ng-change="grid.appScope.consignmentUpdateCtrl.attributeValueOtherChanged(row.entity)" ng-if="row.entity.Attribute.AttributeType == 556" ng-disabled="row.entity.Attribute.IsNotEditable"  ignore-wheel name="AttributeNumericValue" ng-model="row.entity.AttributeNumericValue" class="form-control" ng-class="'colt' + col.uid" class="form-control" ui-grid-editor step="0.01" min="0" />
                                        </p>

                                        <gts-date ng-change="grid.appScope.consignmentUpdateCtrl.attributeValueOtherChanged(row.entity)" ng-if="row.entity.Attribute.AttributeType == 557" ng-disabled="row.entity.Attribute.IsNotEditable"   format="yyyy/MM/dd HH:mm"  show-time="true"  ng-model="row.entity.AttributeDateValue" name="{{MODEL_COL_FIELD.$$hashKey}}-endDate"></gts-date>
                                </form>
                               `,
                        enableSorting: false,
                        width: 300
                    }
                    , {
                        name: "IsActive",
                        displayName: "Active",
                        enableFiltering: false,
                        enableCellEdit: true,
                        enableCellEditOnFocus: true,
                        cellTemplate: `<input type="checkbox" ng-disabled="row.entity.Attribute.IsNotEditable" ng-model="row.entity.IsActive" ng-change="grid.appScope.consignmentUpdateCtrl.checkBoxAttributeChanged(row.entity)">`,
                        editableCellTemplate: ` <form name="inputForm">
                                                    <p class="input-group-sm">
                                                        <input type="checkbox" ng-disabled="row.entity.Attribute.IsNotEditable" ng-model="row.entity.IsActive">
                                                    </p>
                                                </form>`,
                        width: 60
                    }
                ]
            };


            registerClearInGridApi(gridApi: uiGrid.IGridApi) {
                this.apiClearInList = gridApi;

                this.apiClearInList.cellNav.on.navigate(this.$scope, (gridSelection) => {
                    this.apiClearInList.selection.selectRow(gridSelection.row.entity);
                });

                this.apiClearInList.selection.on.rowSelectionChanged(this.$scope, (selected) => {
                    if (selected.entity.StatusIndicator > 0) {
                        this.allowViewCustoms = false;
                    }
                    else {
                        this.allowViewCustoms = true;
                    }
                })

                this.$timeout(() => {
                    //this.gvwClearIn.data = this.consignment.ConsignmentClearingInstructionList;
                });
            }

            generateClearIn() {
                this.displayCreateVersion(true,"GENERATED");
            }

            addManualDeclaration_Click(){
                
                    
                    this.displayCreateManualDeclaration().then((manualGoodsDeclarationCreate:interfaces.customs.IManualGoodsDeclarationCreate ) => {
                        if (manualGoodsDeclarationCreate) {
                        manualGoodsDeclarationCreate.consignmentId = this.consignment.Id;
                           return this.bsLoadingOverlayService.wrap({
                                referenceId: 'con.update'
                            }, () => {
                          
                            return this.goodsDeclarationService.createManualDeclaration().save({}, manualGoodsDeclarationCreate,
                                (result: interfaces.applicationcore.IMessageHandler) => {
                                    this.generalService.displayMessageHandler(result);
            
                                    if (!result.HasErrorMessage) {
                                        
                                        if (this.isInbound) {
                                            this.$state.go("auth.ConsignmentImports.Update.GoodsDeclaration", { gsdId: Number(result.ID), version: 1 });
                                        } else {
                                            this.$state.go("auth.ConsignmentExports.Update.GoodsDeclaration", { gsdId: Number(result.ID), version: 1});
                                        }

                                    }
                                }).$promise;
                        });
                        
                    

                }
            });

            }

                      
            displayCreateManualDeclaration() {
                //Get delivery status
                return this.$uibModal.open({
                    animation: true,
                    template: `
                        <div class="modal-content" >
                            <form name="manualDeclaration">
                                <div class="gts-padding">
                                    <fieldset id="varianceAuth">
                                    <legend>
                                        Add Manual Declaration
                                    </legend>                                            
                                            <div class="row vertical-align">
                                                <div class="col-md-5">
                                                    <req></req>
                                                    <label>Country</label> 
                                                </div>
                                                <div class="col-md-7">                                                    
                                                    <gts-dropdown name="Country" ng-model="manualDeclarationCtrl.manualGoodsDeclarationCreate.Country" form="manualDeclaration" load-data="manualDeclarationCtrl.loadCountries()" ng-change="manualDeclarationCtrl.countryChanged(model)" required="true" ></gts-dropdown>
                                                </div>                                               
                                            </div>  
                                            <div class="row vertical-align">
                                                <div class="col-md-5">
                                                    <req></req>
                                                    <label>Procedure Category</label>
                                                </div>
                                                <div class="col-md-7">
                                                    <gts-dropdown name="procedureCategory" ng-model="manualDeclarationCtrl.manualGoodsDeclarationCreate.ProcedureCategory" form="manualDeclaration" load-data="manualDeclarationCtrl.loadProcedureCategory()" ng-change="manualDeclarationCtrl.procedureCategoryChanged(model)" required="true" ng-disabled="!manualDeclarationCtrl.manualGoodsDeclarationCreate.Country"></gts-dropdown>
                                                </div>                                               
                                            </div>
                                            <div class="row vertical-align">
                                                <div class="col-md-5">
                                                    <req></req>
                                                    <label>Customs Procedure</label>
                                                </div>
                                                <div class="col-md-7">
                                                    <gts-dropdown name="PreviousCustomsProcedure" ng-model="manualDeclarationCtrl.manualGoodsDeclarationCreate.CustomsProcedure" form="manualDeclaration" load-data="manualDeclarationCtrl.loadCustomsProcedure()" required="true" ng-disabled="!manualDeclarationCtrl.manualGoodsDeclarationCreate.ProcedureCategory" ng-change="manualDeclarationCtrl.customsProcedureChanged(model)"  pagination-search="true" refresh-delay="500"></gts-dropdown>
                                                </div>                                               
                                            </div>
                                            <div class="row vertical-align">
                                                <div class="col-md-5">
                                                    <req></req>
                                                    <label>Previous Customs Procedure</label>
                                                </div>
                                                <div class="col-md-7">
                                                    <gts-dropdown name="previousCustomsProcedure" ng-model="manualDeclarationCtrl.manualGoodsDeclarationCreate.PreviousCustomsProcedure" form="manualDeclaration" load-data="manualDeclarationCtrl.loadPreviousCustomsProcedure()" required="true" ng-disabled="!manualDeclarationCtrl.manualGoodsDeclarationCreate.CustomsProcedure" ng-change="manualDeclarationCtrl.previousCustomsProcedureChanged(model)"></gts-dropdown>
                                                </div>                                               
                                            </div>  
                                            <div class="row vertical-align">
                                                <div class="col-md-5">
                                                    <req></req>
                                                    <label>CPC Type</label>
                                                </div>
                                                <div class="col-md-7">
                                                    <gts-dropdown name="CPCType" ng-model="manualDeclarationCtrl.manualGoodsDeclarationCreate.CPCType" form="manualDeclaration" load-data="manualDeclarationCtrl.LoadCPCTypes()" required="true" ng-disabled="!manualDeclarationCtrl.manualGoodsDeclarationCreate.ProcedureCategory"></gts-dropdown>
                                                </div>                                               
                                            </div>                                                      
                                            <div class="row vertical-align">
                                                <div class="col-md-5">
                                                    <req></req>
                                                    <label>Office Of Entry</label>
                                                </div>
                                                <div class="col-md-7">
                                                    <gts-dropdown name="customsOfficeOfEntry" ng-model="manualDeclarationCtrl.manualGoodsDeclarationCreate.OfficeOfEntry" form="manualDeclaration" load-data="manualDeclarationCtrl.loadCustomsOfficeOfEntry(searchText)" required="true" ng-disabled="!manualDeclarationCtrl.manualGoodsDeclarationCreate.Country"></gts-dropdown>
                                                </div>                                               
                                            </div> 
                                            <div class="row vertical-align">
                                                <div class="col-md-5">
                                                    <req></req>
                                                    <label>Declarant</label>
                                                </div>
                                                <div class="col-md-7">
                                                <gts-dropdown name="declarant" ng-model="manualDeclarationCtrl.manualGoodsDeclarationCreate.Declarant" form="manualDeclaration" load-data="manualDeclarationCtrl.loadDeclarantByCountry()" required="true" ng-disabled="!manualDeclarationCtrl.manualGoodsDeclarationCreate.Country"></gts-dropdown>
                                                </div>                                               
                                            </div>            
                                            <div class="row vertical-align">
                                                <div class="col-md-5">
                                                    <req></req>
                                                    <label>Flow Type</label>
                                                </div>
                                                <div class="col-md-7">
                                                    <gts-dropdown name="documentFlowType" ng-model="manualDeclarationCtrl.manualGoodsDeclarationCreate.FlowType" form="manualDeclaration" load-data="manualDeclarationCtrl.loadDocumentFlowType()" required="true" ng-disabled="!manualDeclarationCtrl.manualGoodsDeclarationCreate.Country"></gts-dropdown>
                                                </div>
                                            </div>                                                                                                                                                                    

                                            <div class="gts-padding pull-right">                                               
                                                    <button type="button" class="btn btn-primary"  ng-click="manualDeclarationCtrl.ok()"
                                                    ng-disabled="!manualDeclarationCtrl.manualGoodsDeclarationCreate.Country || !manualDeclarationCtrl.manualGoodsDeclarationCreate.ProcedureCategory
                                                                || !manualDeclarationCtrl.manualGoodsDeclarationCreate.CustomsProcedure
                                                                || !manualDeclarationCtrl.manualGoodsDeclarationCreate.PreviousCustomsProcedure
                                                                || !manualDeclarationCtrl.manualGoodsDeclarationCreate.OfficeOfEntry
                                                                || !manualDeclarationCtrl.manualGoodsDeclarationCreate.CPCType
                                                                || !manualDeclarationCtrl.manualGoodsDeclarationCreate.Declarant
                                                                || !manualDeclarationCtrl.manualGoodsDeclarationCreate.FlowType"
                                                    >Create Goods Declaration</button>
                                                    <button type="button" class="btn btn-info" ng-click="manualDeclarationCtrl.cancel()">Cancel</button>
                                            </div>                                       
                                    </fieldset>
                                </div>
                            </form>
                        </div>
                    `
                    ,
                    controller: class manualDeclarationCtrl {
                        manualGoodsDeclarationCreate: interfaces.customs.IManualGoodsDeclarationCreate = <interfaces.customs.IManualGoodsDeclarationCreate>{};

                        
                        constructor($scope, private $uibModalInstance: angular.ui.bootstrap.IModalInstanceService,  private $q: ng.IQService,
                            private goodsDeclarationService: interfaces.customs.IGoodsDeclarationService,
                            private tariffCountryService: interfaces.tariff.ITariffCountryService,
                            private customsProcedureMatrixService: interfaces.tariff.ICustomsProcedureMatrixService,
                            private customsOfficeCodeService: interfaces.tariff.ICustomsOfficeCodeService,
                            private companyService: interfaces.master.ICompanyService,
                            private flowTypeService: interfaces.customs.IFlowTypeService,
                            private classificationValueService: interfaces.applicationcore.IClassificationValueService,
                            private ownerEntityId: number,
                            ) {

                        }

                        cancel() {
                            this.$uibModalInstance.dismiss();
                        }

                        ok() {
                            this.$uibModalInstance.close(this.manualGoodsDeclarationCreate);
                        }

                        loadCountries() {
                            return this.tariffCountryService.getActiveTariffCountries().query({
                            }, (list: Array<interfaces.applicationcore.IDropdownModel>) => {
                            }).$promise;
                        }

                        
                        LoadCPCTypes() {
                            return this.classificationValueService.GetClassificationValueDropdownByClassification().query({
                                classificationId: Enum.ClassificationEnum.CPCType
                            }, (resultList) => {                                
                            }).$promise;
                        }
            


                        countryChanged(model:interfaces.applicationcore.IDropdownModel) {
                            this.manualGoodsDeclarationCreate.Country = model;
                            this.manualGoodsDeclarationCreate.ProcedureCategory = undefined;
                            this.manualGoodsDeclarationCreate.CustomsProcedure = undefined;
                            this.manualGoodsDeclarationCreate.PreviousCustomsProcedure = undefined;
                            this.manualGoodsDeclarationCreate.OfficeOfEntry = undefined;
                            this.manualGoodsDeclarationCreate.Declarant = undefined;
                            this.manualGoodsDeclarationCreate.FlowType = undefined;
                            this.manualGoodsDeclarationCreate.CPCType = undefined;

                            if (model && model.Id > 0){
                                
                                this.loadDocumentFlowType().then((list: Array<interfaces.applicationcore.IDropdownModel>)=>{
                                    if (list.length === 1){
                                        this.manualGoodsDeclarationCreate.FlowType = list[0];
                                    }   
                                });
                            }

                        }

                        loadCustomProcedureMatrix(){
                            /*this.customsProcedureMatrixService.get(this.manualGoodsDeclarationCreate.Country.Id,
                                this.manualGoodsDeclarationCreate.ProcedureCategory.Id,
                                this.manualGoodsDeclarationCreate.CustomsProcedure? this.manualGoodsDeclarationCreate.CustomsProcedure.Id:undefined,
                                this.manualGoodsDeclarationCreate.PreviousCustomsProcedure? this.manualGoodsDeclarationCreate.PreviousCustomsProcedure.Id : undefined)
                            .get({},(result : interfaces.tariff.ICustomsProcedureMatrix) =>{
                                if (result){
                                    if (result.TypeClassificationValueId){
                                        return this.classificationValueService.GetClassificationValueDropdownByClassification().query({
                                            classificationId: Enum.ClassificationEnum.CPCType
                                        }, (resultList : Array<interfaces.applicationcore.IDropdownModel>) => {   
                                                var cpcType = resultList.find(x=>x.Id === result.TypeClassificationValueId);             
                                                if (cpcType){
                                                    this.manualGoodsDeclarationCreate.CPCType = cpcType;
                                                }

                                                });                                       
                                    }
                                }
                            });*/
                        }

                        loadProcedureCategory() {
                            return this.customsProcedureMatrixService.getProcedureCategoryDropdownList(this.manualGoodsDeclarationCreate.Country.Id).query({
                            }, (list: Array<interfaces.applicationcore.IDropdownModel>) => {
                            }).$promise;
                        }

                        procedureCategoryChanged(model:interfaces.applicationcore.IDropdownModel) {
                            this.manualGoodsDeclarationCreate.CustomsProcedure = undefined;
                            this.manualGoodsDeclarationCreate.PreviousCustomsProcedure = undefined;
                            if (model){
                                this.manualGoodsDeclarationCreate.ProcedureCategory = model;
                                this.loadCustomProcedureMatrix();
                            }
                           
                        };

                        loadCustomsProcedure(searchText) {
                            if (!this.manualGoodsDeclarationCreate.ProcedureCategory) {
                                var deferred = this.$q.defer();
                                deferred.resolve([]);
                                return deferred.promise;
                            }

                            return this.customsProcedureMatrixService.getCustomsProcedureDropdownList(this.manualGoodsDeclarationCreate.Country.Id, this.manualGoodsDeclarationCreate.ProcedureCategory.Id).query({
                            }, (list: Array<interfaces.applicationcore.IDropdownModel>) => {
                            }, (errorResponse) => {
                            }).$promise;
                        }

                        loadPreviousCustomsProcedure() {
                            return this.customsProcedureMatrixService.getPrevCustomsProcedureDropdownList(this.manualGoodsDeclarationCreate.Country.Id, this.manualGoodsDeclarationCreate.ProcedureCategory.Id, this.manualGoodsDeclarationCreate.CustomsProcedure.Id).query({
                            }, (list: Array<interfaces.applicationcore.IDropdownModel>) => {
                            }, (errorResponse) => {                                
                            }).$promise;
                        }

                        previousCustomsProcedureChanged (model:interfaces.applicationcore.IDropdownModel) {
                            if (model){
                                this.manualGoodsDeclarationCreate.PreviousCustomsProcedure = model;
                                this.loadCustomProcedureMatrix();
                            }
                            
                        };

                        customsProcedureChanged (model:interfaces.applicationcore.IDropdownModel) {
                            if (model){
                                this.manualGoodsDeclarationCreate.CustomsProcedure = model;
                                this.loadCustomProcedureMatrix();
                            }
                            
                        };


                        loadCustomsOfficeOfEntry(searchText: string) {
                            var deferred = this.$q.defer();
            
                            this.customsOfficeCodeService.getForDropdown(searchText, this.manualGoodsDeclarationCreate.Country.Id).query({}, (list: Array<interfaces.applicationcore.IDropdownModel>) => {
                                deferred.resolve(list);
                            }, (errorResponse) => {                                
                                deferred.resolve([]);
                            });
            
                            return deferred.promise;
                        }

                        loadDeclarantByCountry(){
                            var deferred = this.$q.defer();

                            this.companyService.getCustomsPartyByCountryDropdownList(this.ownerEntityId,this.manualGoodsDeclarationCreate.Country.Id, Enum.EnumCustomsPartyType.Guarantor).query({}, (list: Array<interfaces.applicationcore.IDropdownModel>) => {
                                deferred.resolve(list);
                            }, (errorResponse) => {                                
                                deferred.resolve([]);
                            });
            
                            return deferred.promise;
                        }

                        loadDocumentFlowType() {
                            var deferred = this.$q.defer();
            
                            this.flowTypeService.getForDropdown(this.manualGoodsDeclarationCreate.Country.Id).query({
                            }, (list: Array<interfaces.applicationcore.IDropdownModel>) => {
                                
                                deferred.resolve(list);
                            }, (errorResponse) => {                              
                                deferred.resolve([]);
                            });
            
                            return deferred.promise;
                        }                        

                    },
                    controllerAs: "manualDeclarationCtrl",
                    size: "md",
                    resolve: {
                        ownerEntityId: () => { return this.consignment.OwnerEntityId }
                    }
                }).result;
            }


            viewRecon() {
                var selectedRow = <interfaces.customs.IGoodsDeclarationDisplay>this.apiGoodsDecList.selection.getSelectedRows()[0];
                if (selectedRow && selectedRow.Id > 0 && selectedRow.IsClearingInstruction) {
                    if (selectedRow.StatusIndicator == 0) {
                        this.generalService.displayMessage("No declaration has been received for the selected Clearing Instruction or the Customs Recon has not run.", Enum.EnumMessageType.Warning);
                    }
                    else {
                        this.$state.go("auth.ConsignmentImports.Update.CustomsRecon", { cusId: Number(selectedRow.Id) });
                    }
                }
                else {
                    this.generalService.displayMessage("Please select a Clearing Instruction", Enum.EnumMessageType.Warning);
                }
            }

            //Display the Create Version
            displayCreateVersion(isClearing: boolean,GoodsDeclarationType:string) {
                var hasAccepted: boolean = false;

                //Check to see if the lists have any with accepted.
                /*if (isClearing) {
                    //Check the Clearing Instructions List
                    for (let clearIn of this.consignment.ConsignmentClearingInstructionList) {
                        if (clearIn.isAccepted) {
                            hasAccepted = true;
                        }
                    }

                } else {
                    //Check the Goods Declaration List
                    for (let goodsDec of this.consignment.ConsignmentGoodsDeclarationList) {
                        if (goodsDec.isAccepted) {
                            hasAccepted = true;
                        }
                    }
                }*/

                
                for (let goodsDec of this.consignment.ConsignmentGoodsDeclarationList) {
                    if (goodsDec.PreventDeclarationAmendment) {
                        this.generalService.displayMessage("Customs Declaration " + goodsDec.MRNNumber+ " is in a status that prevents Amendments being generated.", Enum.EnumMessageType.Error);
                        return;
                    }
                }

                for (let goodsDec of this.consignment.ConsignmentGoodsDeclarationList) {
                    if (goodsDec.isAccepted) {
                        hasAccepted = true;
                    }
                }

                //If no Accepted was found.
                if (!hasAccepted) {
                    this.generate(isClearing,GoodsDeclarationType);
                    return;
                }

                this.$uibModal.open({
                    animation: true,
                    template: `
                    <form name="ChangeReason">
                        <div class="modal-content">
                            <div class="gts-padding">
                                <div class="modal-header">
                                    <h3 class="modal-title" id="modal-title">Create New Version</h3>
                                </div>
                                <div class="modal-body" id="modal-body">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <button type="button" class="btn btn-primary" ng-click="updateType('Amendment')" ng-disabled="!reason">Amendment</button>
                                        </div>
                                        <div class="col-md-6">
                                            <button type="button" class="btn btn-primary" ng-click="updateType('Cancellation')" ng-disabled="!reason">Cancellation</button>
                                        </div>
                                    </div>
                                    <br/>
                                    <div class="row">
                                        <p class="input-group-sm has-feedback" ng-class="{'has-error': ChangeReason.Reason.$invalid}">
                                                <textarea rows="3" name="Reason" ng-model="reason" class="form-control" ng-change="changeReason()"></textarea>
                                        </p>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-info" ng-click="ok()">Close</button>
                                </div>
                            </div>
                        </div>
                    </form>
                    `,
                    controller: ($scope, $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
                    ) => {
                        $scope.reason;
                        $scope.ok = () => {
                            $uibModalInstance.dismiss();
                        }

                        $scope.updateType = (type: string) => {
                            if (type == "Amendment") {
                                this.functionType = 385;
                            }

                            if (type == "Cancellation") {
                                this.functionType = 386;
                            }

                            this.generate(isClearing,GoodsDeclarationType);
                            $uibModalInstance.dismiss();
                        }

                        $scope.changeReason = () => {
                            this.reason = $scope.reason;
                        }
                    },
                    controllerAs: "createVersionCtrl",
                    size: "md",
                    resolve: {
                    }
                });
            }

            //////////////////////////////////////////////////
            editDetail(codId: number) {

                if (this.$stateParams.manId) {
                    if (this.isInbound) {
                        this.$state.go("auth.Manifests.Update.ConsignmentImport.Detail", { codId: codId });
                    } else {
                        this.$state.go("auth.Manifests.Update.ConsignmentExport.Detail", { codId: codId });
                    }
                } else {
                    if (this.isInbound) {
                        this.$state.go("auth.ConsignmentImports.Update.Detail", { codId: codId });
                    } else {
                        this.$state.go("auth.ConsignmentExports.Update.Detail", { codId: codId });
                    }
                }
            }

            gvwDocMatrix: uiGrid.IGridOptions = {
                data: [],
                enableFiltering: false,
                useExternalFiltering: false,
                enableCellEdit: false,
                useExternalSorting: false,
                multiSelect: false,
                enableColumnResizing: true,
                enableFullRowSelection: true,
                useExternalPagination: false,
                enableRowHeaderSelection: false,
                enableHorizontalScrollbar: 2,
                rowEditWaitInterval: -1,
                cellEditableCondition: true,
                showGridFooter: true,
                onRegisterApi: (gridApi) => { this.registerDocMatrixGridApi(gridApi); },
                columnDefs: [{
                    name: "EDIT",
                    displayName: "",
                    field: "ID",
                    cellTemplate: `
                        <div class="GridButton"> 
                            <button type="button" ng-click="grid.appScope.consignmentUpdateCtrl.removeInlineDocMatrixDoc(row.entity)" class="btn btn-warning btn-sm" ng-disabled="grid.appScope.consignmentUpdateCtrl.consignment.LockdownType>3">
                                Delete
                            </button>
                            <button type="button" ng-click="grid.appScope.consignmentUpdateCtrl.showDocMatrixNotes(row.entity)" ng-class="{'btn btn-info btn-sm': row.entity.Notes == '' , 'btn btn-primary btn-sm':  row.entity.Notes != ''}" ng-disabled="grid.appScope.consignmentUpdateCtrl.consignment.LockdownType>3">
                                <span class="fa fa-sticky-note"></span>
                            </button>
                            <a type="button" target="_blank" ng-href="#!/IFrameWindow/{{row.entity.ConsignmentMaintenanceUrl}}" ng-hide="row.entity.ConsignmentMaintenanceUrl==''"  class="btn btn-default btn-sm" ng-disabled="grid.appScope.consignmentUpdateCtrl.consignment.LockdownType>3">
                                <span class="fa fa-pencil"></span>
                            </a>
                        </div>`,
                    enableSorting: false,
                    enableColumnMenu: false,
                    enableCellEdit: false,
                    width: 130,
                    enableCellEditOnFocus: false,

                },
                {
                    name: "DESCRIPTION",
                    displayName: "* Description",
                    field: "Description",
                    type: "string",
                    cellClass: 'text-left',
                    enableCellEdit: false,                    
                    cellTemplate: `<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD}}">{{MODEL_COL_FIELD}}</div>`,
                    enableCellEditOnFocus: false,
                    width: 400
                },
                
                /* {
                    name: "REPORT",
                    displayName: "Document *",
                    field: "Report",
                    type: "string",
                    cellClass: 'text-left',
                    enableCellEdit: true,
                    cellEditableCondition: () => { return this.consignment ? this.consignment.LockdownType < 4 : true },
                    cellTemplate: `<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD.Display}}">{{MODEL_COL_FIELD.Display}}</div>`,
                    editableCellTemplate: `
                            <form name="inputForm">
                                <gts-dropdown ui-select-wrap name="ReportCode-{{MODEL_COL_FIELD.$$hashKey}}" append-to-body="true" ng-model="MODEL_COL_FIELD" form="inputForm" load-data="grid.appScope.consignmentUpdateCtrl.loadReportList()"></gts-dropdown>
                            </form>`,
                    enableCellEditOnFocus: true,
                    width: 300
                }, {
                    name: "DOCTYPE",
                    displayName: "Document Type *",
                    field: "DocType",
                    type: "number",
                    cellClass: 'text-left',
                    enableCellEdit: true,
                    cellEditableCondition: () => { return this.consignment ? this.consignment.LockdownType < 4 : true },
                    cellTemplate: `<div class="ui-grid-cell-contents">{{MODEL_COL_FIELD.Display}}</div>`,
                    editableCellTemplate: `
                    <form name="inputForm">
                        <gts-dropdown ui-select-wrap name="DocType-{{MODEL_COL_FIELD.$$hashKey}}" append-to-body="true" ng-model="MODEL_COL_FIELD" form="inputForm" load-data="grid.appScope.consignmentUpdateCtrl.loadDocumentTypes()"></gts-dropdown>
                    </form>`,
                    enableCellEditOnFocus: true,
                    width: 200
                },*/ {
                    name: "ACTION",
                    displayName: "* Action",
                    field: "Action",
                    type: "string",
                    cellClass: 'text-left',
                    enableCellEdit: true,
                    cellEditableCondition: () => { return this.consignment ? this.consignment.LockdownType < 4 : true },
                    cellTemplate: `<div class="ui-grid-cell-contents">{{MODEL_COL_FIELD.Display}}</div>`,
                    editableCellTemplate: `
                        <form name="inputForm">
                            <gts-dropdown ng-disabled="grid.appScope.consignmentUpdateCtrl.consignment.LockdownType>3" ui-select-wrap name="ReportCode-{{MODEL_COL_FIELD.$$hashKey}}" append-to-body="true" ng-model="MODEL_COL_FIELD" form="inputForm" load-data="grid.appScope.consignmentUpdateCtrl.loadActionList()"></gts-dropdown>
                        </form>`,
                    enableCellEditOnFocus: true,
                    width: 210
                }, {
                    name: "COMPLETED",
                    displayName: "Completed",
                    enableFiltering: false,
                    width: 100,
                    enableCellEdit: true,
                    enableCellEditOnFocus: true,
                    cellEditableCondition: () => { return this.consignment ? this.consignment.LockdownType < 4 : true },
                    cellTemplate: `<input type="checkbox" ng-click="grid.appScope.consignmentUpdateCtrl.docMatrixCompleteChanged(row)" ng-disabled="false" ng-model="row.entity.Completed">`,
                    editableCellTemplate: ` 
                        <form name="inputForm">
                            <p class="input-group-sm">
                                <input type="checkbox" ng-disabled="false" ng-model="row.entity.Completed" ng-click="grid.appScope.consignmentUpdateCtrl.docMatrixCompleteChanged(row.entity)">
                            </p>
                        </form>`
                }, {
                    name: "COMPLETEDBY",
                    displayName: "Completed By",
                    field: "CompletedBy",
                    width: 160,
                    enableCellEdit: false,
                    enableCellEditOnFocus: false,
                    cellTemplate: `<div class="ui-grid-cell-contents">{{MODEL_COL_FIELD}}</div>`
                }, {
                    name: "COMPLETEDON",
                    displayName: "Completed On",
                    field: "CompletedOn",
                    width: 160,
                    enableCellEdit: false,
                    enableCellEditOnFocus: false,
                    cellTemplate: `<div class="ui-grid-cell-contents">{{MODEL_COL_FIELD | momentDateFilter: 'YYYY/MM/DD h:mm:ss a'}}</div>`
                }, {
                    name: "GTSCONNECT",
                    displayName: "GTS Connect?",
                    enableFiltering: false,
                    width: 120,
                    field: "GTSConnect",
                    enableCellEdit: false,
                    enableCellEditOnFocus: false,
                    cellTemplate: `<input type="checkbox" ng-disabled="false" ng-model="row.entity.GTSConnect">`,
                    editableCellTemplate: ` 
                        <form name="inputForm">
                            <p class="input-group-sm">
                                <input type="checkbox" ng-disabled="false" ng-model="row.entity.GTSConnect">
                            </p>
                        </form>`
                },]
            };

            getAllowGenerateReqDocsRight() {
                this.allowGenerateReqDocs = false;
                return this.menuService.getGTSConnectMenuItem(581).get((result: interfaces.applicationcore.IMenu) => {
                    if (result && result.name) {
                        this.allowGenerateReqDocs = true;
                    }

                    if (this.consignment.LockdownType === 5){
                        //Full lockdown then Cant Create New Version 
                        this.allowCreateNewVersion = false;
                    }
                                        
                }).$promise;
            }

            getAllowCreateNewVersionExportRight() {
                this.allowCreateNewVersion = false;

                var rightId = 470;
                if (this.consignment.LockdownType >= 3)
                    rightId = 513;

                return this.menuService.getGTSConnectMenuItem(rightId).get((result: interfaces.applicationcore.IMenu) => {
                    if (result && result.name) {
                        this.allowCreateNewVersion = true;
                    }

                    if (this.consignment.LockdownType === 5){
                        //Full lockdown then Cant Create New Version 
                        this.allowCreateNewVersion = false;
                    }

                }).$promise;
            }

            getAllowViewRefundClaimRight() {
                this.allowCreateNewVersion = false;
                return this.menuService.getGTSConnectMenuItem(545).get((result: interfaces.applicationcore.IMenu) => {
                    if (result && result.name) {
                        this.hasViewRefundClaimRights = true;
                    }
                }).$promise;
            }

            getHasGenerateRemoveClearInRight(){
                this.hasGenerateRemoveClearInRight = false;
                return this.menuService.getGTSConnectMenuItem(698).get((result: interfaces.applicationcore.IMenu) => {
                    if (result && result.name) {
                        this.hasGenerateRemoveClearInRight = true;
                    }
                }).$promise;
            }

            getHasGenerateAndRemoveGoodsDeclarationRight(){
                this.hasGenerateAndRemoveGoodsDeclarationRight = false;
                return this.menuService.getGTSConnectMenuItem(572).get((result: interfaces.applicationcore.IMenu) => {
                    if (result && result.name) {
                        this.hasGenerateAndRemoveGoodsDeclarationRight = true;
                    }
                }).$promise;
            }     

            getHasAddRemoveGoodsDecRight(){
                this.hasAddRemoveManualGoodsDecRight = false;
                return this.menuService.getGTSConnectMenuItem(699).get((result: interfaces.applicationcore.IMenu) => {
                    if (result && result.name) {
                        this.hasAddRemoveManualGoodsDecRight = true;
                    }
                }).$promise;
            }            

            getAllowCreateNewVersionImportRight() {
                this.allowCreateNewVersion = false;

                var rightId = 471;
                if (this.consignment.LockdownType >= 3)
                    rightId = 514;

                return this.menuService.getGTSConnectMenuItem(rightId).get((result: interfaces.applicationcore.IMenu) => {
                    if (result && result.name) {
                        this.allowCreateNewVersion = true;
                    }
                }).$promise;
            }

            getExportConsignmentResponsibleUserOverrideRight() {                 
                var rightId = 707;
                return this.menuService.getGTSConnectMenuItem(rightId).get((result: interfaces.applicationcore.IMenu) => {
                    if (result && result.name) {
                        this.hasOverrideResponsibleUserRight = true;
                      
                    }
                }).$promise;
            }

            getImportConsignmentResponsibleUserOverrideRight() {
                 
                var rightId = 708;
                return this.menuService.getGTSConnectMenuItem(rightId).get((result: interfaces.applicationcore.IMenu) => {
                    if (result && result.name) {
                        this.hasOverrideResponsibleUserRight = true;
                    
                    }
                }).$promise;
            }

            getConsignmentNumberOverrideRight(rightId:number) {        
                    
                return this.menuService.getGTSConnectMenuItem(rightId).get((result: interfaces.applicationcore.IMenu) => {
   
                    if (result && result.name) {
                        this.hasOverrideConsignmentNumberRight = true;
                      
                    }
                }).$promise;
            }



            registerDocMatrixGridApi(gridApi: uiGrid.IGridApi) {
                this.apiConDocList = gridApi;
            }

            loadDocumentTypes() {

                return this.documentTypeService.getDocumentTypes().query({
                    repTypeId: this.documentRepository.RepositoryTypeId,
                    ownerEntityId: this.documentRepository.OwnerEntityId,
                    referenceNumber: this.consignment.WaybillNumber
                }, (documentTypes: ng.resource.IResourceArray<interfaces.applicationcore.IDropdownModel>) => {
                    this.documentTypes = documentTypes;
                }, (errorResponse) => {
                    this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                }).$promise;
            }

            loadActionList() {
                return this.classificationValueService.GetClassificationValueDropdownByClassification().query({
                    classificationId: Enum.ClassificationEnum.DocumentActionType
                }, (resultList) => {
                    this.actionList = resultList;
                }).$promise;
            }

            loadReportList() {
                return this.consignmentDocumentService.GetReportDropdownList().query({

                }, (resultList) => {
                    this.reportList = resultList;
                }).$promise;
            }

            DocMatrixAdd_click(){

                this.displayAddDocMatrixActionManual().then((result:interfaces.logistics.IConsignmentDocument) => {
                    if (result) {
                     
 
                    (<Array<any>>(this.gvwDocMatrix.data)).splice(0, 0, result);

                    this.$timeout(() => {
                        if (this.apiConDocList) {
                            this.apiConDocList.rowEdit.setRowsDirty([result]);
                            this.apiConDocList.core.notifyDataChange(this.uiGridConstants.dataChange.ALL);
                        }
                    });

                        
                    }
                });


            }

            displayAddDocMatrixActionManual() {
                return this.$uibModal.open({
                    animation: true,
                    template: `
                        <div class="modal-content" >
                            <form name="conDocMatrixAdd">
                                <div class="gts-padding">
                                    <fieldset id="conDocMatrixAdd">
                                    <legend>
                                        Consignment Documents - Add Action
                                    </legend>                                            
                                    <div class="row">
                                          <div class="vertical-align">
                                              <div class="col-md-4">
                                                  <req></req>
                                                  <label>Action Type</label>
                                              </div>
                                              <div class="col-md-8">
                                                  <gts-dropdown name="actions" ng-model="Action" form="trade" list="actions" ng-change="actionChange(model)" load-data="loadActionList()" required="true"></gts-dropdown>
                                              </div>
                                          </div>

                                          <div class="vertical-align" ng-if="Action && (Action.Id === 485  || Action.Id===487)">
                                              <div class="col-md-4">
                                                  <req></req>
                                                  <label>Report</label>
                                              </div>
                                              <div class="col-md-8">
                                                  <gts-dropdown name="report" ng-model="Report" form="trade" load-data="loadReportList()" required="true"  ng-change="reportChange(model)"></gts-dropdown>
                                              </div>
                                          </div>          

                                          <div class="vertical-align"  ng-if="Action && (Action.Id===486 || Action.Id===487)">
                                              <div class="col-md-4">
                                                  <req></req>
                                                  <label>Document Type</label>
                                              </div>
                                              <div class="col-md-8">
                                                  <gts-dropdown name="document" ng-model="Document" form="trade" load-data="loadDocumentTypes()" required="true"  ng-change="docChange(model)"></gts-dropdown>
                                              </div>
                                          </div>    

                                          <div class="vertical-align"  ng-if="Action && (Action.Id === 488)">
                                              <div class="col-md-4">
                                                  <req></req>
                                                  <label>Action Text</label>
                                              </div>
                                              <div class="col-md-8">
                                                <p class="input-group-sm has-feedback" ng-class="{'has-error': conDocMatrixAdd.actionText.$invalid}">
                                                  <textarea rows="3" ng-change="actionTextChanged(actionText)" name="actionText" ng-model="actionText" class="form-control"></textarea>
                                                </p>
                                              </div>
                                          </div>   

                                          <div class="vertical-align">
                                                <div class="col-md-4">
                                                  <opt></opt>
                                                    <label>Show in GTS Connect?</label>
                                                  </div>
                                                    <div class="col-md-8">
                                                  <p class="input-group-sm">
                                                    <input type="checkbox" ng-model="showInGTSConnect">
                                                       </p>
                                                      </div>
                                            </div>                                                                                                                                                             
                                        
                                        </div>                                        
                                            <div class="gts-padding pull-right">                                
                                                    <button type="button" class="btn btn-primary" ng-disabled="!Action || (Action.Id === 485 && !Report) || (Action.Id === 486 && !Document) || (Action.Id === 487 && (!Report || !Document))  || (Action.Id === 488 && !actionText)" ng-click="ok()">Ok</button>
                                                    <button type="button" class="btn btn-info" ng-click="cancel()">Cancel</button>
                                            </div>                                       
                                    </fieldset>
                                </div>
                            </form>
                        </div>
                    `
                    ,
                    controller: ($scope, $uibModalInstance: angular.ui.bootstrap.IModalInstanceService) => {

                        $scope.actionText = undefined;

                        $scope.actionChange = (model:interfaces.applicationcore.IDropdownModel) =>{

                            $scope.Action = model;
                            if ($scope.Action.Id === 488){
                                $scope.Report = undefined;
                                $scope.Document = undefined;
                            }
                            else{
                                $scope.actionText = undefined;
                            }

                            switch($scope.Action.Id) { 
                                case 488: { 
                                    $scope.Report = undefined;
                                    $scope.Document = undefined;
                                   break; 
                                } 
                                case 485: { 
                                    $scope.Document = undefined;
                                    $scope.actionText = undefined;
                                   break; 
                                } 
                                case 486: { 
                                    $scope.Report = undefined;
                                    $scope.actionText = undefined;
                                    break; 
                                 }   
                                 case 487: { 
                                    $scope.actionText = undefined;
                                    break; 
                                 }                                                                                                            
                                default: { 
                                   //statements; 
                                   break; 
                                } 
                             } 
                        }

                        $scope.actionTextChanged = (model:string) =>{
                            $scope.actionText = model;
                        }

                        $scope.reportChange = (model:interfaces.applicationcore.IDropdownModel) =>{
                            $scope.Report = model;
                            this.reportService.GetDocumentFromReport($scope.Report.Id).get((data: interfaces.applicationcore.IDropdownModel) => {
                                if (data.Id>0){
                                    $scope.Document = data;
                                }
                                else
                                {
                                    $scope.Document = undefined;
                                }
                            }, (errorResponse) => {
                                this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                            })
                        }


                        $scope.docChange = (model:interfaces.applicationcore.IDropdownModel) =>{
                            $scope.Document = model;
                        }                        

                        $scope.cancel = () => {
                            $uibModalInstance.dismiss();
                        }

                        $scope.ok = () => {
                            var actionText = '';
                            switch($scope.Action.Id) { 
                                case 488: { 
                                    actionText =  $scope.actionText;
                                   break; 
                                } 
                                case 485: { 
                                    actionText = $scope.Report.Display;
                                   break; 
                                } 
                                case 486: { 
                                    actionText = $scope.Document.Display; 
                                    break; 
                                 }   
                                 case 487: { 
                                    actionText = $scope.Document.Display; 
                                    break; 
                                 }                                                                                                            
                                default: { 
                                   //statements; 
                                   break; 
                                } 
                             } 

                            var consignmentDoc = <interfaces.logistics.IConsignmentDocument> {
                                Action: $scope.Action,
                                Description : actionText,
                                Report : $scope.Report,
                                DocType : $scope.Document,                               
                                GTSConnect: $scope.showInGTSConnect,
                                Notes: ''
                            };

                            $uibModalInstance.close(consignmentDoc);
                        };

                        $scope.loadDocumentTypes = () => {

                            return this.documentTypeService.getDocumentTypes().query({
                                repTypeId: this.documentRepository.RepositoryTypeId,
                                ownerEntityId: this.documentRepository.OwnerEntityId,
                                referenceNumber: this.consignment.WaybillNumber
                            }, (documentTypes: ng.resource.IResourceArray<interfaces.applicationcore.IDropdownModel>) => {
                                this.documentTypes = documentTypes;
                            }, (errorResponse) => {
                                this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                            }).$promise;
                        }
            
                        $scope.loadActionList = () => {
                            return this.classificationValueService.GetClassificationValueDropdownByClassification().query({
                                classificationId: Enum.ClassificationEnum.DocumentActionType
                            }, (resultList) => {
                                $scope.actions = resultList.filter((value)=>{return value.Id===485 || value.Id==486 || value.Id==487  || value.Id === 488});
                            }).$promise;
                        }
            
                        $scope.loadReportList = () => {
                            return this.consignmentDocumentService.GetReportDropdownList().query({
            
                            }, (resultList) => {
                                this.reportList = resultList;
                            }).$promise;
                        }      

                        $scope.loadActionList();

                    },
                    controllerAs: "conDocMatrixAddManualCtrl",
                    size: "md",
                    resolve: {

                    }
                }).result;
            }

            DocMatrixAddDefault_click() {
                this.generalService.displayConfirmationBox("Confirm?", "Any existing records will be deleted, do you want to continue?").then((result: boolean) => {
                    this.$timeout(() => {
                        this.bsLoadingOverlayService.wrap({
                            referenceId: 'con.update'
                        }, () => {
                            if (result) {
                                return this.ConsignmentDocumentAddDefault();
                            }
                        });
                    });
                });
            }

            ConsignmentDocumentAddDefault() {
                var conId = this.consignment.Id;

                return this.consignmentDocumentService.AddDefaultDocuments().save(
                    { conId },
                    () => {
                        //Result
                        this.$timeout(() => {
                            this.bsLoadingOverlayService.wrap({
                                referenceId: 'con.update'
                            }, () => {
                                return this.loadConsignment();
                            });
                        });

                    }, (failureData) => {
                        this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                    }).$promise;
            }

            DocMatrxGenerateRequiredDocs_click() {
                this.generalService.displayConfirmationBox("Confirm?", "Generate Documents for Consignment?").then((result: boolean) => {
                    this.$timeout(() => {
                        this.bsLoadingOverlayService.wrap({
                            referenceId: 'con.update'
                        }, () => {
                            if (result) {
                                return this.SaveConsignment().then(() => {
                                    return this.ConsignmentDocumentGenerateDocs();
                                }, () => {
                                    return;
                                });
                            }
                        });
                    });
                });
            }

            ConsignmentDocumentGenerateDocs() {
                var conId = this.consignment.Id;

                return this.consignmentDocumentService.GenerateRequiredDocuments().save(
                    { conId },
                    () => {
                        //Result
                        this.$timeout(() => {
                            this.bsLoadingOverlayService.wrap({
                                referenceId: 'con.update'
                            }, () => {
                                return this.loadConsignment();
                            });
                        });
                    }, (failureData) => {
                        this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                    }).$promise;
            }

            addInlineDocMatrixDoc() {
                /*this.consignment.ConsignmentDocumentList.push(<interfaces.logistics.IConsignmentDocument>{
                    Id: 0,
                    Notes: "",
                    ConsignmentMaintenanceUrl:""
                });*/

                var doc = {
                    Id: 0,
                    Notes: "",
                    ConsignmentMaintenanceUrl: ""
                };
              
                (<Array<any>>(this.gvwDocMatrix.data)).splice(0, 0, doc);
            }

            showDocMatrixNotes(entity: interfaces.logistics.IConsignmentDocument) {

                this.displayNotes(entity.Notes).then((result) => {
                    //if (result) {

                    entity.Notes = result;
                    this.apiConDocList.rowEdit.setRowsDirty([entity]);
                    // }
                });


            }

            docMatrixCompleteChanged(row: uiGrid.IGridRow) {
                if (row.entity.Completed) {
                    row.entity.CompletedBy = this.$rootScope.userFullName;
                    row.entity.CompletedOn = moment().parseZone();// moment().toDate();
                }
                else {
                    row.entity.CompletedBy = null
                    row.entity.CompletedOn = null;
                }

                this.apiConDocList.rowEdit.setRowsDirty([row.entity]);
            }

            removeInlineDocMatrixDoc(entity: interfaces.logistics.IConsignmentDocument) {
                this.bsLoadingOverlayService.wrap({
                    referenceId: 'con.update'
                }, () => {
                    return this.consignmentDocumentService.delete().delete({ dmcId: entity.Id }, (result) => {
                        this.$timeout(() => {
                            this.bsLoadingOverlayService.wrap({
                                referenceId: 'con.update'
                            }, () => {
                                return this.loadConsignment();
                            });
                        });
                    }, (errorResponse) => {
                        this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                    });
                });

                _.remove(this.gvwDocMatrix.data, (o) => {
                    return o === entity;
                });
            }

            displayNotes(Notes: string) {
                //Get delivery status
                return this.$uibModal.open({
                    animation: true,
                    template: `
                        <div class="modal-content" >
                            <form name="conDocNotes">
                                <div class="gts-padding">
                                    <fieldset id="conDocNotes">
                                    <legend>
                                        Consignment Document Notes
                                    </legend>                                            
                                            <div class="row vertical-align">
                                                <div class="col-md-12">
                                                    <p class="input-group-sm has-feedback" ng-class="{'has-error': docNotes.$invalid}">
                                                         <textarea id="docNotes" class="form-control" ng-model="Notes" rows="25"></textarea>
                                                    </p>
                                                </div>                                               
                                            </div>                                            
                                            <div class="gts-padding pull-right">                                               
                                                    <button type="button" class="btn btn-primary" ng-disabled="conDocNotes.$invalid" ng-click="ok()">Ok</button>
                                                    <button type="button" class="btn btn-info" ng-click="cancel()">Cancel</button>
                                            </div>                                       
                                    </fieldset>
                                </div>
                            </form>
                        </div>
                    `
                    ,
                    controller: ($scope, $uibModalInstance: angular.ui.bootstrap.IModalInstanceService) => {
                        $scope.Notes = Notes;
                        $scope.cancel = () => {
                            $uibModalInstance.dismiss();
                        }

                        $scope.ok = () => {
                            $uibModalInstance.close($scope.Notes);
                        };
                    },
                    controllerAs: "conDocumentNotesCtrl",
                    size: "md",
                    resolve: {

                    }
                }).result;
            }

            createNewVersion_Click() {
                this.generalService.displayConfirmationBox("Confirm?", "Create new version?").then((result: boolean) => {
                    if (result) {
                        this.bsLoadingOverlayService.wrap({
                            referenceId: 'con.update'
                        }, () => {
                            return this.createNewVersion(this.consignment.Id);
                        });
                    }
                });
            }

            downloadToExcel() {
                this.bsLoadingOverlayService.wrap({
                    referenceId: 'con.update'
                },
                    () => {
                        this.consignmentService.GetConsignmentsPRListExcel(this.consignment.Id, this.showOnlyProhibited).then(() => {
                        }, (data) => {
                            this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>data.data);
                        });
                    });
            }

            showOnlyPRProhibited() {
                this.bsLoadingOverlayService.wrap({
                    referenceId: 'con.update'
                }, () => {
                        return this.consignmentService.ViewDetailPR().query({
                            conId: this.consignment.Id,
                            showOnlyProhibited: this.showOnlyProhibited,
                        }, (result: Array<interfaces.consignment.IConsignmentPRDisplay>) => {

                                this.consignment.ConsignmentPRList = result;
                                this.gvwPRList.data = result;

                    }, (errorResponse) => {
                        this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                    }).$promise;
                });
            }

            //////////////////////////////////////////////
            //P&R List.
            gvwPRList: uiGrid.IGridOptions | any = {
                data: [],
                enableCellEdit: false,
                useExternalSorting: false,
                multiSelect: false,
                enableColumnResizing: true,
                enableFullRowSelection: true,
                enableRowHeaderSelection: false,
                enableHorizontalScrollbar: 2,
                enableVerticalScrollbar: 1,
                rowEditWaitInterval: -1,
                cellEditableCondition: true,
                showGridFooter: false,
                //Pagination
                paginationPageSizes: [25, 50, 75, 100],
                paginationPageSize: 25,
                useExternalPagination: false,
                //Menu + Download
                enableGridMenu: false,
                exporterMenuCsv: false,
                exporterMenuPdf: false,
                exporterMenuExcel: false,
                gridMenuShowHideColumns: false,
                exporterFieldCallback: (grid, row, col, value) => {
                    return this.generalService.handleValue(value);
                },
                //Filters
                enableFiltering: true,
                useExternalFiltering: false,
                onRegisterApi: (gridApi) => { this.registerPRGridApi(gridApi) },
                columnDefs: [
                {
                    name: "EDIT",
                    displayName: "",
                    field: "",
                    width: 20,
                    enableFiltering: false,
                    enableSorting: false,
                    enableColumnMenu: false,
                },{
                    name: "ProductCode",
                    displayName: "Product Code",
                    field: "ProductCode",
                    width: 100,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                </div>
                            </div>`,
                }, {
                    name: "ProductDescription",
                    displayName: "Description",
                    field: "ProductDescription",
                    cellTemplate: `<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD}}">{{MODEL_COL_FIELD}}</div>`,
                    width: 210,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                </div>
                            </div>`,
                }, {
                    name: "CountryCode",
                    displayName: "Country",
                    field: "CountryCode",
                    width: 73,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                </div>
                            </div>`,
                }, {
                    name: "Flow",
                    displayName: "Flow",
                    field: "Flow",
                    width: 60,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                </div>
                            </div>`,
                }, {
                    name: "Restriction",
                    displayName: "Restriction",
                    field: "Restriction",
                    width: 220,
                    cellTemplate: `<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD.Display}}"><a href="/ApplicationCore/GTS/index.html#!/ProhibitedAndRestricted/RestrictionDetail/{{MODEL_COL_FIELD.Id}}" target="_blank">{{MODEL_COL_FIELD.Display}}</a></div>`,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                </div>
                            </div>`,
                    filter: {
                        condition: (searchTerm, cellValue) => {
                            return (searchTerm.length === 0 || cellValue.Code.toLocaleLowerCase().indexOf(searchTerm.toLocaleLowerCase()) >= 0 || cellValue.Description.toLocaleLowerCase().indexOf(searchTerm.toLocaleLowerCase()) >= 0);
                        }
                    },
                }, {
                    name: "IsProhibited",
                    displayName: "Prohibited",
                    field: "IsProhibited",
                    width: 84,
                    cellTemplate: `<input type="checkbox" ng-disabled="true" ng-model="MODEL_COL_FIELD">`,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="checkbox" ng-model="colFilter.term" ng-model-options="{ debounce: 200 }"/></div>
                            </div>`
                }, {
                    name: "IsException",
                    displayName: "Is Exception",
                    field: "IsException",
                    width: 91,
                    cellTemplate: `<input type="checkbox" ng-disabled="false" ng-model="MODEL_COL_FIELD" ng-click="grid.appScope.consignmentUpdateCtrl.permitExceptionChanged(row)">`,
                    enableCellEdit: true,
                    enableCellEditOnFocus: true,
                    editableCellTemplate:
                        `   <form name="inputForm">
                            <p class="input-group-sm">
                                <input type="checkbox" ng-disabled="false" ng-model="MODEL_COL_FIELD" ng-click="grid.appScope.consignmentUpdateCtrl.permitExceptionChanged(row.entity)">
                            </p>
                        </form>`,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="checkbox" ng-model="colFilter.term" ng-model-options="{ debounce: 200 }"/></div>
                            </div>`
                }, {
                    name: "Permit",
                    displayName: "Permit",
                    field: "Permit",
                    width: 160,
                    cellTemplate: `<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD.Display}}">{{MODEL_COL_FIELD.Display}}</div>`,
                    editableCellTemplate: `
                        <form name="inputForm">                                               
                            <p class="input-group-sm" ng-show="row.entity.RestrictionQuotaTypeId === 755">
                                <input type="text" name="PermitNumber-{{MODEL_COL_FIELD.$$hashKey}}" ng-model="MODEL_COL_FIELD.Display" ng-class="'colt' + col.uid" class="form-control" ui-grid-editor ng-change="grid.appScope.consignmentUpdateCtrl.permitCodeChange(row)" />
                            </p>                           
                        </form>
                        <gts-dropdown ng-show="row.entity.RestrictionQuotaTypeId != 755" ui-select-wrap name="Permit-{{MODEL_COL_FIELD.$$hashKey}}" append-to-body="true" ng-model="MODEL_COL_FIELD" form="inputForm" ng-change="grid.appScope.consignmentUpdateCtrl.permitCodeDropdownChange(row)" load-data="grid.appScope.consignmentUpdateCtrl.loadPermits(row, searchText)" pagination-search="true" refresh-delay="1000"></gts-dropdown>`,
                    enableCellEdit: true,
                    enableCellEditOnFocus: true,
                    cellEditableCondition: () => { return this.consignment ? this.consignment.LockdownType < 3 : true },
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                </div>
                            </div>`,
                    filter: {
                        condition: (searchTerm, cellValue) => {
                            if (cellValue){
                                if (cellValue.Description) {
                                    return (searchTerm.length === 0 || cellValue.Display.toLocaleLowerCase().indexOf(searchTerm.toLocaleLowerCase()) >= 0 || cellValue.Description.toLocaleLowerCase().indexOf(searchTerm.toLocaleLowerCase()) >= 0);
                                } else {
                                    return (searchTerm.length === 0 || cellValue.Display.toLocaleLowerCase().indexOf(searchTerm.toLocaleLowerCase()) >= 0);
                                }
                            }
                        }
                    },
                },{
                    name: "PermitDisplay",
                    displayName: "",
                    field: "Permit",
                    width: 50,
                    enableFiltering: false,
                    enableSorting: false,
                    enableColumnMenu: false,
                    cellTemplate: `<div class="ui-grid-cell-contents"><a ng-show="{{MODEL_COL_FIELD.Id}}" href="/ApplicationCore/GTS/index.html#!/MasterData/Permit/UpdatePermit/{{MODEL_COL_FIELD.Id}}" target="_blank">View</a></div>`,
                },{
                    name: "IsQuota",
                    displayName: "Quota",
                    field: "IsQuota",
                    width: 58,
                    cellTemplate: `<input type="checkbox" ng-disabled="true" ng-model="MODEL_COL_FIELD">`,
                    filterHeaderTemplate: `
                        <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                            <div class="input-group-sm">
                                <input type="checkbox" ng-model="colFilter.term" ng-model-options="{ debounce: 200 }"/></div>
                        </div>`
                }, {
                    name: "IsQuotaAllocated",
                    displayName: "Quota Allocated",
                    field: "IsQuotaAllocated",
                    width: 150,
                    cellTemplate: `<input type="checkbox" ng-disabled="true" ng-model="MODEL_COL_FIELD">`,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="checkbox" ng-model="colFilter.term" ng-model-options="{ debounce: 200 }"/></div>
                            </div>`
                }, {
                    name: "QuotaRequiredValue",
                    displayName: "Quota Value",
                    field: "QuotaRequiredValue",
                    width: 150,
                    cellFilter: "number: 2",
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="number" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                </div>
                            </div>`,
                 }, {
                    name: "QuotaAllocatedValue",
                    displayName: "Allocated Value",
                    field: "QuotaAllocatedValue",
                    width: 150,
                    cellFilter: "number: 2",
                    enableCellEdit: true,
                    enableCellEditOnFocus: true,
                    cellEditableCondition: () => { return this.consignment ? this.consignment.LockdownType < 3 : true },
                    filterHeaderTemplate: `
                        <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                            <div class="input-group-sm">
                                <input type="number" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                            </div>
                        </div>`,
                    editableCellTemplate: `
                            <form name="inputForm">
                                <p class="input-group-sm">
                                    <input type="number" ng-disabled="!(row.entity.RestrictionQuotaTypeId === 798 || row.entity.RestrictionQuotaTypeId === 740 || !row.entity.QuotaRequiredValue)" name="QuotaAllocatedValue-{{MODEL_COL_FIELD.$$hashKey}}" ng-model="MODEL_COL_FIELD" ng-class="'colt' + col.uid" class="form-control" ui-grid-editor step="0.01" />
                                </p>
                            </form>`,
                }, {
                    name: "QuotaCurrency",
                    displayName: "Currency",
                    field: "QuotaCurrency",
                    width: 75,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                </div>
                            </div>`,
                }, {
                    name: "QuotaRequiredAmount",
                    displayName: "Quota Amount",
                    field: "QuotaRequiredAmount",
                    width: 150,
                    cellFilter: "number: 2",
                    filterHeaderTemplate: `
                        <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                            <div class="input-group-sm">
                                <input type="number" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                            </div>
                        </div>`,
                }, {
                    name: "QuotaAllocatedAmount",
                    displayName: "Allocated Amount",
                    field: "QuotaAllocatedAmount",
                    width: 150,
                    cellFilter: "number: 2",
                    enableCellEdit: true,
                    enableCellEditOnFocus: true,
                    cellEditableCondition: () => { return this.consignment ? this.consignment.LockdownType < 3 : true },
                    filterHeaderTemplate: `
                    <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                        <div class="input-group-sm">
                            <input type="number" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                        </div>
                    </div>`,
                    editableCellTemplate: `
                        <form name="inputForm">
                            <p class="input-group-sm">
                                <input type="number" ng-disabled="!(row.entity.RestrictionQuotaTypeId === 798 || row.entity.RestrictionQuotaTypeId === 739 || !row.entity.QuotaRequiredAmount)" name="QuotaAllocatedAmount-{{MODEL_COL_FIELD.$$hashKey}}" ng-model="MODEL_COL_FIELD" ng-class="'colt' + col.uid" class="form-control" ui-grid-editor step="0.01" />
                            </p>
                        </form>`,
                }, {
                    name: "QuotaUnitOfMeasure",
                    displayName: "UoM",
                    field: "QuotaUnitOfMeasure",
                    width: 58,
                    filterHeaderTemplate: `
                        <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                            <div class="input-group-sm">
                                <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                            </div>
                        </div>`,
                },{
                    name: "TariffCode",
                    displayName: "Tariff Code",
                    field: "TariffCode",
                    width: 110,
                    cellTemplate: `<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD}}">{{MODEL_COL_FIELD}}</div>`,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                </div>
                            </div>`,
                }, {
                    name: "Comments",
                    displayName: "Comments",
                    field: "Comments",
                    width: 125,
                    cellTemplate: `<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD}}">{{MODEL_COL_FIELD}}</div>`,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                </div>
                            </div>`,
                }]
            };

            registerPRGridApi(gridApi: uiGrid.IGridApi) {
                this.apiPRList = gridApi;

                this.apiPRList.pagination.on.paginationChanged(this.$scope, (newPage, pageSize) => { this.PRListPageChange(newPage, pageSize) });

                this.apiPRList.cellNav.on.navigate(this.$scope, (newCol) => {
                    this.$timeout(() => {
                        this.apiPRList.selection.selectRow(newCol.row.entity);
                    });
                });
            }

            PRListPageChange(newPage, pageSize) {
                this.paginationPROptions.pageNumber = newPage;
                this.paginationPROptions.pageSize = pageSize;
            }

            loadPermits(row: uiGrid.IGridRow, searchText: string) {
                return this.consignmentService.GetPermitsForDropdown().query({
                    consignmentRestrictionId: row.entity.Id,
                    searchText: searchText
                }, () => {
                }, (failureData) => {
                    this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                }).$promise;
            }

            permitExceptionChanged(row: uiGrid.IGridRow) {
                this.apiPRList.rowEdit.setRowsDirty([row.entity]);
            }

            permitCodeChange(row: uiGrid.IGridRow) {
                this.apiPRList.rowEdit.setRowsDirty([row.entity]);
                row.entity.Permit.Id = null;
                row.entity.Permit.Description = row.entity.Permit.Display;
            }

            permitCodeDropdownChange(row: uiGrid.IGridRow) {
                this.apiPRList.rowEdit.setRowsDirty([row.entity]);
            }


            checkPR() {
                this.bsLoadingOverlayService.wrap({
                    referenceId: 'con.update'
                }, () => {
                    return this.SaveConsignment().then(() => {
                        this.consignmentService.CheckForPR(this.consignment.Id, this.consignment.IsInbound).save((result) => {
                            this.generalService.displayMessageHandler(result);
                            this.$anchorScroll("topAnchor");

                            if (!result.HasErrorMessage) {
                                this.$timeout(() => {
                                    this.bsLoadingOverlayService.wrap({
                                        referenceId: 'con.update'
                                    }, () => {
                                        return this.loadConsignment();
                                    });
                                });
                            }
                        }, (failureData) => {
                            this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                            this.$anchorScroll("topAnchor");
                        }).$promise;
                    }, () => {
                        return;
                    });
                });
            }

            addPermit() {
                if (this.apiPRList && this.apiPRList.selection.getSelectedRows().length > 0) {

                    var selected: interfaces.consignment.IConsignmentPRDisplay = this.apiPRList.selection.getSelectedRows()[0];

                    if (selected.Restriction === null) {
                        this.generalService.displayMessage("Only P&R Lines linked to restrictions can be split.", Enum.EnumMessageType.Warning);
                    } else {
                        

                        var newPR = {
                            Id: selected.Id,
                            ProductCode: selected.ProductCode,
                            ProductDescription: selected.ProductDescription,
                            CountryCode: selected.CountryCode,
                            Flow: selected.Flow,
                            TariffCode: selected.TariffCode,
                            Restriction: selected.Restriction,
                            RestrictionQuotaTypeId: selected.RestrictionQuotaTypeId,
                            RestrictionQuotaTypeDesc: selected.RestrictionQuotaTypeDesc,
                            IsProhibited: true,
                            IsException: false,
                            IsQuotaAllocated: false,

                            QuotaRequiredValue: selected.QuotaRequiredValue,
                            QuotaCurrency: selected.QuotaCurrency,
                            QuotaRequiredAmount: selected.QuotaRequiredAmount,
                            QuotaUnitOfMeasure: selected.QuotaUnitOfMeasure,

                            Comments: selected.Comments,

                            RestrictionPermitId: 0,
                            Permit: null,
                            IsQuota: selected.IsQuota,
                            QuotaAllocatedValue: 0,
                            QuotaAllocatedAmount: 0,
                            RestrictionPermitActive: true
                        };

                        (<Array<any>>(this.gvwPRList.data)).splice(0, 0, newPR);
                    }

                } else {
                    this.generalService.displayMessage("Please select a P&R Line", Enum.EnumMessageType.Warning);
                }
            }

            removePermit() {
                if (this.apiPRList && this.apiPRList.selection.getSelectedRows().length > 0) {

                    var selected: interfaces.consignment.IConsignmentPRDisplay = this.apiPRList.selection.getSelectedRows()[0];
                    selected.RestrictionPermitActive = false;
                    this.apiPRList.rowEdit.setRowsDirty([selected]);

                    this.Save();

                } else {
                    this.generalService.displayMessage("Please select a P&R Line", Enum.EnumMessageType.Warning);
                }
            }

            runQuotaAllocation() {
                this.bsLoadingOverlayService.wrap({
                    referenceId: 'con.update'
                }, () => {
                    return this.SaveConsignment().then(() => {
                        this.consignmentService.RunQuotaAllocation(this.consignment.Id).save({
                            conId: this.consignment.Id,
                        }, (result) => {
                            this.generalService.displayMessageHandler(result);
                            this.$anchorScroll("topAnchor");

                            //if (!result.HasErrorMessage) { //this check has been removed as we always need to refresh the P&R grid after quota allocation
                                this.$timeout(() => {
                                    this.bsLoadingOverlayService.wrap({
                                        referenceId: 'con.update'
                                    }, () => {
                                        return this.loadConsignment();
                                    });
                                });
                            //}
                        }, (failureData) => {
                            this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                            this.$anchorScroll("topAnchor");
                        });
                    }, () => {
                        return;
                    });
                });
            }

            changeLoadingLocationDescription() {
                return this.$uibModal.open({
                    animation: true,
                    size: "md",
                    template: `
                    <div class="modal-header">
                        <h3 class="modal-title" id="modal-title">Edit Loading Location Description</h3>
                    </div>
                    <div class="modal-body" id="modal-body">
                        <p>
                            Change Loading Location Description below:
                        </p>
                        <form name="inputForm">
                            <p class="input-group-sm">
                                <input class="form-control" type="text" ng-model="loadingLocationCtrl.loadingLocationDescription"
                                    aria-label="Loading Location Description">
                            </p>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-primary" type="button" ng-click="loadingLocationCtrl.ok()">Ok</button>
                        <button class="btn btn-info" type="button" ng-click="loadingLocationCtrl.cancel()">Close</button>
                    </div>`,
                    controller: class loadingLocationCtrl {
                        loadingLocationDescription: string;
                        constructor($scope, private $uibModalInstance: angular.ui.bootstrap.IModalInstanceService, loadingLocationDescription: string) {
                            this.loadingLocationDescription = loadingLocationDescription;
                        }

                        ok() {
                            this.$uibModalInstance.close(this.loadingLocationDescription);
                        }

                        cancel() {
                            this.$uibModalInstance.dismiss();
                        }
                    },
                    controllerAs: "loadingLocationCtrl",
                    resolve: {
                        loadingLocationDescription: () => { return this.consignment.LoadingLocation.Description; }
                    }
                }).result.then((loadingLocationDescription) => {
                    this.consignment.LoadingLocation.Description = loadingLocationDescription;
                    this.consignment.LoadingLocation.Display = this.consignment.LoadingLocation.Code + " - " + this.consignment.LoadingLocation.Description;
                });
            }

            changeUnloadingLocationDescription() {
                return this.$uibModal.open({
                    animation: true,
                    size: "md",
                    template: `
                    <div class="modal-header">
                        <h3 class="modal-title" id="modal-title">Edit Unloading Location Description</h3>
                    </div>
                    <div class="modal-body" id="modal-body">
                        <p>
                            Change Unloading Location Description below:
                        </p>
                        <form name="inputForm">
                            <p class="input-group-sm">
                                <input class="form-control" type="text" ng-model="unloadingLocationCtrl.unloadingLocationDescription"
                                    aria-label="Unloading Location Description">
                            </p>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-primary" type="button" ng-click="unloadingLocationCtrl.ok()">Ok</button>
                        <button class="btn btn-info" type="button" ng-click="unloadingLocationCtrl.cancel()">Close</button>
                    </div>`,
                    controller: class unloadingLocationCtrl {
                        unloadingLocationDescription: string;
                        constructor($scope, private $uibModalInstance: angular.ui.bootstrap.IModalInstanceService, unloadingLocationDescription: string) {
                            this.unloadingLocationDescription = unloadingLocationDescription;
                        }

                        ok() {
                            this.$uibModalInstance.close(this.unloadingLocationDescription);
                        }

                        cancel() {
                            this.$uibModalInstance.dismiss();
                        }
                    },
                    controllerAs: "unloadingLocationCtrl",
                    resolve: {
                        unloadingLocationDescription: () => { return this.consignment.UnloadingLocation.Description; }
                    }
                }).result.then((unloadingLocationDescription) => {
                    this.consignment.UnloadingLocation.Description = unloadingLocationDescription;
                    this.consignment.UnloadingLocation.Display = this.consignment.UnloadingLocation.Code + " - " + this.consignment.UnloadingLocation.Description;
                });
            }
            //////////////////////////////////////////////

            createNewVersion(id: number) {
                return this.consignmentService.CreateNewVersion(id).save(
                    (data: interfaces.applicationcore.IMessageHandler) => {
                        this.generalService.displayMessageHandler(data);

                        if (!data.HasErrorMessage) {
                            this.$timeout(() => {
                                this.bsLoadingOverlayService.wrap({
                                    referenceId: 'con.update'
                                }, () => {
                                    return this.loadConsignment();
                                });
                            });
                        }

                    }, (failureData) => {
                        this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                    }).$promise;
            }

            generateUCR(ucrType: number) {
                this.bsLoadingOverlayService.wrap({
                    referenceId: 'con.update'
                }, () => {
                        return this.SaveConsignment().then(() => {
                            this.consignmentService.GenerateUCR(this.consignment.Id, ucrType).save({
                        }, (result) => {
                            this.generalService.displayMessageHandler(result);
                            this.$anchorScroll("topAnchor");

                            if (!result.HasErrorMessage) {
                                this.$timeout(() => {
                                    this.bsLoadingOverlayService.wrap({
                                        referenceId: 'con.update'
                                    }, () => {
                                        return this.loadConsignment();
                                    });
                                });
                            }
                        }, (failureData) => {
                            this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                            this.$anchorScroll("topAnchor");
                        });
                    }, () => {
                        return;
                    });
                });
            }

            Save() {
                this.bsLoadingOverlayService.wrap({
                    referenceId: 'con.update'
                }, () => {
                    return this.SaveConsignment().then((result) => {
                        this.generalService.displayMessageHandler(result);
                        if (!result.HasErrorMessage) {
                            this.$timeout(() => {
                                this.bsLoadingOverlayService.wrap({
                                    referenceId: 'con.update'
                                }, () => {
                                    return this.loadConsignment();
                                });
                            });
                        }
                    });
                });
            }

            
            ViewOrder(orderId:number){
                var url = "";
                if (this.isInbound){
                    url = '#!/PurchaseOrders/Update/'+orderId;
                }
                else{                    
                    url = '#!/SalesOrders/SalesOrders/Update/'+orderId;
                }

                window.open(url, '_blank');
            }

            SaveClose() {
                this.bsLoadingOverlayService.wrap({
                    referenceId: 'con.update'
                }, () => {
                    return this.SaveConsignment().then(() => {
                        this.Close();
                    }, (failureData) => {
                        this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                        this.$anchorScroll("topAnchor");
                    });
                });
            }

            Close() {
                this.$state.go("^");
            }

            GetExportConsignmentXML() {
                this.generalService.displayYesNoConfirmation("Confirm", "Embed Document Repository files within the XML? This may result in a large download.").then((embedDocs) => {
                    this.consignmentService.GetExportConsignmentXML(this.consignment.WaybillNumber, this.consignment.Id,embedDocs);
                }, () => {

                });
            }

            GetPOWizardDetailExcel(){
                this.consignmentService.GetPOWizardDetailExcel(this.consignment.WaybillNumber, this.consignment.Id);
            }

            ConsignmentNumberOverride(){
                this.$uibModal.open({
                    animation: true,
                    size: "md",
                    template: `
                        <div class="modal-header" style="white-space: nowrap;">
                            <h3 class="modal-title" id="modal-title">Override Consignment Number <i class="fa fa-question-circle" uib-tooltip='Use this option to override the current Consignment Number.' tooltip-placement="bottom"></i></h3>
                        </div>
                        <div bs-loading-overlay bs-loading-overlay-reference-id="con.overridenumber">
                            <form name="cominvexcelupload">
                                <div class="gts-padding">
                                    <gts-message-display messages="ConsignmentNumberOverrideCtrl.messages"></gts-message-display>
                                    <div class="modal-body" id="modal-body">
                                        <div class="row">
				                            <div class="row vertical-align">
					                            <div class="col-md-4">
                                                    <req></req>
						                            <label>Consignment Number</label>
					                            </div>
					                            <div class="col-md-8">
                                                    <form name="inputForm">
                                                        <p class="input-group input-group-sm has-feedback" >
                                                            <input   type="text" name="DiscountPercentage" ng-model="ConsignmentNumberOverrideCtrl.consignmentNumber" class="form-control" maxlength="30" />                                                   
                                                        </p>
                                                    </form>
					                            </div>
				                            </div>
			                            </div>                                          
                                    </div>
                                    <div class="modal-footer"> 
                                        <button class="btn btn-primary" type="button"  ng-disabled="ConsignmentNumberOverrideCtrl.disableSubmit || !ConsignmentNumberOverrideCtrl.consignmentNumber" ng-click="ConsignmentNumberOverrideCtrl.ConsignmentNumberOverride()">Submit</button>
                                        <button class="btn btn-info" type="button"  ng-click="ConsignmentNumberOverrideCtrl.cancel()">Cancel</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        `,
                    controller: class ConsignmentNumberOverrideCtrl {

                        messages: interfaces.applicationcore.IMessage[] = [];
                        disableSubmit: boolean = false;
                        consignmentNumber:string;
                      
                        constructor($scope, private $uibModalInstance: angular.ui.bootstrap.IModalInstanceService,
                            private consignmentService: interfaces.consignment.IConsignmentService,
                            public generalService: interfaces.applicationcore.IGeneralService,
                            private $rootScope: interfaces.applicationcore.IRootScope,
                            private $state: ng.ui.IStateService,
                            public bsLoadingOverlayService,
                            public ENV: interfaces.applicationcore.serverConfig,
                            private conId : number,
                            private entityId: number
                        ) {

                         
                        }
                 
                        ConsignmentNumberOverride(){

                            this.bsLoadingOverlayService.wrap({
                                referenceId: 'con.overridenumber'
                            },
                                () => {


                                   return this.consignmentService.overrideConsignmentNumber(this.conId, this.consignmentNumber).save({
                                    }, (result : interfaces.applicationcore.IMessageHandler) => {
                                        this.generalService.displayMessageHandler(result);                                        
                                        if (!result.HasErrorMessage) {
                                            this.disableSubmit = false;
                                            this.$uibModalInstance.close(true);
                                        }
            
                                      
                                    }, (failureData) => {
                                        this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                                     
                                    });

                                                 

                                }
                            
                            );
                    
                        }

                        cancel() {
                            this.$uibModalInstance.close(false);
                        }
 
 
                    },
                    controllerAs: "ConsignmentNumberOverrideCtrl",
                    resolve: { conId : this.consignmentID, entityId : this.consignment.OwnerEntityId
                    }
                }).result.then((result) => {
                    if (result) {
                        this.loadConsignment();
                    }
                });
            }

            UploadFromExcel(){
                this.$uibModal.open({
                    animation: true,
                    size: "md",
                    template: `
                        <div class="modal-header" style="white-space: nowrap;">
                            <h3 class="modal-title" id="modal-title">Upload PO Wizard from Excel <i class="fa fa-question-circle" uib-tooltip='Use this option to add, update or remove lines from the invoice using an Excel Spreadsheet. The format of the spreadsheet is the same as the Download to Excel functionality.' tooltip-placement="bottom"></i></h3>
                        </div>
                        <div bs-loading-overlay bs-loading-overlay-reference-id="cominv.excelupload">
                            <form name="cominvexcelupload">
                                <div class="gts-padding">
                                    <gts-message-display messages="Messages"></gts-message-display>
                                    <div class="modal-body" id="modal-body">
                                        <div class="row">
				                            <div class="row vertical-align">
                                            <div class="col-md-6 pull-left">
                                                <button type="button" class="btn btn-info" ng-click="uploadExcelCtrl.varianceAuthorisation_Click()">Variance Authorisation</button>
                                            </div>
				                            </div>
			                            </div> 

                                        <div class="row">
                                            <div class="row vertical-align">
                                                <div class="col-md-8">
                                                    <label class="fileUpload btn btn-primary file-upload-btn-primary" for="docFileToUpload" ng-disabled="uploadExcelCtrl.disableSubmit">
                                                        <span>Select File</span>
                                                        <input name="docFileToUpload" ng-disabled="uploadExcelCtrl.disableSubmit" class="upload" type="file" id="docFileToUpload" ng-model="uploadExcelCtrl.repositoryFile" base-sixty-four-input accept=".xlsx" />
                                                    </label>
                                                    <span>{{uploadExcelCtrl.repositoryFile.filename}}</span>
                                                </div>
                                            </div>
                                        </div>   
                                    </div>
                                    <div class="modal-footer"> 
                                        <button class="btn btn-primary" type="button"  ng-disabled="!uploadExcelCtrl.repositoryFile || uploadExcelCtrl.disableSubmit" ng-click="uploadExcelCtrl.upload()">Submit</button>
                                        <button class="btn btn-info" type="button" ng-disabled="uploadExcelCtrl.disableSubmit" ng-click="uploadExcelCtrl.cancel()">Cancel</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        `,
                    controller: class uploadExcelCtrl {

                        messages: interfaces.applicationcore.IMessage[];


                        disableSubmit: boolean = false;
                        repositoryFile: interfaces.applicationcore.IRepositoryFile;

                        poWizardExcelData: interfaces.consignment.IPOWizardExcelData;

                        varianceAuthUser: interfaces.applicationcore.IDropdownModel;
                        varianceAuthUserId: number = 0; //by default not authorized for variance

                        constructor($scope, private $uibModalInstance: angular.ui.bootstrap.IModalInstanceService,
                            private countryService: interfaces.applicationcore.ICountryService,
                            private entityService: interfaces.applicationcore.IEntityService,
                            public consignmentService: interfaces.consignment.IConsignmentService,
                            public generalService: interfaces.applicationcore.IGeneralService,
                            private $rootScope: interfaces.applicationcore.IRootScope,
                            private $state: ng.ui.IStateService,
                            private refundClaimTypeService: interfaces.tariff.IRefundClaimTypeService,
                            public bsLoadingOverlayService,
                            public commercialInvoiceSkuService: interfaces.logistics.ICommercialInvoiceSkuService,
                            private $uibModal: ng.ui.bootstrap.IModalService,
                            private consignmentId : number
                        ) {
                        
                        }

                        varianceAuthorisation_Click() {

                            this.displayVarianceAuthorisation().then((result) => {
                                if (result) {
                                    this.varianceAuthUser = result;
                                    this.commercialInvoiceSkuService.ValidateUser().save((this.varianceAuthUser), (result: interfaces.applicationcore.IMessageHandler) => {
                                        this.generalService.displayMessageHandler(result);
            
                                        this.varianceAuthUserId = this.varianceAuthUser.Id;
            
                                    }, (failureData) => {
                                        this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                                    });
                                }
                            });
            
                        }
            
            
                        displayVarianceAuthorisation() {
                            //Get delivery status
                            return this.$uibModal.open({
                                animation: true,
                                template: `
                                    <div class="modal-content" >
                                        <form name="varianceAuthorisation">
                                            <div class="gts-padding">
                                                <fieldset id="varianceAuth">
                                                <legend>
                                                    Commercial Invoice Variance Authorisation
                                                </legend>                                            
                                                        <div class="row vertical-align">
                                                            <div class="col-md-4">
                                                                <req></req>
                                                                <label>Username: </label>
                                                            </div>
                                                            <div class="col-md-6">
                                                                <p class="input-group-sm has-feedback" ng-class="{'has-error': users.$invalid}">
                                                                    <gts-dropdown name="users" ng-model="varianceAuthorisationCtrl.user" form="varianceAuthorisation" load-data="varianceAuthorisationCtrl.loadUserList()" required="true"></gts-dropdown>
                                                                </p>
                                                            </div>                                               
                                                        </div>  
                                                        <div class="row vertical-align">
                                                            <div class="col-md-4">
                                                                <req></req>
                                                                <label>Password: </label>
                                                            </div>
                                                            <div class="col-md-6">
                                                                <p class="input-group-sm has-feedback" ng-class="{'has-error': password.$invalid}">
                                                                       <input type="password" name="password" autocomplete="off" ng-model="varianceAuthorisationCtrl.password" form="varianceAuthorisation"  required="true"   class="form-control"/>
                                                                </p>
                                                            </div>                                               
                                                        </div> 
                                                        <div class="gts-padding pull-right">                                               
                                                                <button type="button" class="btn btn-primary" ng-disabled="varianceAuthorisation.$invalid" ng-click="varianceAuthorisationCtrl.ok()">Ok</button>
                                                                <button type="button" class="btn btn-info" ng-click="varianceAuthorisationCtrl.cancel()">Cancel</button>
                                                        </div>                                       
                                                </fieldset>
                                            </div>
                                        </form>
                                    </div>
                                `
                                ,
                                controller: class varianceAuthorisationCtrl {
                                    user: interfaces.applicationcore.IDropdownModel;
                                    password: string;
                                    constructor($scope, private $uibModalInstance: angular.ui.bootstrap.IModalInstanceService, private commercialInvoiceSkuService: interfaces.logistics.ICommercialInvoiceSkuService) {
            
                                    }
            
                                    cancel() {
                                        this.$uibModalInstance.dismiss();
                                    }
            
                                    ok() {
                                        this.user.Code = this.password;
                                        this.$uibModalInstance.close(this.user);
                                    }
            
            
            
                                    //Load Container ISO.
                                    loadUserList() {
                                        return this.commercialInvoiceSkuService.getUserAuthorisationDropdownList().query(
                                            () => {
            
                                            }, (failureData) => {
                                            }).$promise;
                                    }
                                },
                                controllerAs: "varianceAuthorisationCtrl",
                                size: "md",
                                resolve: {
                                }
                            }).result;
                        }

                 

                        cancel() {
                            this.$uibModalInstance.close(false);
                        }

                        upload() {
                            this.disableSubmit = true;
                             this.poWizardExcelData = <interfaces.consignment.IPOWizardExcelData>{
                                consignmentId: this.consignmentId,
                                authorizeVarianceUserId:this.varianceAuthUserId,
                                repositoryFile:this.repositoryFile
                             };

                            this.bsLoadingOverlayService.wrap({
                                referenceId: 'cominv.excelupload'
                            },
                                () => {

                                    this.consignmentService.UploadPOWizardFromExcel().save(this.poWizardExcelData, (result) => {
                                        this.generalService.displayMessageHandler(result);
                                        this.disableSubmit = false;
                                        if (!result.HasErrorMessage) {
                                            this.$uibModalInstance.close(true);
                                        }

                                        //this.$uibModalInstance.close(true);
                                    }, (errorResult) => {
                                        this.generalService.displayMessageHandler(errorResult.data);

                                        if (errorResult.data.Messages) {
                                            this.messages = [];
                                        }

                                        angular.forEach(errorResult.data.Messages, (o) => {
                                            angular.forEach(o.MessageItems, (n) => {
                                                this.messages.push(n);
                                            });
                                        });
                                        }).$promise;

                                });
                        }
                    },
                    controllerAs: "uploadExcelCtrl",
                    resolve: { consignmentId : this.consignmentID
                    }
                }).result.then((result) => {
                    if (result) {
                        this.bsLoadingOverlayService.wrap({
                            referenceId: 'con.update'
                        }, () => {
                            return this.loadConsignment();
                        });
                    }
                });
            }
        }

        angular.module("app").controller("consignmentUpdateCtrl", controllers.consigment.ConsignmentExportUpdateCtrl);
    }
}